import { PERMISSIONS } from './permissions.js';
export const PRODUCT_NEWS_CATEGORIES = ['NEW', 'IMPROVED', 'FIXED'];
/**
 * Curated product history. Entries describe user impact, never implementation details.
 * Sequences are append-only so each user can persist a monotonic read position.
 */
export const PRODUCT_NEWS_ENTRIES = [
    {
        id: 'reliable-mobile-workflows',
        sequence: 1,
        version: '2026.8.0',
        publishedAt: '2026-08-22T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/',
        requiredAnyPermissions: [],
        commitRefs: ['19c8660', 'b8633ea'],
        translations: {
            de: {
                title: 'Zuverlässiger auf Mobilgeräten',
                description: 'Die wichtigsten Arbeitsbereiche passen sich kleinen Bildschirmen an und Fehlermeldungen enthalten eine nachverfolgbare Referenz.',
            },
            en: {
                title: 'More reliable on mobile devices',
                description: 'Key work areas adapt to small screens, and error messages include a traceable reference.',
            },
            tr: {
                title: 'Mobil cihazlarda daha güvenilir',
                description: 'Temel çalışma alanları küçük ekranlara uyum sağlar ve hata iletileri izlenebilir bir referans içerir.',
            },
            fr: {
                title: 'Plus fiable sur les appareils mobiles',
                description: 'Les principaux espaces de travail s’adaptent aux petits écrans et les erreurs comportent une référence traçable.',
            },
            es: {
                title: 'Mayor fiabilidad en dispositivos móviles',
                description: 'Las áreas de trabajo principales se adaptan a pantallas pequeñas y los errores incluyen una referencia rastreable.',
            },
            ru: {
                title: 'Надёжнее на мобильных устройствах',
                description: 'Основные рабочие разделы адаптируются к небольшим экранам, а сообщения об ошибках содержат идентификатор для отслеживания.',
            },
        },
    },
    {
        id: 'business-partners',
        sequence: 2,
        version: '2026.8.0',
        publishedAt: '2026-08-22T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/partners',
        requiredAnyPermissions: [PERMISSIONS.CUSTOMER_READ],
        commitRefs: ['d4f912d'],
        translations: {
            de: {
                title: 'Geschäftspartner ausgebaut',
                description: 'Kunden und Lieferanten lassen sich in einer gemeinsamen, klaren Akte pflegen.',
            },
            en: {
                title: 'Expanded business partners',
                description: 'Customers and suppliers can be maintained in one clear shared record.',
            },
            tr: {
                title: 'İş ortakları genişletildi',
                description: 'Müşteriler ve tedarikçiler ortak ve anlaşılır bir kayıtta yönetilebilir.',
            },
            fr: {
                title: 'Partenaires enrichis',
                description: 'Clients et fournisseurs sont gérés dans une fiche commune et claire.',
            },
            es: {
                title: 'Gestión ampliada de socios comerciales',
                description: 'Clientes y proveedores se gestionan en una ficha común y clara.',
            },
            ru: {
                title: 'Расширено ведение партнёров',
                description: 'Клиенты и поставщики ведутся в единой понятной карточке.',
            },
        },
    },
    {
        id: 'connected-purchasing',
        sequence: 3,
        version: '2026.8.0',
        publishedAt: '2026-08-22T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/procurement/orders',
        requiredAnyPermissions: [PERMISSIONS.PURCHASE_READ],
        commitRefs: ['79aafc1'],
        translations: {
            de: {
                title: 'Durchgängiger Einkaufsprozess',
                description: 'Bestellungen, Wareneingänge und Rechnungsabgleich greifen in einem nachvollziehbaren Ablauf ineinander.',
            },
            en: {
                title: 'Connected purchasing process',
                description: 'Purchase orders, goods receipts and invoice matching work together in one traceable flow.',
            },
            tr: {
                title: 'Uçtan uca satın alma süreci',
                description: 'Siparişler, mal kabulleri ve fatura eşleştirmesi izlenebilir tek bir akışta birlikte çalışır.',
            },
            fr: {
                title: 'Processus d’achat intégré',
                description: 'Commandes, réceptions et rapprochement des factures s’enchaînent dans un flux traçable.',
            },
            es: {
                title: 'Proceso de compras conectado',
                description: 'Pedidos, recepciones y conciliación de facturas funcionan en un único flujo trazable.',
            },
            ru: {
                title: 'Сквозной процесс закупок',
                description: 'Заказы, приёмка и сверка счетов объединены в единый прослеживаемый процесс.',
            },
        },
    },
    {
        id: 'secure-document-management',
        sequence: 4,
        version: '2026.8.0',
        publishedAt: '2026-08-23T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/dms',
        requiredAnyPermissions: [PERMISSIONS.DMS_READ],
        commitRefs: ['26b9e4b'],
        translations: {
            de: {
                title: 'Zentrale Dokumentenablage',
                description: 'Dateien können sicher abgelegt, mit Fachobjekten verknüpft und anhand ihrer Metadaten wiedergefunden werden.',
            },
            en: {
                title: 'Central document repository',
                description: 'Files can be stored securely, linked to business records and found again using their metadata.',
            },
            tr: {
                title: 'Merkezi belge arşivi',
                description: 'Dosyalar güvenle saklanabilir, iş kayıtlarına bağlanabilir ve üst verileriyle yeniden bulunabilir.',
            },
            fr: {
                title: 'Référentiel documentaire central',
                description: 'Les fichiers sont stockés en sécurité, reliés aux objets métier et retrouvés grâce à leurs métadonnées.',
            },
            es: {
                title: 'Repositorio documental central',
                description: 'Los archivos se guardan de forma segura, se vinculan a registros empresariales y se localizan mediante sus metadatos.',
            },
            ru: {
                title: 'Централизованное хранилище документов',
                description: 'Файлы безопасно хранятся, связываются с объектами учёта и находятся по метаданным.',
            },
        },
    },
    {
        id: 'field-questionnaires',
        sequence: 5,
        version: '2026.8.0',
        publishedAt: '2026-08-24T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/field',
        requiredAnyPermissions: [
            PERMISSIONS.QUESTIONNAIRE_USE,
            PERMISSIONS.QUESTIONNAIRE_VIEW_OWN_RUNS,
            PERMISSIONS.QUESTIONNAIRE_VIEW_ALL_RUNS,
        ],
        commitRefs: ['22d9cee', '9c6eb80'],
        translations: {
            de: {
                title: 'Fragebögen für den Außendienst',
                description: 'Mehrsprachige Fragebögen führen durch Termine, bewahren Eingaben zuverlässig und verknüpfen Ergebnisse mit Geschäftspartnern.',
            },
            en: {
                title: 'Questionnaires for field service',
                description: 'Multilingual questionnaires guide appointments, preserve entries reliably and link results to business partners.',
            },
            tr: {
                title: 'Saha hizmetleri için anketler',
                description: 'Çok dilli anketler ziyaretleri yönlendirir, girişleri güvenle korur ve sonuçları iş ortaklarına bağlar.',
            },
            fr: {
                title: 'Questionnaires pour le service terrain',
                description: 'Des questionnaires multilingues guident les rendez-vous, conservent les saisies et relient les résultats aux partenaires.',
            },
            es: {
                title: 'Cuestionarios para el servicio de campo',
                description: 'Los cuestionarios multilingües guían las visitas, conservan las respuestas y vinculan los resultados con socios comerciales.',
            },
            ru: {
                title: 'Опросники для выездной работы',
                description: 'Многоязычные опросники сопровождают встречи, надёжно сохраняют ввод и связывают результаты с партнёрами.',
            },
        },
    },
    {
        id: 'production-planning-traceability',
        sequence: 6,
        version: '2026.8.0',
        publishedAt: '2026-08-27T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/manufacturing/production-orders',
        requiredAnyPermissions: [
            PERMISSIONS.MANUFACTURING_READ,
            PERMISSIONS.TRACEABILITY_READ,
            PERMISSIONS.MRP_READ,
        ],
        commitRefs: ['31e9cbb', '80e4645', '222455c'],
        translations: {
            de: {
                title: 'Produktion, Rückverfolgung und Materialplanung',
                description: 'Fertigungsaufträge, Chargenherkunft und Materialbedarfe greifen in einem kontrollierten Ablauf ineinander.',
            },
            en: {
                title: 'Production, traceability and material planning',
                description: 'Production orders, lot genealogy and material requirements now work together in one controlled flow.',
            },
            tr: {
                title: 'Üretim, izlenebilirlik ve malzeme planlama',
                description: 'Üretim emirleri, parti geçmişi ve malzeme ihtiyaçları kontrollü tek bir akışta birlikte çalışır.',
            },
            fr: {
                title: 'Production, traçabilité et planification matière',
                description: 'Ordres de fabrication, généalogie des lots et besoins matière s’enchaînent dans un flux contrôlé.',
            },
            es: {
                title: 'Producción, trazabilidad y planificación de materiales',
                description: 'Órdenes de producción, genealogía de lotes y necesidades de material trabajan en un flujo controlado.',
            },
            ru: {
                title: 'Производство, прослеживаемость и планирование материалов',
                description: 'Производственные заказы, происхождение партий и потребности в материалах объединены в контролируемый процесс.',
            },
        },
    },
    {
        id: 'product-development-workflows',
        sequence: 7,
        version: '2026.8.0',
        publishedAt: '2026-08-27T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/product-development',
        requiredAnyPermissions: [
            PERMISSIONS.PRODUCT_DEVELOPMENT_READ,
            PERMISSIONS.PRODUCT_SPECIFICATION_READ,
            PERMISSIONS.RECIPE_READ,
            PERMISSIONS.LABEL_READ,
            PERMISSIONS.CHANGE_CONTROL_READ,
        ],
        commitRefs: ['fa1c38d', '3d1b862', 'be05614', 'b8fc0fd'],
        translations: {
            de: {
                title: 'Durchgängige Produktentwicklung',
                description: 'Rezepturen, Spezifikationen, Etiketten und Änderungsfreigaben sind versioniert und fachlich miteinander verbunden.',
            },
            en: {
                title: 'Connected product development',
                description: 'Recipes, specifications, labels and change approvals are versioned and linked across the business process.',
            },
            tr: {
                title: 'Uçtan uca ürün geliştirme',
                description: 'Reçeteler, spesifikasyonlar, etiketler ve değişiklik onayları sürümlenir ve süreç boyunca birbirine bağlanır.',
            },
            fr: {
                title: 'Développement produit intégré',
                description: 'Recettes, spécifications, étiquettes et validations de changement sont versionnées et reliées dans le processus métier.',
            },
            es: {
                title: 'Desarrollo de producto conectado',
                description: 'Recetas, especificaciones, etiquetas y aprobaciones de cambios están versionadas y vinculadas en el proceso empresarial.',
            },
            ru: {
                title: 'Сквозная разработка продукции',
                description: 'Рецептуры, спецификации, этикетки и согласование изменений версионируются и связаны в едином процессе.',
            },
        },
    },
    {
        id: 'russian-language',
        sequence: 8,
        version: '2026.8.0',
        publishedAt: '2026-08-29T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/settings/profile',
        requiredAnyPermissions: [],
        commitRefs: ['b207b5c'],
        translations: {
            de: {
                title: 'Russisch als weitere ERP-Sprache',
                description: 'Oberfläche und Hilfe stehen nun auch vollständig auf Russisch bereit.',
            },
            en: {
                title: 'Russian added as an ERP language',
                description: 'The interface and help are now fully available in Russian.',
            },
            tr: {
                title: 'ERP’ye Rusça dil desteği eklendi',
                description: 'Arayüz ve yardım artık eksiksiz olarak Rusça da kullanılabilir.',
            },
            fr: {
                title: 'Le russe rejoint les langues de l’ERP',
                description: 'L’interface et l’aide sont désormais entièrement disponibles en russe.',
            },
            es: {
                title: 'Ruso añadido como idioma del ERP',
                description: 'La interfaz y la ayuda ya están disponibles completamente en ruso.',
            },
            ru: {
                title: 'Русский язык добавлен в ERP',
                description: 'Интерфейс и справка теперь полностью доступны на русском языке.',
            },
        },
    },
    {
        id: 'global-power-search',
        sequence: 9,
        version: '2026.8.1',
        publishedAt: '2026-08-30T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/?openSearch=1',
        requiredAnyPermissions: [PERMISSIONS.GLOBAL_SEARCH_USE],
        commitRefs: ['3b871b3'],
        translations: {
            de: {
                title: 'Globale Power-Suche',
                description: 'Mit Strg oder Cmd + K finden Sie berechtigte Kunden, Artikel, Vorgänge, Dokumente und weitere Datensätze zentral und fehlertolerant.',
            },
            en: {
                title: 'Global power search',
                description: 'Use Ctrl or Cmd + K to find permitted customers, products, transactions, documents and other records centrally, even with minor typos.',
            },
            tr: {
                title: 'Genel güçlü arama',
                description: 'Ctrl veya Cmd + K ile yetkili olduğunuz müşteri, ürün, işlem, belge ve diğer kayıtları küçük yazım hatalarına rağmen bulun.',
            },
            fr: {
                title: 'Recherche globale puissante',
                description: 'Avec Ctrl ou Cmd + K, retrouvez les clients, articles, opérations et documents autorisés, même avec de petites fautes.',
            },
            es: {
                title: 'Búsqueda global avanzada',
                description: 'Con Ctrl o Cmd + K puede encontrar clientes, artículos, operaciones y documentos permitidos incluso con pequeños errores.',
            },
            ru: {
                title: 'Глобальный интеллектуальный поиск',
                description: 'С помощью Ctrl или Cmd + K находите доступных клиентов, товары, операции и документы даже при небольших опечатках.',
            },
        },
    },
    {
        id: 'vat-id-validation',
        sequence: 10,
        version: '2026.8.1',
        publishedAt: '2026-08-30T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/partners/customers',
        requiredAnyPermissions: [PERMISSIONS.VAT_VALIDATION_READ],
        commitRefs: ['bf00177'],
        translations: {
            de: {
                title: 'Nachweisbare USt-ID-Prüfung',
                description: 'USt-IDs von Kunden und Lieferanten lassen sich über VIES prüfen; Ergebnis, Zeitpunkt und mögliche Stammdatenabweichungen bleiben nachvollziehbar.',
            },
            en: {
                title: 'Traceable VAT ID validation',
                description: 'Customer and supplier VAT IDs can be checked through VIES, with the result, time and possible master-data differences retained.',
            },
            tr: {
                title: 'İzlenebilir KDV kimlik doğrulaması',
                description: 'Müşteri ve tedarikçi KDV numaraları VIES üzerinden doğrulanır; sonuç, zaman ve olası ana veri farkları kaydedilir.',
            },
            fr: {
                title: 'Validation traçable des numéros de TVA',
                description: 'Les numéros de TVA des clients et fournisseurs sont contrôlés via VIES, avec conservation du résultat, de la date et des écarts.',
            },
            es: {
                title: 'Validación trazable del NIF-IVA',
                description: 'Los NIF-IVA de clientes y proveedores se validan mediante VIES, conservando resultado, fecha y posibles diferencias de datos.',
            },
            ru: {
                title: 'Прослеживаемая проверка номера НДС',
                description: 'Номера НДС клиентов и поставщиков проверяются через VIES с сохранением результата, времени и расхождений в реквизитах.',
            },
        },
    },
    {
        id: 'clearer-navigation',
        sequence: 11,
        version: '2026.8.1',
        publishedAt: '2026-08-30T00:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/',
        requiredAnyPermissions: [],
        commitRefs: ['f57e354'],
        translations: {
            de: {
                title: 'Verständlichere Navigation',
                description: 'Die Sidebar ordnet CRM, Verkauf und Auftragsabwicklung, Einkauf, Lager und Finanzen fachlich und zeigt nur verfügbare Bereiche.',
            },
            en: {
                title: 'Clearer navigation',
                description: 'The sidebar groups CRM, sales and order processing, purchasing, inventory and finance, and only shows available areas.',
            },
            tr: {
                title: 'Daha anlaşılır gezinme',
                description: 'Kenar çubuğu CRM, satış ve sipariş işlemleri, satın alma, stok ve finansı işlevsel biçimde gruplar ve yalnızca kullanılabilir alanları gösterir.',
            },
            fr: {
                title: 'Navigation plus claire',
                description: 'La barre latérale regroupe CRM, ventes, traitement des commandes, achats, stocks et finances, et n’affiche que les zones disponibles.',
            },
            es: {
                title: 'Navegación más clara',
                description: 'La barra lateral agrupa CRM, ventas y pedidos, compras, almacén y finanzas, y solo muestra las áreas disponibles.',
            },
            ru: {
                title: 'Более понятная навигация',
                description: 'Боковая панель логично объединяет CRM, продажи, закупки, склад и финансы и показывает только доступные разделы.',
            },
        },
    },
    {
        id: 'multi-stage-dunning',
        sequence: 12,
        version: '2026.8.1',
        publishedAt: '2026-08-30T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/finance/dunning',
        requiredAnyPermissions: [PERMISSIONS.DUNNING_READ],
        commitRefs: ['5d4da4b'],
        translations: {
            de: {
                title: 'Vollständiges mehrstufiges Mahnwesen',
                description: 'Fällige Posten werden zu prüfbaren, idempotenten Mahnläufen mit Gebühren, Zinsen, PDF, Versandnachweis und Kundenhistorie zusammengeführt.',
            },
            en: {
                title: 'Complete multi-stage dunning',
                description: 'Due receivables become reviewable, idempotent dunning runs with fees, interest, PDFs, dispatch evidence and customer history.',
            },
            tr: {
                title: 'Eksiksiz çok aşamalı tahsilat',
                description: 'Vadesi gelen alacaklar; ücret, faiz, PDF, gönderim kanıtı ve müşteri geçmişi içeren, incelenebilir ve tekrara dayanıklı çalışmalarda birleştirilir.',
            },
            fr: {
                title: 'Relance complète à plusieurs niveaux',
                description: 'Les créances échues sont regroupées en campagnes vérifiables et idempotentes avec frais, intérêts, PDF, preuve d’envoi et historique client.',
            },
            es: {
                title: 'Gestión completa de cobros por niveles',
                description: 'Los saldos vencidos se agrupan en ejecuciones revisables e idempotentes con gastos, intereses, PDF, prueba de envío e historial del cliente.',
            },
            ru: {
                title: 'Полный многоэтапный процесс взыскания',
                description: 'Просроченные позиции объединяются в проверяемые идемпотентные запуски с комиссиями, процентами, PDF, подтверждением отправки и историей клиента.',
            },
        },
    },
    {
        id: 'accessible-language-menu',
        sequence: 13,
        version: '2026.8.1',
        publishedAt: '2026-08-30T00:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/settings/profile',
        requiredAnyPermissions: [],
        commitRefs: ['816d563'],
        translations: {
            de: {
                title: 'Neues barrierefreies Sprachmenü',
                description: 'Die Sprache lässt sich im Kopfbereich suchen und ohne Neuladen wechseln; die Auswahl bleibt im Profil gespeichert.',
            },
            en: {
                title: 'New accessible language menu',
                description: 'Languages can be searched and changed from the header without reloading, and the selection remains saved in the profile.',
            },
            tr: {
                title: 'Yeni erişilebilir dil menüsü',
                description: 'Dil, sayfa yenilenmeden üst alandan aranıp değiştirilebilir ve seçim profilde kalıcı olarak saklanır.',
            },
            fr: {
                title: 'Nouveau menu de langue accessible',
                description: 'La langue se recherche et se change depuis l’en-tête sans rechargement, et le choix reste enregistré dans le profil.',
            },
            es: {
                title: 'Nuevo menú de idioma accesible',
                description: 'El idioma se busca y cambia desde la cabecera sin recargar, y la selección queda guardada en el perfil.',
            },
            ru: {
                title: 'Новое доступное меню языка',
                description: 'Язык можно найти и сменить в шапке без перезагрузки, а выбор сохраняется в профиле.',
            },
        },
    },
    {
        id: 'invitation-only-customer-portal',
        sequence: 14,
        version: '2026.8.1',
        publishedAt: '2026-08-30T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/partners/customers',
        requiredAnyPermissions: [PERMISSIONS.PORTAL_ACCESS_MANAGE],
        commitRefs: ['483b848'],
        translations: {
            de: {
                title: 'Sicheres Kundenportal per Einladung',
                description: 'Portalzugänge entstehen ausschließlich per Einmal-Einladung und sind durch getrennte Rollen, Sitzungen, Sperren und optionale Zwei-Faktor-Anmeldung geschützt.',
            },
            en: {
                title: 'Secure invitation-only customer portal',
                description: 'Portal access is created only through one-time invitations and protected by separate roles, sessions, locks and optional two-factor sign-in.',
            },
            tr: {
                title: 'Yalnızca davetle güvenli müşteri portalı',
                description: 'Portal erişimi yalnızca tek kullanımlık davetlerle oluşturulur; ayrı roller, oturumlar, kilitler ve isteğe bağlı iki aşamalı girişle korunur.',
            },
            fr: {
                title: 'Portail client sécurisé sur invitation',
                description: 'L’accès naît uniquement d’une invitation à usage unique et est protégé par des rôles, sessions, blocages et une double authentification optionnelle.',
            },
            es: {
                title: 'Portal de clientes seguro por invitación',
                description: 'El acceso solo se crea mediante invitaciones de un solo uso y se protege con roles, sesiones, bloqueos y doble factor opcional.',
            },
            ru: {
                title: 'Безопасный клиентский портал по приглашениям',
                description: 'Доступ создаётся только одноразовым приглашением и защищён отдельными ролями, сеансами, блокировками и необязательной двухфакторной проверкой.',
            },
        },
    },
    {
        id: 'customer-portal-documents',
        sequence: 15,
        version: '2026.8.1',
        publishedAt: '2026-08-30T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/partners/customers',
        requiredAnyPermissions: [PERMISSIONS.PORTAL_ACCESS_MANAGE, PERMISSIONS.PORTAL_ACTIVITY_READ],
        commitRefs: ['d3c1fd3'],
        translations: {
            de: {
                title: 'Belege und freigegebene Dateien im Kundenportal',
                description: 'Kunden sehen ausschließlich eigene Vorgänge, Zahlstände, Mahnungen und ausdrücklich freigegebene Dateien; Öffnungen und Downloads bleiben nachvollziehbar.',
            },
            en: {
                title: 'Documents and shared files in the customer portal',
                description: 'Customers see only their own transactions, payment status, dunning notices and explicitly shared files, while views and downloads remain traceable.',
            },
            tr: {
                title: 'Müşteri portalında belgeler ve paylaşılan dosyalar',
                description: 'Müşteriler yalnızca kendi işlemlerini, ödeme durumlarını, ihtarlarını ve açıkça paylaşılan dosyaları görür; açma ve indirme işlemleri izlenebilir.',
            },
            fr: {
                title: 'Documents et fichiers partagés dans le portail client',
                description: 'Les clients voient uniquement leurs opérations, paiements, relances et fichiers explicitement partagés; consultations et téléchargements restent traçables.',
            },
            es: {
                title: 'Documentos y archivos compartidos en el portal',
                description: 'Los clientes solo ven sus operaciones, pagos, avisos de cobro y archivos compartidos expresamente; aperturas y descargas quedan registradas.',
            },
            ru: {
                title: 'Документы и общие файлы в клиентском портале',
                description: 'Клиенты видят только свои операции, платежи, напоминания и явно опубликованные файлы; просмотры и скачивания отслеживаются.',
            },
        },
    },
    {
        id: 'customer-specific-portal-orders',
        sequence: 16,
        version: '2026.8.1',
        publishedAt: '2026-08-31T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/sales/orders',
        requiredAnyPermissions: [PERMISSIONS.PORTAL_ORDERS_REVIEW, PERMISSIONS.PORTAL_ACTIVITY_READ],
        commitRefs: ['cd3524c'],
        translations: {
            de: {
                title: 'Kundenspezifische Bestellungen im Portal',
                description: 'Kunden bestellen aus ihrem freigegebenen Sortiment zu zentral berechneten Preisen und geprüfter Verfügbarkeit; doppelte oder manipulierte Übermittlungen werden verhindert.',
            },
            en: {
                title: 'Customer-specific portal ordering',
                description: 'Customers order from their approved assortment using centrally calculated prices and checked availability; duplicate or manipulated submissions are prevented.',
            },
            tr: {
                title: 'Müşteriye özel portal siparişleri',
                description: 'Müşteriler onaylı ürünlerinden merkezi hesaplanan fiyat ve doğrulanmış uygunlukla sipariş verir; yinelenen veya değiştirilmiş gönderimler engellenir.',
            },
            fr: {
                title: 'Commandes personnalisées dans le portail',
                description: 'Les clients commandent dans leur assortiment autorisé avec prix centralisés et disponibilité vérifiée; les envois doublons ou manipulés sont bloqués.',
            },
            es: {
                title: 'Pedidos personalizados en el portal',
                description: 'Los clientes piden de su surtido aprobado con precios centrales y disponibilidad comprobada; se evitan envíos duplicados o manipulados.',
            },
            ru: {
                title: 'Индивидуальные заказы в клиентском портале',
                description: 'Клиенты заказывают из разрешённого ассортимента по централизованным ценам и проверенной доступности; дубли и подмена данных блокируются.',
            },
        },
    },
    {
        id: 'permission-aware-product-news',
        sequence: 17,
        version: '2026.8.1',
        publishedAt: '2026-08-31T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/news',
        requiredAnyPermissions: [],
        commitRefs: ['feat(changelog): add permission-aware multilingual product news'],
        translations: {
            de: {
                title: 'Neuigkeiten passend zu Ihrer Rolle',
                description: 'Der neue Neuigkeiten-Bereich erklärt sichtbare Verbesserungen verständlich, filterbar und nur dann, wenn die betroffene Funktion für Sie verfügbar ist.',
            },
            en: {
                title: 'Product news relevant to your role',
                description: 'The new product news area explains visible improvements clearly, with filters and only when the affected feature is available to you.',
            },
            tr: {
                title: 'Rolünüze uygun ürün haberleri',
                description: 'Yeni haberler alanı görünür iyileştirmeleri anlaşılır ve filtrelenebilir biçimde, yalnızca ilgili özellik size açıksa gösterir.',
            },
            fr: {
                title: 'Actualités adaptées à votre rôle',
                description: 'Le nouvel espace présente clairement les améliorations visibles, avec filtres, uniquement lorsque la fonction concernée vous est accessible.',
            },
            es: {
                title: 'Novedades relevantes para su rol',
                description: 'La nueva área explica mejoras visibles de forma clara y filtrable, solo cuando la función afectada está disponible para usted.',
            },
            ru: {
                title: 'Новости продукта с учётом вашей роли',
                description: 'Новый раздел понятно и с фильтрами показывает видимые улучшения только для доступных вам функций.',
            },
        },
    },
    {
        id: 'reliable-customer-portal-workflows',
        sequence: 18,
        version: '2026.8.1',
        publishedAt: '2026-08-31T01:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/sales/orders',
        requiredAnyPermissions: [PERMISSIONS.PORTAL_ORDERS_REVIEW, PERMISSIONS.PORTAL_ACTIVITY_READ],
        commitRefs: ['fix(customer-portal): preserve tenant context for customer workflows'],
        translations: {
            de: {
                title: 'Portalbestellungen und PDF-Abrufe zuverlässig',
                description: 'Katalog, Warenkorb, Bestellung und geschützte PDFs funktionieren nun auch nach einer frischen Anmeldung zuverlässig im richtigen Kundenbereich.',
            },
            en: {
                title: 'Reliable portal orders and PDF access',
                description: 'Catalog, cart, ordering and protected PDFs now work reliably in the correct customer area, including immediately after signing in.',
            },
            tr: {
                title: 'Güvenilir portal siparişleri ve PDF erişimi',
                description: 'Katalog, sepet, sipariş ve korumalı PDF’ler artık oturum açıldıktan hemen sonra da doğru müşteri alanında güvenilir biçimde çalışır.',
            },
            fr: {
                title: 'Commandes et PDF fiables dans le portail',
                description: 'Catalogue, panier, commande et PDF protégés fonctionnent désormais de façon fiable dans le bon espace client, y compris juste après la connexion.',
            },
            es: {
                title: 'Pedidos y acceso a PDF fiables en el portal',
                description: 'El catálogo, el carrito, los pedidos y los PDF protegidos funcionan ahora de forma fiable en el área de cliente correcta, también justo después de iniciar sesión.',
            },
            ru: {
                title: 'Надёжные заказы и доступ к PDF в портале',
                description: 'Каталог, корзина, оформление заказа и защищённые PDF теперь надёжно работают в нужном разделе клиента, в том числе сразу после входа.',
            },
        },
    },
    {
        id: 'reliable-application-startup',
        sequence: 19,
        version: '2026.8.2',
        publishedAt: '2026-08-31T05:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/',
        requiredAnyPermissions: [],
        commitRefs: ['fix(web): restore application startup on mobile browsers'],
        translations: {
            de: {
                title: 'ERP öffnet sich wieder zuverlässig',
                description: 'Die Anwendung startet wieder zuverlässig auf Smartphones, Tablets und Desktop-Browsern.',
            },
            en: {
                title: 'ERP opens reliably again',
                description: 'The application once again starts reliably on smartphones, tablets and desktop browsers.',
            },
            tr: {
                title: 'ERP yeniden güvenilir biçimde açılıyor',
                description: 'Uygulama akıllı telefonlarda, tabletlerde ve masaüstü tarayıcılarda yeniden güvenilir biçimde başlıyor.',
            },
            fr: {
                title: 'L’ERP s’ouvre à nouveau de manière fiable',
                description: 'L’application démarre à nouveau de manière fiable sur smartphones, tablettes et navigateurs de bureau.',
            },
            es: {
                title: 'El ERP vuelve a abrirse de forma fiable',
                description: 'La aplicación vuelve a iniciarse de forma fiable en móviles, tabletas y navegadores de escritorio.',
            },
            ru: {
                title: 'ERP снова открывается без сбоев',
                description: 'Приложение снова стабильно запускается на смартфонах, планшетах и в настольных браузерах.',
            },
        },
    },
    {
        id: 'consent-aware-newsletter-foundation',
        sequence: 20,
        version: '2026.8.3',
        publishedAt: '2026-08-31T15:30:00.000Z',
        category: 'NEW',
        linkUrl: '/marketing',
        requiredAnyPermissions: [PERMISSIONS.NEWSLETTER_READ],
        commitRefs: ['feat(newsletter): add consent-aware newsletter domain model'],
        translations: {
            de: {
                title: 'Nachvollziehbare Newsletter-Einwilligungen',
                description: 'Marken, mehrsprachige Themen, Empfänger und unveränderliche Einwilligungsnachweise bilden jetzt die kontrollierte Grundlage für Marketingkommunikation.',
            },
            en: {
                title: 'Traceable newsletter consent records',
                description: 'Brands, multilingual topics, recipients and immutable consent evidence now form the controlled foundation for marketing communication.',
            },
            tr: {
                title: 'İzlenebilir bülten rıza kayıtları',
                description: 'Markalar, çok dilli konular, alıcılar ve değiştirilemez rıza kanıtları pazarlama iletişimi için kontrollü temeli oluşturur.',
            },
            fr: {
                title: 'Consentements aux newsletters traçables',
                description: 'Marques, thèmes multilingues, destinataires et preuves immuables forment désormais une base contrôlée pour la communication marketing.',
            },
            es: {
                title: 'Consentimientos de boletín trazables',
                description: 'Marcas, temas multilingües, destinatarios y pruebas inmutables forman ahora una base controlada para la comunicación comercial.',
            },
            ru: {
                title: 'Прослеживаемые согласия на рассылку',
                description: 'Бренды, многоязычные темы, получатели и неизменяемые подтверждения создают контролируемую основу маркетинговых сообщений.',
            },
        },
    },
    {
        id: 'newsletter-double-opt-in-preferences',
        sequence: 21,
        version: '2026.8.4',
        publishedAt: '2026-08-31T17:00:00.000Z',
        category: 'NEW',
        linkUrl: '/marketing',
        requiredAnyPermissions: [PERMISSIONS.NEWSLETTER_READ],
        commitRefs: ['feat(newsletter): implement double opt-in and preference center'],
        translations: {
            de: {
                title: 'Sicherer Double-Opt-in und einfache Einstellungen',
                description: 'Interessierte wählen Newsletter-Themen freiwillig, bestätigen die Anmeldung geschützt und können Themen, Sprache und Abmeldung jederzeit selbst verwalten.',
            },
            en: {
                title: 'Secure double opt-in and simple preferences',
                description: 'People freely choose newsletter topics, securely confirm their subscription and can manage topics, language and unsubscribing at any time.',
            },
            tr: {
                title: 'Güvenli çift onay ve kolay tercihler',
                description: 'İlgilenenler bülten konularını özgürce seçer, aboneliği güvenle onaylar ve konuları, dili ve abonelikten çıkmayı her zaman yönetebilir.',
            },
            fr: {
                title: 'Double opt-in sécurisé et préférences simples',
                description: 'Les personnes choisissent librement les thèmes, confirment leur inscription de façon sécurisée et gèrent à tout moment thèmes, langue et désabonnement.',
            },
            es: {
                title: 'Doble opt-in seguro y preferencias sencillas',
                description: 'Las personas eligen libremente los temas, confirman la suscripción de forma segura y gestionan en todo momento temas, idioma y baja.',
            },
            ru: {
                title: 'Защищённый double opt-in и простые настройки',
                description: 'Пользователи свободно выбирают темы, безопасно подтверждают подписку и в любое время управляют темами, языком и отпиской.',
            },
        },
    },
    {
        id: 'newsletter-existing-customer-suppression',
        sequence: 22,
        version: '2026.8.5',
        publishedAt: '2026-08-31T18:30:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/marketing/existing-customer',
        requiredAnyPermissions: [PERMISSIONS.NEWSLETTER_READ],
        commitRefs: ['feat(newsletter): enforce existing-customer rules and suppression lists'],
        translations: {
            de: {
                title: 'Vorsichtige Bestandskundenprüfung und zentrale Sperrliste',
                description: 'Bestandskundenwerbung bleibt standardmäßig aus und erfordert einen vollständigen Verkaufsnachweis mit unabhängiger Freigabe; Abmeldungen, Widersprüche und weitere Sperren haben immer Vorrang.',
            },
            en: {
                title: 'Cautious existing-customer review and central suppression',
                description: 'Existing-customer marketing remains off by default and requires complete sale evidence plus independent approval; unsubscribes, objections and other suppressions always take priority.',
            },
            tr: {
                title: 'Temkinli mevcut müşteri incelemesi ve merkezi engelleme',
                description: 'Mevcut müşteri reklamı varsayılan olarak kapalıdır ve eksiksiz satış kanıtıyla bağımsız onay gerektirir; abonelikten çıkma, itiraz ve diğer engeller her zaman önceliklidir.',
            },
            fr: {
                title: 'Examen prudent des clients existants et exclusion centrale',
                description: 'Le marketing aux clients existants reste désactivé par défaut et exige une preuve de vente complète avec validation indépendante; désabonnements, oppositions et autres exclusions priment toujours.',
            },
            es: {
                title: 'Revisión prudente de clientes existentes y exclusión central',
                description: 'El marketing a clientes existentes permanece desactivado por defecto y exige prueba completa de la venta y aprobación independiente; bajas, oposiciones y demás exclusiones siempre prevalecen.',
            },
            ru: {
                title: 'Осторожная проверка постоянных клиентов и единые блокировки',
                description: 'Маркетинг для постоянных клиентов по умолчанию выключен и требует полного подтверждения продажи с независимым одобрением; отписки, возражения и другие блокировки всегда имеют приоритет.',
            },
        },
    },
    {
        id: 'newsletter-audiences-and-compliant-import',
        sequence: 23,
        version: '2026.8.6',
        publishedAt: '2026-08-31T20:00:00.000Z',
        category: 'NEW',
        linkUrl: '/marketing/audiences',
        requiredAnyPermissions: [PERMISSIONS.NEWSLETTER_READ],
        commitRefs: ['feat(newsletter): add compliant audience segmentation and recipient import'],
        translations: {
            de: {
                title: 'Versionierte Zielgruppen und kontrollierter Empfängerimport',
                description: 'Dynamische und statische Zielgruppen zeigen Ausschlussgründe transparent; CSV- und Excel-Importe deduplizieren, beachten dauerhafte Sperren und schalten neue Adressen niemals automatisch frei.',
            },
            en: {
                title: 'Versioned audiences and controlled recipient imports',
                description: 'Dynamic and static audiences transparently show exclusion reasons; CSV and Excel imports deduplicate, respect durable suppressions and never activate new addresses automatically.',
            },
            tr: {
                title: 'Sürümlü hedef kitleler ve kontrollü alıcı içe aktarma',
                description: 'Dinamik ve statik hedef kitleler hariç tutma nedenlerini gösterir; CSV ve Excel içe aktarımları tekilleştirir, kalıcı engelleri korur ve yeni adresleri otomatik etkinleştirmez.',
            },
            fr: {
                title: 'Audiences versionnées et import contrôlé des destinataires',
                description: 'Les audiences dynamiques et statiques affichent les motifs d’exclusion ; les imports CSV et Excel dédupliquent, respectent les exclusions durables et n’activent jamais automatiquement les nouvelles adresses.',
            },
            es: {
                title: 'Audiencias versionadas e importación controlada',
                description: 'Las audiencias dinámicas y estáticas muestran los motivos de exclusión; las importaciones CSV y Excel deduplican, respetan bloqueos duraderos y nunca activan automáticamente nuevas direcciones.',
            },
            ru: {
                title: 'Версии аудиторий и контролируемый импорт получателей',
                description: 'Динамические и статические аудитории показывают причины исключения; импорт CSV и Excel устраняет дубли, соблюдает постоянные блокировки и никогда автоматически не активирует новые адреса.',
            },
        },
    },
    {
        id: 'newsletter-multilingual-campaign-editor',
        sequence: 24,
        version: '2026.8.7',
        publishedAt: '2026-08-31T21:30:00.000Z',
        category: 'NEW',
        linkUrl: '/marketing/campaigns',
        requiredAnyPermissions: [PERMISSIONS.NEWSLETTER_READ],
        commitRefs: ['feat(newsletter): implement multilingual campaign and template editor'],
        translations: {
            de: {
                title: 'Mehrsprachiger Newsletter-Editor mit Pflicht-Footer',
                description: 'Versionierte Vorlagen, responsive Inhaltsblöcke, DMS-Bilder, Artikel, sichere Personalisierung und serverseitige Vorschauen unterstützen kontrollierte Kampagnenentwürfe.',
            },
            en: {
                title: 'Multilingual newsletter editor with mandatory footer',
                description: 'Versioned templates, responsive content blocks, DMS images, products, safe personalization and server-side previews support controlled campaign drafts.',
            },
            tr: {
                title: 'Zorunlu altbilgili çok dilli bülten düzenleyici',
                description: 'Sürümlü şablonlar, duyarlı içerik blokları, DMS görselleri, ürünler, güvenli kişiselleştirme ve sunucu önizlemeleri kontrollü kampanya taslaklarını destekler.',
            },
            fr: {
                title: 'Éditeur multilingue avec pied de page obligatoire',
                description: 'Modèles versionnés, blocs adaptatifs, images DMS, produits, personnalisation sûre et aperçus serveur facilitent les brouillons de campagne contrôlés.',
            },
            es: {
                title: 'Editor multilingüe con pie obligatorio',
                description: 'Plantillas versionadas, bloques adaptables, imágenes DMS, productos, personalización segura y vistas del servidor permiten borradores de campaña controlados.',
            },
            ru: {
                title: 'Многоязычный редактор с обязательным подвалом',
                description: 'Версионные шаблоны, адаптивные блоки, изображения DMS, товары, безопасная персонализация и серверный предпросмотр поддерживают контролируемые черновики кампаний.',
            },
        },
    },
    {
        id: 'newsletter-reviewed-campaign-delivery',
        sequence: 25,
        version: '2026.8.8',
        publishedAt: '2026-08-31T22:30:00.000Z',
        category: 'NEW',
        linkUrl: '/marketing/campaigns',
        requiredAnyPermissions: [PERMISSIONS.NEWSLETTER_READ],
        commitRefs: ['feat(newsletter): add reviewed scheduled and idempotent campaign delivery'],
        translations: {
            de: {
                title: 'Geprüfter und ausfallsicherer Kampagnenversand',
                description: 'Vier-Augen-Freigaben, unveränderliche Empfängersnapshots, Zeitzonenplanung, Pausen, kontrollierte Wiederholungen und PostgreSQL-gestützte Queue-Wiederherstellung sichern den Versandablauf ab.',
            },
            en: {
                title: 'Reviewed and resilient campaign delivery',
                description: 'Four-eyes approvals, immutable recipient snapshots, timezone scheduling, pausing, controlled retries and PostgreSQL-backed queue recovery protect the delivery workflow.',
            },
            tr: {
                title: 'İncelenen ve dayanıklı kampanya gönderimi',
                description: 'Dört göz onayı, değişmez alıcı anlık görüntüleri, saat dilimi planlaması, duraklatma, kontrollü yeniden denemeler ve PostgreSQL tabanlı kuyruk kurtarma gönderim akışını korur.',
            },
            fr: {
                title: 'Envoi de campagnes contrôlé et résilient',
                description: 'La validation à quatre yeux, les instantanés immuables, la planification par fuseau, la pause, les reprises contrôlées et la restauration de file fondée sur PostgreSQL sécurisent l’envoi.',
            },
            es: {
                title: 'Envío de campañas revisado y resiliente',
                description: 'La aprobación por cuatro ojos, las instantáneas inmutables, la planificación por zona horaria, las pausas, los reintentos controlados y la recuperación mediante PostgreSQL protegen el envío.',
            },
            ru: {
                title: 'Проверенная и отказоустойчивая отправка кампаний',
                description: 'Контроль четырёх глаз, неизменяемые снимки получателей, планирование по часовым поясам, паузы, управляемые повторы и восстановление очереди через PostgreSQL защищают процесс отправки.',
            },
        },
    },
    {
        id: 'newsletter-deliverability-feedback-management',
        sequence: 26,
        version: '2026.8.9',
        publishedAt: '2026-08-31T23:15:00.000Z',
        category: 'NEW',
        linkUrl: '/marketing/deliverability',
        requiredAnyPermissions: [PERMISSIONS.NEWSLETTER_READ],
        commitRefs: ['feat(newsletter): implement deliverability bounce and complaint management'],
        translations: {
            de: {
                title: 'Geprüfte Versanddomains und automatische Bounce-Sperren',
                description: 'SPF, DKIM, DMARC, getrennte Marketing-Subdomains, signierte Provider-Rückmeldungen und RFC-8058-One-Click-Abmeldungen schützen Zustellbarkeit und Empfängerpräferenzen.',
            },
            en: {
                title: 'Verified sending domains and automatic bounce suppression',
                description: 'SPF, DKIM, DMARC, separate marketing subdomains, signed provider feedback and RFC 8058 one-click unsubscribes protect deliverability and recipient preferences.',
            },
            tr: {
                title: 'Doğrulanmış gönderim alan adları ve otomatik geri dönme engeli',
                description: 'SPF, DKIM, DMARC, ayrı pazarlama alt alan adları, imzalı sağlayıcı bildirimleri ve RFC 8058 tek tıklamayla abonelikten çıkma, teslim edilebilirliği ve alıcı tercihlerini korur.',
            },
            fr: {
                title: 'Domaines vérifiés et exclusion automatique des rebonds',
                description: 'SPF, DKIM, DMARC, sous-domaines marketing séparés, retours fournisseur signés et désabonnement en un clic RFC 8058 protègent la délivrabilité et les préférences.',
            },
            es: {
                title: 'Dominios verificados y bloqueo automático de rebotes',
                description: 'SPF, DKIM, DMARC, subdominios de marketing separados, respuestas firmadas del proveedor y baja en un clic RFC 8058 protegen la entregabilidad y las preferencias.',
            },
            ru: {
                title: 'Проверенные домены и автоматическая блокировка возвратов',
                description: 'SPF, DKIM, DMARC, отдельные маркетинговые поддомены, подписанные события провайдера и отписка RFC 8058 защищают доставляемость и выбор получателя.',
            },
        },
    },
    {
        id: 'newsletter-privacy-first-analytics',
        sequence: 27,
        version: '2026.8.10',
        publishedAt: '2026-08-31T23:45:00.000Z',
        category: 'NEW',
        linkUrl: '/marketing/analytics',
        requiredAnyPermissions: [PERMISSIONS.NEWSLETTER_READ],
        commitRefs: ['feat(newsletter): add privacy-first campaign analytics'],
        translations: {
            de: {
                title: 'Datenschutzfreundliche Newsletter-Auswertungen',
                description: 'Aggregierte Versandwerte stehen ohne personenbezogenes Tracking bereit. Öffnungen und Klicks bleiben standardmäßig aus und benötigen getrennte Freigaben sowie eine finale Empfängerprüfung.',
            },
            en: {
                title: 'Privacy-friendly newsletter analytics',
                description: 'Aggregated delivery metrics are available without personal tracking. Opens and clicks remain off by default and require separate approvals plus a final recipient check.',
            },
            tr: {
                title: 'Gizlilik dostu bülten analizleri',
                description: 'Toplu gönderim değerleri kişisel takip olmadan sunulur. Açılma ve tıklamalar varsayılan olarak kapalıdır; ayrı onaylar ve son alıcı kontrolü gerekir.',
            },
            fr: {
                title: 'Analyses de newsletter respectueuses de la vie privée',
                description: 'Les mesures d’envoi agrégées restent disponibles sans suivi personnel. Ouvertures et clics sont désactivés par défaut et exigent des validations distinctes et un contrôle final.',
            },
            es: {
                title: 'Analítica de boletines respetuosa con la privacidad',
                description: 'Las métricas agregadas están disponibles sin seguimiento personal. Aperturas y clics siguen desactivados por defecto y requieren aprobaciones separadas y comprobación final.',
            },
            ru: {
                title: 'Аналитика рассылок с учётом конфиденциальности',
                description: 'Агрегированные показатели доступны без персонального отслеживания. Открытия и переходы по умолчанию выключены и требуют отдельных согласований и финальной проверки.',
            },
        },
    },
    {
        id: 'newsletter-crm-administration-and-help',
        sequence: 28,
        version: '2026.9.1',
        publishedAt: '2026-09-01T01:30:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/marketing/settings',
        requiredAnyPermissions: [PERMISSIONS.NEWSLETTER_READ],
        commitRefs: ['docs(newsletter): integrate administration help and compliance documentation'],
        translations: {
            de: {
                title: 'Newsletter-Verwaltung direkt in CRM und Administration',
                description: 'Kundenakten zeigen Status, Themen, Nachweise, Kampagnen und Zustellereignisse; zentrale Einstellungen, strukturierte Datenschutzexporte und mehrsprachige Hilfe vervollständigen die Verwaltung.',
            },
            en: {
                title: 'Newsletter management in CRM and administration',
                description: 'Customer records show status, topics, evidence, campaigns and delivery events; central settings, structured privacy exports and multilingual help complete administration.',
            },
            tr: {
                title: 'CRM ve yönetimde bülten yönetimi',
                description: 'Müşteri kayıtları durum, konular, kanıtlar, kampanyalar ve teslimat olaylarını gösterir; merkezi ayarlar, yapılandırılmış gizlilik dışa aktarımları ve çok dilli yardım yönetimi tamamlar.',
            },
            fr: {
                title: 'Gestion des newsletters dans le CRM et l’administration',
                description: 'Les fiches client affichent statut, thèmes, preuves, campagnes et événements de livraison ; réglages centraux, exports structurés et aide multilingue complètent la gestion.',
            },
            es: {
                title: 'Gestión de boletines en CRM y administración',
                description: 'Las fichas de cliente muestran estado, temas, pruebas, campañas y eventos de entrega; los ajustes centrales, exportaciones estructuradas y ayuda multilingüe completan la gestión.',
            },
            ru: {
                title: 'Управление рассылками в CRM и администрировании',
                description: 'Карточки клиентов показывают статус, темы, доказательства, кампании и события доставки; централизованные настройки, структурированный экспорт и многоязычная справка завершают управление.',
            },
        },
    },
    {
        id: 'structured-multilingual-custom-field-categories',
        sequence: 29,
        version: '2026.9.2',
        publishedAt: '2026-09-01T08:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/admin/custom-fields',
        requiredAnyPermissions: [PERMISSIONS.CUSTOM_FIELDS_READ],
        commitRefs: ['feat(custom-fields): add structured multilingual field categories and scopes'],
        translations: {
            de: {
                title: 'Mehrsprachige Kategorien für Zusatzfelder',
                description: 'Zusatzfelder erhalten klar definierte Kategorien, Entitäts- und Partnerrollen-Gültigkeit sowie vertrauliche Lese- und Schreibrechte, ohne vorhandene Werte zu verändern.',
            },
            en: {
                title: 'Multilingual categories for custom fields',
                description: 'Custom fields now have explicit categories, entity and partner-role scopes, and confidential read and write permissions without changing existing values.',
            },
            fr: {
                title: 'Catégories multilingues pour les champs personnalisés',
                description: 'Les champs disposent de catégories, de périmètres par entité et rôle partenaire et de droits confidentiels explicites sans modifier les valeurs existantes.',
            },
            es: {
                title: 'Categorías multilingües para campos personalizados',
                description: 'Los campos incorporan categorías, ámbitos por entidad y rol de socio y permisos confidenciales explícitos sin modificar los valores existentes.',
            },
            ru: {
                title: 'Многоязычные категории пользовательских полей',
                description: 'Поля получили явные категории, области по сущностям и ролям партнёров, а также права на конфиденциальные данные без изменения существующих значений.',
            },
            tr: {
                title: 'Özel alanlar için çok dilli kategoriler',
                description: 'Özel alanlara mevcut değerler değişmeden açık kategoriler, varlık ve iş ortağı rol kapsamları ile gizli okuma ve yazma yetkileri eklendi.',
            },
        },
    },
    {
        id: 'category-custom-field-builder',
        sequence: 30,
        version: '2026.9.3',
        publishedAt: '2026-09-01T10:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/admin/custom-fields',
        requiredAnyPermissions: [PERMISSIONS.CUSTOM_FIELDS_READ],
        commitRefs: ['feat(custom-fields): implement category-based custom field builder'],
        translations: {
            de: {
                title: 'Geführter Builder für Zusatzfelder',
                description: 'Kategorien und Felder lassen sich per Drag-and-drop ordnen, in allen ERP-Sprachen pflegen, mit Rechten schützen und vor der Archivierung anhand realer Nutzungszahlen prüfen.',
            },
            en: {
                title: 'Guided custom-field builder',
                description: 'Categories and fields can be arranged by drag and drop, maintained in every ERP language, protected with permissions, and reviewed against real usage before archiving.',
            },
            fr: {
                title: 'Assistant de création de champs personnalisés',
                description: 'Catégories et champs se réorganisent par glisser-déposer, se traduisent dans toutes les langues ERP et affichent leur usage réel avant archivage.',
            },
            es: {
                title: 'Constructor guiado de campos personalizados',
                description: 'Categorías y campos se ordenan mediante arrastrar y soltar, se traducen a todos los idiomas y muestran su uso real antes de archivarse.',
            },
            ru: {
                title: 'Управляемый конструктор пользовательских полей',
                description: 'Категории и поля сортируются перетаскиванием, переводятся на все языки ERP, защищаются правами и показывают фактическое использование перед архивированием.',
            },
            tr: {
                title: 'Yönlendirmeli özel alan oluşturucu',
                description: 'Kategoriler ve alanlar sürükle-bırak ile sıralanır, tüm ERP dillerinde tanımlanır, izinlerle korunur ve arşivlemeden önce gerçek kullanım gösterilir.',
            },
        },
    },
    {
        id: 'embedded-master-data-custom-fields',
        sequence: 31,
        version: '2026.9.4',
        publishedAt: '2026-09-01T12:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/partners',
        requiredAnyPermissions: [PERMISSIONS.CUSTOM_FIELDS_READ],
        commitRefs: ['feat(master-data): embed categorized custom fields in master data'],
        translations: {
            de: {
                title: 'Zusatzfelder direkt in den Stammdaten',
                description: 'Kategorien stehen nun ohne eigenen Tab bei Partnern, Artikeln, Kontakten, Adressen, Verpackungen und Chargen bereit – einschließlich persönlichem Öffnungszustand und sicheren Listenfiltern.',
            },
            en: {
                title: 'Custom fields directly in master data',
                description: 'Categories now appear without a separate tab for partners, products, contacts, addresses, packaging and batches, including personal expansion state and secure list filters.',
            },
            fr: {
                title: 'Champs personnalisés dans les données de base',
                description: 'Les catégories figurent sans onglet séparé pour partenaires, articles, contacts, adresses, conditionnements et lots, avec état d’ouverture personnel et filtres sécurisés.',
            },
            es: {
                title: 'Campos personalizados en los datos maestros',
                description: 'Las categorías aparecen sin pestaña separada en socios, artículos, contactos, direcciones, embalajes y lotes, con apertura personal y filtros seguros.',
            },
            ru: {
                title: 'Дополнительные поля прямо в основных данных',
                description: 'Категории доступны без отдельной вкладки для партнёров, товаров, контактов, адресов, упаковок и партий, с личным раскрытием и безопасными фильтрами.',
            },
            tr: {
                title: 'Özel alanlar doğrudan ana verilerde',
                description: 'Kategoriler iş ortağı, ürün, kişi, adres, ambalaj ve partilerde ayrı sekme olmadan; kişisel açılma durumu ve güvenli filtrelerle sunulur.',
            },
        },
    },
    {
        id: 'actionable-multilingual-custom-field-validation',
        sequence: 32,
        version: '2026.9.5',
        publishedAt: '2026-09-04T04:45:00.000Z',
        category: 'FIXED',
        linkUrl: '/admin/custom-fields',
        requiredAnyPermissions: [PERMISSIONS.CUSTOM_FIELDS_READ],
        commitRefs: ['fix(custom-fields): show actionable multilingual validation errors'],
        translations: {
            de: {
                title: 'Übersetzungsfehler direkt finden',
                description: 'Beim Speichern zeigen Zusatzfelder und Kategorien dauerhaft, welche Sprache und Eingabe noch fehlt; der erste Fehler wird automatisch geöffnet und fokussiert.',
            },
            en: {
                title: 'Find translation errors immediately',
                description: 'When saving, custom fields and categories now keep showing which language and input is missing, then open and focus the first error automatically.',
            },
            tr: {
                title: 'Çeviri hatalarını doğrudan bulun',
                description: 'Kaydederken özel alanlar ve kategoriler eksik dil ile girdiyi kalıcı olarak gösterir; ilk hata otomatik açılır ve odaklanır.',
            },
            fr: {
                title: 'Repérer immédiatement les erreurs de traduction',
                description: 'Lors de l’enregistrement, les champs et catégories indiquent durablement la langue et la saisie manquantes, puis ouvrent et ciblent automatiquement la première erreur.',
            },
            es: {
                title: 'Localice enseguida los errores de traducción',
                description: 'Al guardar, los campos y categorías muestran de forma permanente el idioma y el dato que faltan, y abren y enfocan automáticamente el primer error.',
            },
            ru: {
                title: 'Сразу находите ошибки перевода',
                description: 'При сохранении поля и категории постоянно показывают недостающий язык и ввод, а первая ошибка автоматически открывается и получает фокус.',
            },
        },
    },
    {
        id: 'custom-field-drafts-and-activation',
        sequence: 33,
        version: '2026.9.6',
        publishedAt: '2026-09-04T04:45:00.000Z',
        category: 'NEW',
        linkUrl: '/admin/custom-fields',
        requiredAnyPermissions: [PERMISSIONS.CUSTOM_FIELDS_READ],
        commitRefs: ['feat(custom-fields): add draft workflow for incomplete translations'],
        translations: {
            de: {
                title: 'Unvollständige Zusatzfelder als Entwurf sichern',
                description: 'Noch nicht vollständig übersetzte Felder lassen sich speichern, ohne in Geschäftsformularen zu erscheinen; die Aktivierung bleibt bis zur vollständigen Prüfung gesperrt.',
            },
            en: {
                title: 'Save incomplete custom fields as drafts',
                description: 'Fields with unfinished translations can be saved without appearing in business forms; activation remains blocked until every required check is complete.',
            },
            tr: {
                title: 'Eksik özel alanları taslak olarak kaydedin',
                description: 'Çevirileri tamamlanmamış alanlar iş formlarında görünmeden kaydedilebilir; gerekli kontroller tamamlanana kadar etkinleştirme engellenir.',
            },
            fr: {
                title: 'Enregistrer les champs incomplets comme brouillons',
                description: 'Les champs dont les traductions sont inachevées peuvent être enregistrés sans apparaître dans les formulaires métier ; l’activation reste bloquée jusqu’à validation complète.',
            },
            es: {
                title: 'Guarde como borrador los campos incompletos',
                description: 'Los campos con traducciones pendientes pueden guardarse sin aparecer en formularios de negocio; la activación queda bloqueada hasta completar todas las comprobaciones.',
            },
            ru: {
                title: 'Сохраняйте незавершённые поля как черновики',
                description: 'Поля с незавершёнными переводами можно сохранить без показа в рабочих формах; активация недоступна до завершения всех обязательных проверок.',
            },
        },
    },
    {
        id: 'controlled-local-translation-assistance',
        sequence: 34,
        version: '2026.9.7',
        publishedAt: '2026-09-04T04:45:00.000Z',
        category: 'NEW',
        linkUrl: '/admin/custom-fields',
        requiredAnyPermissions: [PERMISSIONS.CUSTOM_FIELDS_READ],
        commitRefs: ['feat(translations): add local Ollama translation service'],
        translations: {
            de: {
                title: 'Lokale Übersetzungshilfe mit kontrollierter Prüfung',
                description: 'Definitionstexte können über den lokalen Übersetzungsdienst vorgeschlagen werden. Geschäftsdaten bleiben außen vor und Vorschläge müssen vor einer Aktivierung geprüft werden.',
            },
            en: {
                title: 'Local translation assistance with controlled review',
                description: 'Definition text can be suggested by the local translation service. Business data is excluded, and suggestions must be reviewed before activation.',
            },
            tr: {
                title: 'Denetimli incelemeyle yerel çeviri desteği',
                description: 'Tanım metinleri yerel çeviri hizmetiyle önerilebilir. İş verileri kapsam dışında kalır ve öneriler etkinleştirmeden önce incelenmelidir.',
            },
            fr: {
                title: 'Aide à la traduction locale avec contrôle',
                description: 'Le service local peut proposer la traduction des textes de définition. Les données métier sont exclues et chaque proposition doit être vérifiée avant activation.',
            },
            es: {
                title: 'Ayuda de traducción local con revisión controlada',
                description: 'El servicio local puede proponer traducciones de los textos de definición. Los datos de negocio quedan excluidos y las propuestas deben revisarse antes de activar.',
            },
            ru: {
                title: 'Локальные переводы с обязательной проверкой',
                description: 'Локальный сервис может предлагать переводы текстов определений. Деловые данные не передаются, а предложения требуют проверки перед активацией.',
            },
        },
    },
    {
        id: 'reviewed-automatic-custom-field-translations',
        sequence: 35,
        version: '2026.9.8',
        publishedAt: '2026-09-04T04:45:00.000Z',
        category: 'NEW',
        linkUrl: '/admin/custom-fields',
        requiredAnyPermissions: [PERMISSIONS.CUSTOM_FIELDS_READ],
        commitRefs: ['feat(custom-fields): add reviewed automatic field translations'],
        translations: {
            de: {
                title: 'Fehlende Feldtexte kontrolliert übersetzen',
                description: 'Im Zusatzfeld-Editor lassen sich fehlende Sprachen einzeln oder gesammelt vorschlagen, vergleichen, übernehmen oder verwerfen, ohne vorhandene Texte automatisch zu überschreiben.',
            },
            en: {
                title: 'Translate missing field text with full control',
                description: 'The custom-field editor can suggest missing languages individually or together for comparison, acceptance or rejection, without automatically replacing existing text.',
            },
            tr: {
                title: 'Eksik alan metinlerini denetimli çevirin',
                description: 'Özel alan düzenleyicisinde eksik diller tek tek veya topluca önerilebilir, karşılaştırılabilir, kabul ya da reddedilebilir; mevcut metinler otomatik değiştirilmez.',
            },
            fr: {
                title: 'Traduire les textes manquants en gardant le contrôle',
                description: 'L’éditeur peut proposer les langues manquantes séparément ou ensemble pour comparaison, acceptation ou rejet, sans remplacer automatiquement les textes existants.',
            },
            es: {
                title: 'Traduzca los textos que faltan con pleno control',
                description: 'El editor puede proponer los idiomas pendientes de forma individual o conjunta para comparar, aceptar o descartar, sin sustituir automáticamente los textos existentes.',
            },
            ru: {
                title: 'Переводите недостающие тексты под полным контролем',
                description: 'В редакторе можно получить предложения для отдельных или всех недостающих языков, сравнить, принять или отклонить их без автоматической замены существующих текстов.',
            },
        },
    },
    {
        id: 'custom-field-translation-review-center',
        sequence: 36,
        version: '2026.9.9',
        publishedAt: '2026-09-04T04:45:00.000Z',
        category: 'NEW',
        linkUrl: '/admin/custom-fields',
        requiredAnyPermissions: [PERMISSIONS.CUSTOM_FIELDS_READ],
        commitRefs: ['feat(translations): add custom field translation review center'],
        translations: {
            de: {
                title: 'Übersetzungen zentral prüfen',
                description: 'Eine gemeinsame Übersicht bündelt fehlende und maschinell vorgeschlagene Texte, zeigt den Fortschritt je Sprache und unterstützt kontrollierte Sammelaufträge und Freigaben.',
            },
            en: {
                title: 'Review translations in one place',
                description: 'A central overview brings together missing and machine-suggested text, shows progress by language, and supports controlled batch requests and approvals.',
            },
            tr: {
                title: 'Çevirileri tek merkezde inceleyin',
                description: 'Merkezi görünüm eksik ve makine önerili metinleri bir araya getirir, dil bazında ilerlemeyi gösterir ve kontrollü toplu işlemler ile onayları destekler.',
            },
            fr: {
                title: 'Contrôler les traductions dans un espace central',
                description: 'Une vue commune regroupe les textes manquants et suggérés, affiche la progression par langue et permet des traitements et validations groupés et contrôlés.',
            },
            es: {
                title: 'Revise las traducciones en un único lugar',
                description: 'Una vista central reúne textos pendientes y sugeridos, muestra el progreso por idioma y permite solicitudes y aprobaciones masivas de forma controlada.',
            },
            ru: {
                title: 'Проверяйте переводы в едином центре',
                description: 'Общий обзор объединяет недостающие и машинные предложения, показывает прогресс по языкам и поддерживает контролируемые пакетные задания и подтверждения.',
            },
        },
    },
    {
        id: 'tenant-translation-glossary',
        sequence: 37,
        version: '2026.9.10',
        publishedAt: '2026-09-04T04:45:00.000Z',
        category: 'NEW',
        linkUrl: '/settings/translations',
        requiredAnyPermissions: [PERMISSIONS.TRANSLATIONS_GLOSSARY_MANAGE],
        commitRefs: ['feat(translations): add tenant translation glossary'],
        translations: {
            de: {
                title: 'Unternehmensbegriffe im Übersetzungsglossar schützen',
                description: 'Marken, Produktnamen, Abkürzungen und weitere feste Begriffe lassen sich mandantenbezogen pflegen und bei Übersetzungsvorschlägen unverändert erhalten.',
            },
            en: {
                title: 'Protect company terms in the translation glossary',
                description: 'Brands, product names, abbreviations and other fixed terms can be maintained per tenant and preserved unchanged in translation suggestions.',
            },
            tr: {
                title: 'Şirket terimlerini çeviri sözlüğünde koruyun',
                description: 'Markalar, ürün adları, kısaltmalar ve diğer sabit terimler kiracı bazında yönetilebilir ve çeviri önerilerinde değişmeden korunur.',
            },
            fr: {
                title: 'Protéger les termes de l’entreprise dans le glossaire',
                description: 'Marques, noms de produits, abréviations et autres termes fixes se gèrent par organisation et restent inchangés dans les propositions de traduction.',
            },
            es: {
                title: 'Proteja los términos de empresa en el glosario',
                description: 'Marcas, nombres de producto, abreviaturas y otros términos fijos se gestionan por organización y se conservan sin cambios en las propuestas de traducción.',
            },
            ru: {
                title: 'Защищайте термины компании в глоссарии',
                description: 'Бренды, названия продуктов, сокращения и другие фиксированные термины ведутся отдельно для каждой организации и сохраняются без изменений в предложениях.',
            },
        },
    },
    {
        id: 'reviewed-translation-memory',
        sequence: 38,
        version: '2026.9.11',
        publishedAt: '2026-09-04T04:45:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/settings/translations',
        requiredAnyPermissions: [PERMISSIONS.TRANSLATIONS_REVIEW],
        commitRefs: ['feat(translations): add reviewed translation memory'],
        translations: {
            de: {
                title: 'Geprüfte Übersetzungen konsistent wiederverwenden',
                description: 'Der mandanteneigene Übersetzungsspeicher schlägt bestätigte Formulierungen erneut vor, zeigt ihre Herkunft und erkennt veraltete Texte nach Änderungen am Ausgangstext.',
            },
            en: {
                title: 'Reuse reviewed translations consistently',
                description: 'The tenant-specific translation memory suggests approved wording again, shows its origin, and detects outdated translations after source text changes.',
            },
            tr: {
                title: 'İncelenmiş çevirileri tutarlı biçimde yeniden kullanın',
                description: 'Kiracıya özel çeviri belleği onaylanmış ifadeleri yeniden önerir, kaynağını gösterir ve kaynak metin değişince güncelliğini yitiren çevirileri belirler.',
            },
            fr: {
                title: 'Réutiliser les traductions validées avec cohérence',
                description: 'La mémoire propre à chaque organisation repropose les formulations approuvées, indique leur origine et détecte les traductions obsolètes après modification de la source.',
            },
            es: {
                title: 'Reutilice traducciones revisadas de forma coherente',
                description: 'La memoria propia de cada organización vuelve a sugerir textos aprobados, muestra su origen y detecta traducciones obsoletas cuando cambia el texto de origen.',
            },
            ru: {
                title: 'Повторно используйте проверенные переводы',
                description: 'Память переводов организации снова предлагает подтверждённые формулировки, показывает их источник и выявляет устаревшие переводы после изменения исходного текста.',
            },
        },
    },
    {
        id: 'protected-technical-translation-content',
        sequence: 39,
        version: '2026.9.12',
        publishedAt: '2026-09-04T04:45:00.000Z',
        category: 'FIXED',
        linkUrl: '/admin/custom-fields',
        requiredAnyPermissions: [PERMISSIONS.CUSTOM_FIELDS_READ],
        commitRefs: ['fix(translations): protect placeholders formulas and technical values'],
        translations: {
            de: {
                title: 'Technische Inhalte bleiben beim Übersetzen geschützt',
                description: 'Platzhalter, Formeln, Feldschlüssel, Links, Einheiten und stabile Auswahlwerte werden vor und nach jedem Vorschlag geprüft; fehlerhafte Ergebnisse gelangen nicht in das Formular.',
            },
            en: {
                title: 'Technical content stays protected during translation',
                description: 'Placeholders, formulas, field keys, links, units and stable option values are checked before and after every suggestion; invalid results never enter the form.',
            },
            tr: {
                title: 'Teknik içerikler çeviri sırasında korunur',
                description: 'Yer tutucular, formüller, alan anahtarları, bağlantılar, birimler ve sabit seçenek değerleri her öneriden önce ve sonra denetlenir; hatalı sonuçlar forma alınmaz.',
            },
            fr: {
                title: 'Le contenu technique reste protégé pendant la traduction',
                description: 'Paramètres, formules, clés, liens, unités et valeurs d’option stables sont contrôlés avant et après chaque proposition ; aucun résultat invalide n’entre dans le formulaire.',
            },
            es: {
                title: 'El contenido técnico permanece protegido al traducir',
                description: 'Marcadores, fórmulas, claves, enlaces, unidades y valores estables se comprueban antes y después de cada propuesta; los resultados no válidos no llegan al formulario.',
            },
            ru: {
                title: 'Техническое содержимое защищено при переводе',
                description: 'Плейсхолдеры, формулы, ключи полей, ссылки, единицы и стабильные значения вариантов проверяются до и после предложения; ошибочный результат не попадает в форму.',
            },
        },
    },
    {
        id: 'localized-custom-field-usage-preview',
        sequence: 40,
        version: '2026.9.13',
        publishedAt: '2026-09-04T04:45:00.000Z',
        category: 'NEW',
        linkUrl: '/admin/custom-fields',
        requiredAnyPermissions: [PERMISSIONS.CUSTOM_FIELDS_READ],
        commitRefs: ['feat(custom-fields): add localized usage preview'],
        translations: {
            de: {
                title: 'Zusatzfelder im späteren Einsatz vorab ansehen',
                description: 'Die lokalisierte Vorschau zeigt Kategorie, Feld, Hinweise und Auswahloptionen für verschiedene Entitäten sowie Desktop, Tablet und Mobilgerät – ohne echte Geschäftsdaten zu laden.',
            },
            en: {
                title: 'Preview custom fields in their future context',
                description: 'The localized preview shows category, field, guidance and options for different entities and desktop, tablet or mobile layouts without loading real business data.',
            },
            tr: {
                title: 'Özel alanları gerçek kullanım bağlamında önizleyin',
                description: 'Yerelleştirilmiş önizleme, gerçek iş verisi yüklemeden farklı varlıklar ile masaüstü, tablet ve mobil görünümlerde kategori, alan, açıklama ve seçenekleri gösterir.',
            },
            fr: {
                title: 'Prévisualiser les champs dans leur futur contexte',
                description: 'La prévisualisation localisée montre catégorie, champ, aide et options selon l’entité et le format ordinateur, tablette ou mobile, sans charger de données métier réelles.',
            },
            es: {
                title: 'Previsualice los campos en su contexto de uso',
                description: 'La vista localizada muestra categoría, campo, ayuda y opciones para distintas entidades y formatos de escritorio, tableta o móvil, sin cargar datos reales de negocio.',
            },
            ru: {
                title: 'Предпросмотр полей в будущем контексте',
                description: 'Локализованный предпросмотр показывает категорию, поле, подсказки и варианты для разных сущностей и экранов компьютера, планшета или телефона без загрузки реальных данных.',
            },
        },
    },
    {
        id: 'custom-field-change-impact-analysis',
        sequence: 41,
        version: '2026.9.14',
        publishedAt: '2026-09-04T04:45:00.000Z',
        category: 'NEW',
        linkUrl: '/admin/custom-fields',
        requiredAnyPermissions: [PERMISSIONS.CUSTOM_FIELDS_READ],
        commitRefs: ['feat(custom-fields): add change impact analysis'],
        translations: {
            de: {
                title: 'Auswirkungen vor riskanten Feldänderungen prüfen',
                description: 'Vor strukturellen Änderungen sehen Administratoren betroffene Datensätze und Verwendungen samt Risikostufe; produktiv genutzte Schlüssel und Werte werden vor stillen Schäden geschützt.',
            },
            en: {
                title: 'Assess impact before risky field changes',
                description: 'Before structural changes, administrators see affected records and usage with a risk level; keys and values already in production are protected from silent damage.',
            },
            tr: {
                title: 'Riskli alan değişikliklerinden önce etkiyi inceleyin',
                description: 'Yapısal değişikliklerden önce yöneticiler etkilenen kayıtları, kullanımları ve risk düzeyini görür; üretimdeki anahtar ve değerler sessiz bozulmaya karşı korunur.',
            },
            fr: {
                title: 'Évaluer l’impact avant une modification risquée',
                description: 'Avant toute modification structurelle, les administrateurs voient les enregistrements, usages et niveau de risque ; les clés et valeurs déjà utilisées sont protégées.',
            },
            es: {
                title: 'Evalúe el impacto antes de cambios arriesgados',
                description: 'Antes de modificar la estructura, los administradores ven registros, usos y nivel de riesgo; las claves y valores ya productivos quedan protegidos frente a daños silenciosos.',
            },
            ru: {
                title: 'Оценивайте последствия рискованных изменений',
                description: 'До структурного изменения администраторы видят затронутые записи, места использования и уровень риска; рабочие ключи и значения защищены от незаметного повреждения.',
            },
        },
    },
    {
        id: 'versioned-custom-field-publishing',
        sequence: 42,
        version: '2026.9.15',
        publishedAt: '2026-09-04T04:45:00.000Z',
        category: 'NEW',
        linkUrl: '/admin/custom-fields',
        requiredAnyPermissions: [PERMISSIONS.CUSTOM_FIELDS_READ],
        commitRefs: ['feat(custom-fields): add versioned publishing workflow'],
        translations: {
            de: {
                title: 'Zusatzfelder versioniert prüfen und veröffentlichen',
                description: 'Änderungen an aktiven Feldern entstehen als neue Version, können verglichen und begründet freigegeben werden; frühere Stände bleiben einsehbar und als neue Version wiederherstellbar.',
            },
            en: {
                title: 'Review and publish versioned custom fields',
                description: 'Changes to active fields become a new version for comparison and reasoned approval; earlier states remain visible and can be restored as another version.',
            },
            tr: {
                title: 'Sürümlü özel alanları inceleyip yayımlayın',
                description: 'Etkin alan değişiklikleri karşılaştırma ve gerekçeli onay için yeni bir sürüm olur; önceki durumlar görüntülenebilir ve yeni sürüm olarak geri yüklenebilir.',
            },
            fr: {
                title: 'Contrôler et publier des champs versionnés',
                description: 'Les modifications d’un champ actif créent une nouvelle version à comparer et valider avec justification ; les états antérieurs restent consultables et restaurables.',
            },
            es: {
                title: 'Revise y publique campos con versiones',
                description: 'Los cambios de un campo activo crean una versión nueva que puede compararse y aprobarse con justificación; los estados anteriores siguen visibles y pueden restaurarse.',
            },
            ru: {
                title: 'Проверяйте и публикуйте версии полей',
                description: 'Изменения активного поля создают новую версию для сравнения и обоснованного подтверждения; прежние состояния остаются доступными и восстанавливаются новой версией.',
            },
        },
    },
    {
        id: 'custom-field-definition-import-export',
        sequence: 43,
        version: '2026.9.16',
        publishedAt: '2026-09-04T04:45:00.000Z',
        category: 'NEW',
        linkUrl: '/admin/custom-fields',
        requiredAnyPermissions: [PERMISSIONS.CUSTOM_FIELDS_READ],
        commitRefs: ['feat(custom-fields): add definition translation import export'],
        translations: {
            de: {
                title: 'Zusatzfelder sicher exportieren und gesammelt pflegen',
                description: 'Definitionen und Übersetzungen stehen als Tabellenexport bereit; Importe zeigen vorab neue, geänderte und fehlerhafte Zeilen mit genauer Rückmeldung und aktivieren nichts automatisch.',
            },
            en: {
                title: 'Export and maintain custom fields safely in bulk',
                description: 'Definitions and translations are available as spreadsheet exports; imports preview new, changed and invalid rows with precise feedback and never activate anything automatically.',
            },
            tr: {
                title: 'Özel alanları güvenle dışa aktarın ve topluca yönetin',
                description: 'Tanımlar ve çeviriler tablo olarak dışa aktarılabilir; içe aktarma yeni, değişen ve hatalı satırları ayrıntılı geri bildirimle önceden gösterir ve hiçbir şeyi otomatik etkinleştirmez.',
            },
            fr: {
                title: 'Exporter et gérer les champs en masse en toute sécurité',
                description: 'Définitions et traductions sont exportables sous forme de tableau ; l’import prévisualise les lignes nouvelles, modifiées ou erronées avec un retour précis, sans activation automatique.',
            },
            es: {
                title: 'Exporte y mantenga campos en bloque con seguridad',
                description: 'Las definiciones y traducciones pueden exportarse como tabla; la importación muestra antes las filas nuevas, cambiadas o erróneas con detalle y nunca activa nada automáticamente.',
            },
            ru: {
                title: 'Безопасно экспортируйте и массово ведите поля',
                description: 'Определения и переводы экспортируются в таблицу; импорт заранее показывает новые, изменённые и ошибочные строки с точной обратной связью и ничего не активирует автоматически.',
            },
        },
    },
    {
        id: 'granular-custom-field-administration-permissions',
        sequence: 44,
        version: '2026.9.17',
        publishedAt: '2026-09-04T04:45:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/settings/roles',
        requiredAnyPermissions: [PERMISSIONS.SETTINGS_READ],
        commitRefs: ['feat(custom-fields): add granular administration permissions'],
        translations: {
            de: {
                title: 'Zusatzfeld-Verwaltung genauer berechtigen',
                description: 'Rollen können Lesen, Bearbeiten, Übersetzen, Prüfen, Veröffentlichen, Importieren, Glossarpflege und Wiederherstellung getrennt erhalten; der Server prüft jedes Recht mandantenbezogen.',
            },
            en: {
                title: 'Control custom-field administration more precisely',
                description: 'Roles can receive separate rights to read, edit, translate, review, publish, import, manage the glossary and restore versions, with tenant-aware checks on every request.',
            },
            tr: {
                title: 'Özel alan yönetimini ayrıntılı yetkilendirin',
                description: 'Rollere okuma, düzenleme, çeviri, inceleme, yayımlama, içe aktarma, sözlük yönetimi ve sürüm geri yükleme yetkileri ayrı ayrı verilebilir; her istek kiracı bazında denetlenir.',
            },
            fr: {
                title: 'Gérer plus finement les droits des champs personnalisés',
                description: 'Les rôles reçoivent séparément les droits de lecture, modification, traduction, contrôle, publication, import, glossaire et restauration, vérifiés par organisation à chaque requête.',
            },
            es: {
                title: 'Controle con precisión la administración de campos',
                description: 'Los roles reciben por separado permisos para leer, editar, traducir, revisar, publicar, importar, gestionar el glosario y restaurar versiones, comprobados por organización en cada solicitud.',
            },
            ru: {
                title: 'Точно настраивайте права на управление полями',
                description: 'Ролям отдельно назначаются права чтения, изменения, перевода, проверки, публикации, импорта, ведения глоссария и восстановления; каждый запрос проверяется в рамках организации.',
            },
        },
    },
    {
        id: 'custom-field-configuration-quality-dashboard',
        sequence: 45,
        version: '2026.9.18',
        publishedAt: '2026-09-04T04:45:00.000Z',
        category: 'NEW',
        linkUrl: '/admin/custom-fields',
        requiredAnyPermissions: [PERMISSIONS.CUSTOM_FIELDS_READ],
        commitRefs: ['feat(custom-fields): add configuration quality dashboard'],
        translations: {
            de: {
                title: 'Konfigurationsqualität auf einen Blick',
                description: 'Das Qualitäts-Dashboard bündelt fehlende Übersetzungen, ungeprüfte Vorschläge, ungültige Formeln, Konflikte, ungenutzte Felder und fehlgeschlagene Aufträge mit direkten Sprungzielen.',
            },
            en: {
                title: 'Configuration quality at a glance',
                description: 'The quality dashboard brings together missing translations, unreviewed suggestions, invalid formulas, conflicts, unused fields and failed jobs with direct links to each issue.',
            },
            tr: {
                title: 'Yapılandırma kalitesi tek bakışta',
                description: 'Kalite panosu eksik çevirileri, incelenmemiş önerileri, geçersiz formülleri, çakışmaları, kullanılmayan alanları ve başarısız işleri doğrudan bağlantılarla bir araya getirir.',
            },
            fr: {
                title: 'La qualité de configuration en un coup d’œil',
                description: 'Le tableau de qualité réunit traductions manquantes, propositions non contrôlées, formules invalides, conflits, champs inutilisés et traitements échoués avec des liens directs.',
            },
            es: {
                title: 'Calidad de configuración de un vistazo',
                description: 'El panel reúne traducciones pendientes, propuestas sin revisar, fórmulas no válidas, conflictos, campos sin uso y tareas fallidas con enlaces directos a cada incidencia.',
            },
            ru: {
                title: 'Качество конфигурации с первого взгляда',
                description: 'Панель качества объединяет недостающие переводы, непроверенные предложения, неверные формулы, конфликты, неиспользуемые поля и сбои заданий с прямыми ссылками.',
            },
        },
    },
    {
        id: 'unified-customer-activity-timeline',
        sequence: 46,
        version: '2026.9.19',
        publishedAt: '2026-09-04T09:00:00.000Z',
        category: 'NEW',
        linkUrl: '/partners',
        requiredAnyPermissions: [PERMISSIONS.CUSTOMER_READ],
        commitRefs: ['feat(crm): add unified customer activity timeline'],
        translations: {
            de: {
                title: 'Kundenkontakte und Vorgänge in einer Zeitleiste',
                description: 'Kundenakten bündeln jetzt Belege, Portalbestellungen, Telefonate, E-Mails, Notizen und manuell dokumentierte Kontakte chronologisch. Persönliche Kontakte sind klar von automatisch entstandenen Vorgängen getrennt.',
            },
            en: {
                title: 'Customer contacts and events in one timeline',
                description: 'Customer records now combine documents, portal orders, calls, emails, notes and manually documented contacts chronologically. Personal contacts are clearly separated from automatically created events.',
            },
            tr: {
                title: 'Müşteri temasları ve işlemleri tek zaman çizelgesinde',
                description: 'Müşteri kayıtları artık belgeleri, portal siparişlerini, aramaları, e-postaları, notları ve elle belgelenen temasları kronolojik olarak birleştirir. Kişisel temaslar otomatik işlemlerden açıkça ayrılır.',
            },
            fr: {
                title: 'Contacts et événements client dans une seule chronologie',
                description: 'Les fiches client regroupent désormais chronologiquement documents, commandes du portail, appels, e-mails, notes et contacts saisis manuellement. Les contacts personnels sont clairement séparés des événements automatiques.',
            },
            es: {
                title: 'Contactos y eventos del cliente en una sola cronología',
                description: 'Las fichas de cliente reúnen cronológicamente documentos, pedidos del portal, llamadas, correos, notas y contactos documentados manualmente. Los contactos personales se distinguen claramente de los eventos automáticos.',
            },
            ru: {
                title: 'Контакты и события клиента в единой хронологии',
                description: 'Карточка клиента теперь хронологически объединяет документы, заказы с портала, звонки, письма, заметки и контакты, внесённые вручную. Личные контакты явно отделены от автоматических событий.',
            },
        },
    },
    {
        id: 'explainable-reorder-cadence',
        sequence: 47,
        version: '2026.9.20',
        publishedAt: '2026-09-04T09:30:00.000Z',
        category: 'NEW',
        linkUrl: '/partners',
        requiredAnyPermissions: [PERMISSIONS.SALES_ASSISTANT_USE],
        commitRefs: ['feat(crm): add explainable reorder cadence analysis'],
        translations: {
            de: {
                title: 'Individuelle Bestellrhythmen statt starrer Fristen',
                description: 'Die Kundenakte erklärt den typischen Bestellabstand, die nächste Erwartung und deren Vertrauensniveau. Ausreißer, Saisonzeiten, offene Aufträge, geplante Bestellungen und bekannte Betriebspausen werden nachvollziehbar berücksichtigt.',
            },
            en: {
                title: 'Individual reorder cadence instead of fixed deadlines',
                description: 'The customer record explains the typical order interval, next expectation and confidence. Outliers, seasons, open orders, planned orders and known operating pauses are handled transparently.',
            },
            tr: {
                title: 'Sabit süreler yerine bireysel sipariş ritmi',
                description: 'Müşteri kaydı olağan sipariş aralığını, sonraki beklentiyi ve güven düzeyini açıklar. Aykırı değerler, sezonlar, açık ve planlanan siparişler ile bilinen işletme araları şeffaf biçimde dikkate alınır.',
            },
            fr: {
                title: 'Un rythme de commande individuel plutôt que des délais fixes',
                description: 'La fiche client explique l’intervalle habituel, la prochaine échéance et sa fiabilité. Valeurs aberrantes, saisons, commandes ouvertes ou prévues et fermetures connues sont prises en compte de façon transparente.',
            },
            es: {
                title: 'Ritmo de pedido individual en lugar de plazos fijos',
                description: 'La ficha explica el intervalo habitual, la próxima fecha esperada y su confianza. Se consideran de forma transparente valores atípicos, temporadas, pedidos abiertos o previstos y pausas operativas conocidas.',
            },
            ru: {
                title: 'Индивидуальный ритм заказов вместо фиксированных сроков',
                description: 'Карточка клиента объясняет обычный интервал, следующую ожидаемую дату и уровень уверенности. Прозрачно учитываются выбросы, сезонность, открытые и запланированные заказы и известные перерывы в работе.',
            },
        },
    },
    {
        id: 'configurable-sales-opportunity-rules',
        sequence: 48,
        version: '2026.9.21',
        publishedAt: '2026-09-04T10:00:00.000Z',
        category: 'NEW',
        linkUrl: '/partners',
        requiredAnyPermissions: [PERMISSIONS.SALES_ASSISTANT_USE],
        commitRefs: ['feat(crm): add configurable sales opportunity rules'],
        translations: {
            de: {
                title: 'Nachvollziehbare Hinweise für die Kundenpflege',
                description: 'Konfigurierbare Regeln erkennen 17 konkrete Vertriebs- und Betreuungssituationen anhand sichtbarer Fakten. Reklamationen, Sperren und Zahlungsrisiken erhalten Vorrang vor gewöhnlichen Verkaufsanrufen.',
            },
            en: {
                title: 'Transparent customer-care opportunities',
                description: 'Configurable rules identify 17 specific sales and care situations from visible facts. Complaints, blocks and payment risks take precedence over ordinary sales calls.',
            },
            tr: {
                title: 'Açıklanabilir müşteri bakım fırsatları',
                description: 'Yapılandırılabilir kurallar, görünür olgulara dayanarak 17 somut satış ve bakım durumunu belirler. Şikâyetler, engeller ve ödeme riskleri olağan satış aramalarından önce gelir.',
            },
            fr: {
                title: 'Des opportunités de suivi client transparentes',
                description: 'Des règles configurables identifient 17 situations précises de vente et de suivi à partir de faits visibles. Réclamations, blocages et risques de paiement priment sur les appels commerciaux ordinaires.',
            },
            es: {
                title: 'Oportunidades transparentes de atención al cliente',
                description: 'Las reglas configurables detectan 17 situaciones concretas de venta y atención a partir de hechos visibles. Las reclamaciones, los bloqueos y los riesgos de pago tienen prioridad sobre las llamadas comerciales normales.',
            },
            ru: {
                title: 'Понятные возможности для работы с клиентами',
                description: 'Настраиваемые правила выявляют 17 конкретных ситуаций продаж и сопровождения по видимым фактам. Претензии, блокировки и платёжные риски имеют приоритет над обычными звонками по продажам.',
            },
        },
    },
    {
        id: 'automated-idempotent-sales-recommendations',
        sequence: 49,
        version: '2026.9.22',
        publishedAt: '2026-09-04T10:30:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/partners',
        requiredAnyPermissions: [PERMISSIONS.SALES_RULES_VIEW],
        commitRefs: ['feat(crm): automate idempotent sales recommendations'],
        translations: {
            de: {
                title: 'Kundenpflege-Hinweise zuverlässig im Hintergrund',
                description: 'Mandantenbezogene Läufe verarbeiten auch große Kundenbestände in Batches, verhindern Dubletten und setzen nach einem Neustart am letzten sicheren Punkt fort. Fortschritt und Fehler bleiben nachvollziehbar.',
            },
            en: {
                title: 'Reliable customer-care insights in the background',
                description: 'Tenant-aware runs process even large customer bases in batches, prevent duplicates and resume from the last safe checkpoint after a restart. Progress and errors remain transparent.',
            },
            tr: {
                title: 'Arka planda güvenilir müşteri bakım önerileri',
                description: 'Kiracı bazlı çalışmalar büyük müşteri tabanlarını gruplar hâlinde işler, kopyaları önler ve yeniden başlatmadan sonra son güvenli noktadan devam eder. İlerleme ve hatalar izlenebilir kalır.',
            },
            fr: {
                title: 'Des recommandations client fiables en arrière-plan',
                description: 'Les traitements par organisation gèrent de grands portefeuilles par lots, évitent les doublons et reprennent au dernier point sûr après un redémarrage. Progression et erreurs restent explicites.',
            },
            es: {
                title: 'Recomendaciones fiables de atención en segundo plano',
                description: 'Los procesos por organización tratan grandes carteras por lotes, evitan duplicados y continúan desde el último punto seguro tras un reinicio. El progreso y los errores siguen siendo transparentes.',
            },
            ru: {
                title: 'Надёжные рекомендации по клиентам в фоне',
                description: 'Запуски по организациям обрабатывают большие клиентские базы пакетами, исключают дубли и продолжаются с последней безопасной точки после перезапуска. Прогресс и ошибки остаются прозрачными.',
            },
        },
    },
    {
        id: 'sales-follow-up-workflow',
        sequence: 50,
        version: '2026.9.23',
        publishedAt: '2026-09-04T11:00:00.000Z',
        category: 'NEW',
        linkUrl: '/sales-assistant',
        requiredAnyPermissions: [PERMISSIONS.SALES_TASKS_VIEW_OWN],
        commitRefs: ['feat(crm): add sales follow-up task workflow'],
        translations: {
            de: {
                title: 'Vertriebsaufgaben gemeinsam und ohne Doppelarbeit bearbeiten',
                description: 'Empfehlungen werden zu planbaren Aufgaben mit Fälligkeit, Erinnerung, Kommentaren, Checkliste, Anhängen und vollständiger Historie. Vertretungen übernehmen bei Abwesenheit; eine sichere Übernahme verhindert parallele Kontakte.',
            },
            en: {
                title: 'Handle sales follow-ups together without duplicate work',
                description: 'Recommendations become scheduled tasks with due dates, reminders, comments, checklists, attachments and a complete history. Delegates take over during absences, while safe claiming prevents parallel contact.',
            },
            tr: {
                title: 'Satış takiplerini yinelenen iş olmadan birlikte yönetin',
                description: 'Öneriler; son tarih, hatırlatma, yorum, kontrol listesi, ek ve eksiksiz geçmiş içeren planlanabilir görevlere dönüşür. Yoklukta vekiller devralır; güvenli sahiplenme eş zamanlı iletişimi önler.',
            },
            fr: {
                title: 'Traiter les suivis commerciaux ensemble, sans doublons',
                description: 'Les recommandations deviennent des tâches planifiées avec échéance, rappel, commentaires, liste de contrôle, pièces jointes et historique complet. Les délégations couvrent les absences et la prise en charge sûre évite les contacts parallèles.',
            },
            es: {
                title: 'Gestionar seguimientos comerciales en equipo y sin duplicados',
                description: 'Las recomendaciones se convierten en tareas planificadas con vencimiento, recordatorio, comentarios, lista de control, adjuntos e historial completo. Las sustituciones cubren ausencias y la toma segura evita contactos paralelos.',
            },
            ru: {
                title: 'Совместная работа с задачами продаж без дублирования',
                description: 'Рекомендации превращаются в планируемые задачи со сроком, напоминанием, комментариями, списком действий, вложениями и полной историей. Замещения учитывают отсутствие, а безопасное принятие исключает параллельные контакты.',
            },
        },
    },
    {
        id: 'structured-sales-contact-outcomes',
        sequence: 51,
        version: '2026.9.24',
        publishedAt: '2026-09-04T11:30:00.000Z',
        category: 'NEW',
        linkUrl: '/sales-assistant',
        requiredAnyPermissions: [PERMISSIONS.SALES_CONTACTS_DOCUMENT],
        commitRefs: ['feat(crm): add structured sales contact outcomes'],
        translations: {
            de: {
                title: 'Kontaktergebnisse vollständig und schnell festhalten',
                description: 'Anrufe, Rückrufe, Besuche und Termine werden mit einem passenden Ergebnis abgeschlossen. Vereinbarte Folgetermine, erwartete Bestellungen, Angebote und Reklamationen entstehen direkt und ohne doppelte Vorgänge.',
            },
            en: {
                title: 'Capture contact outcomes quickly and completely',
                description: 'Calls, callbacks, visits and meetings close with a suitable outcome. Agreed follow-ups, expected orders, quotes and complaints are created directly without duplicate records.',
            },
            tr: {
                title: 'İletişim sonuçlarını hızlı ve eksiksiz kaydedin',
                description: 'Aramalar, geri aramalar, ziyaretler ve toplantılar uygun bir sonuçla tamamlanır. Kararlaştırılan takipler, beklenen siparişler, teklifler ve şikâyetler yinelenen kayıt olmadan doğrudan oluşturulur.',
            },
            fr: {
                title: 'Consigner rapidement et complètement les résultats de contact',
                description: 'Les appels, rappels, visites et rendez-vous se terminent par un résultat adapté. Les suivis convenus, commandes attendues, devis et réclamations sont créés directement sans doublons.',
            },
            es: {
                title: 'Registrar resultados de contacto de forma rápida y completa',
                description: 'Las llamadas, devoluciones de llamada, visitas y reuniones se cierran con un resultado adecuado. Los seguimientos acordados, pedidos previstos, presupuestos y reclamaciones se crean directamente sin duplicados.',
            },
            ru: {
                title: 'Быстрая и полная фиксация результатов контакта',
                description: 'Звонки, обратные звонки, визиты и встречи завершаются подходящим результатом. Согласованные последующие действия, ожидаемые заказы, предложения и претензии создаются сразу и без дублей.',
            },
        },
    },
    {
        id: 'proactive-sales-assistant-cockpit',
        sequence: 52,
        version: '2026.9.25',
        publishedAt: '2026-09-04T12:00:00.000Z',
        category: 'NEW',
        linkUrl: '/sales-assistant',
        requiredAnyPermissions: [PERMISSIONS.SALES_ASSISTANT_USE],
        commitRefs: ['feat(web): add proactive sales assistant cockpit'],
        translations: {
            de: {
                title: 'Alle wichtigen Kundenkontakte in einem Cockpit',
                description: 'Das persönliche Vertriebscockpit bündelt fällige Kontakte, Aufgaben, ausgebliebene Bestellungen, offene Angebote und Klärfälle. Jede Karte zeigt Fakten, Priorität und mögliche Sperren; Ansichten lassen sich speichern und Vorgänge gemeinsam bearbeiten.',
            },
            en: {
                title: 'All important customer contacts in one cockpit',
                description: 'The personal sales cockpit brings together due contacts, tasks, missed orders, open quotes and resolution cases. Every card shows facts, priority and possible blocks; views can be saved and work handled in batches.',
            },
            tr: {
                title: 'Tüm önemli müşteri temasları tek kokpitte',
                description: 'Kişisel satış kokpiti; yaklaşan temasları, görevleri, kaçırılan siparişleri, açık teklifleri ve çözüm bekleyen konuları bir araya getirir. Her kart gerçekleri, önceliği ve olası engelleri gösterir; görünümler kaydedilebilir ve işlemler toplu yürütülebilir.',
            },
            fr: {
                title: 'Tous les contacts client importants dans un cockpit',
                description: 'Le cockpit commercial personnel réunit les contacts à traiter, tâches, commandes manquées, devis ouverts et dossiers à clarifier. Chaque carte présente les faits, la priorité et les blocages éventuels; les vues sont enregistrables et les actions traitables en lot.',
            },
            es: {
                title: 'Todos los contactos importantes en un solo panel',
                description: 'El panel personal de ventas reúne contactos pendientes, tareas, pedidos ausentes, ofertas abiertas y asuntos por resolver. Cada tarjeta muestra hechos, prioridad y posibles bloqueos; las vistas se guardan y las acciones se procesan por lotes.',
            },
            ru: {
                title: 'Все важные контакты с клиентами в одной панели',
                description: 'Личная панель продаж объединяет срочные контакты, задачи, пропущенные заказы, открытые предложения и вопросы для решения. Каждая карточка показывает факты, приоритет и возможные ограничения; виды сохраняются, а действия выполняются пакетно.',
            },
        },
    },
    {
        id: 'customer-care-profile-insights',
        sequence: 53,
        version: '2026.9.26',
        publishedAt: '2026-09-04T12:30:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/partners/customers',
        requiredAnyPermissions: [PERMISSIONS.SALES_ASSISTANT_USE],
        commitRefs: ['feat(crm): integrate customer care insights'],
        translations: {
            de: {
                title: 'Kundenpflege direkt in jeder Kundenakte',
                description: 'Kunden und Interessenten zeigen jetzt letzte und nächste Kontakte, Bestellrhythmus, Zuständigkeit, offene Aufgaben und Sperrhinweise an einem Ort. Rückrufe, Besuche und Angebote lassen sich direkt planen; begründete Regelausnahmen bleiben nachvollziehbar.',
            },
            en: {
                title: 'Customer care directly in every customer record',
                description: 'Customer and prospect records now show recent and upcoming contacts, reorder cadence, ownership, open tasks and restrictions in one place. Callbacks, visits and quotes can be planned directly, while documented rule exceptions remain transparent.',
            },
            tr: {
                title: 'Her müşteri kaydında doğrudan müşteri bakımı',
                description: 'Müşteri ve aday kayıtları artık son ve yaklaşan temasları, sipariş ritmini, sorumluyu, açık görevleri ve kısıtları tek yerde gösterir. Geri aramalar, ziyaretler ve teklifler doğrudan planlanır; gerekçeli kural istisnaları izlenebilir kalır.',
            },
            fr: {
                title: 'Le suivi client directement dans chaque fiche',
                description: 'Les fiches client et prospect réunissent désormais contacts récents et à venir, rythme de commande, responsable, tâches ouvertes et restrictions. Rappels, visites et devis se planifient directement, avec des exceptions de règles documentées.',
            },
            es: {
                title: 'Atención al cliente directamente en cada ficha',
                description: 'Las fichas de clientes y prospectos reúnen contactos recientes y próximos, ritmo de pedidos, responsable, tareas abiertas y restricciones. Se pueden planificar devoluciones, visitas y ofertas directamente, manteniendo visibles las excepciones justificadas.',
            },
            ru: {
                title: 'Работа с клиентом прямо в его карточке',
                description: 'Карточки клиентов и лидов теперь объединяют последние и будущие контакты, ритм заказов, ответственного, открытые задачи и ограничения. Звонки, визиты и предложения планируются сразу, а обоснованные исключения правил остаются прозрачными.',
            },
        },
    },
    {
        id: 'ringover-sales-follow-ups',
        sequence: 54,
        version: '2026.9.27',
        publishedAt: '2026-09-04T13:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/sales-assistant',
        requiredAnyPermissions: [PERMISSIONS.SALES_ASSISTANT_USE],
        commitRefs: ['feat(cti): connect Ringover with sales follow-ups'],
        translations: {
            de: {
                title: 'Ringover-Anrufe lückenlos nachverfolgen',
                description: 'Anrufe aus Empfehlungen und Aufgaben bleiben mit dem Kundenfall verbunden. Dauer, Richtung und Erreichbarkeit werden sicher übernommen; nach Gesprächsende öffnet sich direkt die strukturierte Ergebnisdokumentation.',
            },
            en: {
                title: 'Track Ringover calls without gaps',
                description: 'Calls from recommendations and tasks stay connected to the customer case. Duration, direction and reachability are captured securely, and structured outcome recording opens when the call ends.',
            },
            tr: {
                title: 'Ringover aramalarını eksiksiz takip edin',
                description: 'Önerilerden ve görevlerden başlatılan aramalar müşteri kaydıyla bağlantılı kalır. Süre, yön ve ulaşılabilirlik güvenle alınır; görüşme bitince yapılandırılmış sonuç kaydı açılır.',
            },
            fr: {
                title: 'Suivre les appels Ringover sans interruption',
                description: 'Les appels issus des recommandations et tâches restent liés au dossier client. Durée, direction et joignabilité sont reprises de façon sûre, puis la saisie structurée du résultat s’ouvre à la fin.',
            },
            es: {
                title: 'Seguimiento completo de llamadas Ringover',
                description: 'Las llamadas iniciadas desde recomendaciones y tareas permanecen vinculadas al caso del cliente. Se registran duración, dirección y contacto, y al terminar se abre el resultado estructurado.',
            },
            ru: {
                title: 'Полное сопровождение звонков Ringover',
                description: 'Звонки из рекомендаций и задач сохраняют связь с карточкой клиента. Длительность, направление и результат соединения фиксируются безопасно, а после завершения открывается структурированный итог.',
            },
        },
    },
    {
        id: 'local-ai-sales-call-preparation',
        sequence: 55,
        version: '2026.9.28',
        publishedAt: '2026-09-04T13:30:00.000Z',
        category: 'NEW',
        linkUrl: '/sales-assistant',
        requiredAnyPermissions: [PERMISSIONS.SALES_AI_SUMMARIES_CREATE],
        commitRefs: ['feat(crm): add local AI call preparation'],
        translations: {
            de: {
                title: 'Mit sicheren Fakten ins Kundengespräch',
                description: 'Eine optionale lokale KI sortiert relevante Bestell-, Kontakt- und Klärhinweise für das Gespräch. Sie kann keine Fakten hinzufügen oder Prioritäten verändern; bei Fehlern steht sofort eine deterministische Vorbereitung bereit.',
            },
            en: {
                title: 'Enter customer calls with safe facts',
                description: 'Optional local AI orders relevant ordering, contact and resolution facts for the conversation. It cannot add facts or alter priorities, and a deterministic preparation is available immediately on failure.',
            },
            tr: {
                title: 'Müşteri görüşmesine güvenli olgularla girin',
                description: 'İsteğe bağlı yerel yapay zekâ sipariş, iletişim ve çözüm olgularını görüşme için sıralar. Olgu ekleyemez veya öncelikleri değiştiremez; hata halinde belirlenimsel hazırlık hemen sunulur.',
            },
            fr: {
                title: 'Aborder les appels client avec des faits sûrs',
                description: 'Une IA locale facultative ordonne les faits de commande, contact et résolution utiles. Elle ne peut ni ajouter de faits ni modifier les priorités; une préparation déterministe prend immédiatement le relais en cas d’échec.',
            },
            es: {
                title: 'Preparar llamadas con hechos seguros',
                description: 'Una IA local opcional ordena hechos de pedidos, contactos y asuntos pendientes. No puede añadir hechos ni cambiar prioridades; ante cualquier fallo se muestra de inmediato una preparación determinista.',
            },
            ru: {
                title: 'Готовьтесь к разговору на основе проверенных фактов',
                description: 'Необязательный локальный ИИ упорядочивает факты о заказах, контактах и нерешённых вопросах. Он не добавляет факты и не меняет приоритеты; при сбое сразу доступна детерминированная подготовка.',
            },
        },
    },
    {
        id: 'sales-rule-management',
        sequence: 56,
        version: '2026.9.29',
        publishedAt: '2026-09-04T14:00:00.000Z',
        category: 'NEW',
        linkUrl: '/settings/sales-rules',
        requiredAnyPermissions: [PERMISSIONS.SALES_RULES_VIEW],
        commitRefs: ['feat(admin): add sales recommendation rule management'],
        translations: {
            de: {
                title: 'Vertriebsregeln sicher prüfen und aktivieren',
                description: 'Die neue Regelverwaltung bündelt Schwellenwerte, Zielgruppen, Bestellrhythmen und automatische Läufe. Eine verpflichtende Simulation zeigt Wirkung, Konflikte und Verteilung, bevor eine Regel produktiv wird.',
            },
            en: {
                title: 'Review and activate sales rules safely',
                description: 'The new rule administration combines thresholds, audiences, reorder cadences and automatic runs. A mandatory simulation shows impact, conflicts and distribution before a rule goes live.',
            },
            tr: {
                title: 'Satış kurallarını güvenle inceleyin ve etkinleştirin',
                description: 'Yeni kural yönetimi eşikleri, hedef grupları, sipariş ritimlerini ve otomatik çalışmaları birleştirir. Zorunlu simülasyon, kural canlıya alınmadan önce etkiyi, çakışmaları ve dağılımı gösterir.',
            },
            fr: {
                title: 'Vérifier et activer les règles commerciales en sécurité',
                description: 'La gestion des règles réunit seuils, audiences, rythmes de commande et exécutions automatiques. Une simulation obligatoire présente impact, conflits et répartition avant activation.',
            },
            es: {
                title: 'Revise y active reglas comerciales con seguridad',
                description: 'La gestión de reglas reúne umbrales, públicos, ritmos de pedidos y ejecuciones automáticas. Una simulación obligatoria muestra impacto, conflictos y distribución antes de activar.',
            },
            ru: {
                title: 'Безопасная проверка и активация правил продаж',
                description: 'Управление правилами объединяет пороги, аудитории, ритмы заказов и автоматические запуски. Обязательная симуляция показывает влияние, конфликты и распределение до активации.',
            },
        },
    },
    {
        id: 'customer-contact-preferences',
        sequence: 57,
        version: '2026.9.30',
        publishedAt: '2026-09-04T14:30:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/sales-assistant',
        requiredAnyPermissions: [PERMISSIONS.SALES_ASSISTANT_USE],
        commitRefs: ['feat(crm): enforce customer contact preferences'],
        translations: {
            de: {
                title: 'Kontaktwünsche zuverlässig respektieren',
                description: 'Bevorzugte Wege und Zeiten sowie zeitlich begrenzte Kontakt- und Werbesperren gelten jetzt gemeinsam in Kundenpflege, Aufgaben, Vertriebstelefonie und Newsletter-Versand.',
            },
            en: {
                title: 'Respect contact preferences reliably',
                description: 'Preferred channels and times, including time-limited contact and marketing restrictions, now apply consistently to customer care, tasks, sales calls, and newsletter delivery.',
            },
            tr: {
                title: 'İletişim tercihlerini güvenle uygulayın',
                description: 'Tercih edilen kanal ve saatler ile süreli iletişim ve pazarlama kısıtlamaları artık müşteri bakımı, görevler, satış aramaları ve bülten gönderiminde birlikte uygulanır.',
            },
            fr: {
                title: 'Respecter fiablement les préférences de contact',
                description: 'Les canaux et horaires préférés, ainsi que les restrictions temporaires de contact et de marketing, s’appliquent désormais au suivi client, aux tâches, aux appels et aux newsletters.',
            },
            es: {
                title: 'Respete de forma fiable las preferencias de contacto',
                description: 'Los canales y horarios preferidos, junto con las restricciones temporales de contacto y marketing, se aplican ahora a la atención, tareas, llamadas y envíos de boletines.',
            },
            ru: {
                title: 'Надёжно соблюдайте предпочтения связи',
                description: 'Предпочтительные каналы и время, включая временные запреты контактов и маркетинга, теперь единообразно действуют в работе с клиентом, задачах, звонках и рассылках.',
            },
        },
    },
    {
        id: 'sales-assistant-performance-insights',
        sequence: 58,
        version: '2026.10.1',
        publishedAt: '2026-09-04T15:00:00.000Z',
        category: 'NEW',
        linkUrl: '/sales-assistant/analytics',
        requiredAnyPermissions: [PERMISSIONS.SALES_ASSISTANT_USE],
        commitRefs: ['feat(analytics): add sales assistant performance insights'],
        translations: {
            de: {
                title: 'Kundenpflege transparent auswerten',
                description: 'Die neue Auswertung macht Reaktionszeiten, Regelqualität, Teamlast und zeitlich zugeordnete Aufträge nachvollziehbar. Sie erklärt ihre Datengrundlage und behauptet weder Kausalität noch überwacht sie Bildschirmaktivitäten.',
            },
            en: {
                title: 'Review customer-care impact transparently',
                description: 'The new analysis explains response times, rule quality, team workload, and temporally attributed orders. It discloses its data basis, claims no causality, and does not monitor screen activity.',
            },
            tr: {
                title: 'Müşteri bakım etkisini şeffaf biçimde inceleyin',
                description: 'Yeni analiz tepki sürelerini, kural kalitesini, ekip iş yükünü ve zamansal olarak ilişkilendirilen siparişleri açıklar. Veri temelini gösterir, nedensellik iddia etmez ve ekran etkinliğini izlemez.',
            },
            fr: {
                title: 'Analyser l’impact du suivi client en toute transparence',
                description: 'La nouvelle analyse explique délais de réaction, qualité des règles, charge des équipes et commandes attribuées dans le temps. Elle expose ses données, sans causalité ni surveillance d’écran.',
            },
            es: {
                title: 'Evalúe de forma transparente el impacto de la atención',
                description: 'El nuevo análisis explica tiempos de reacción, calidad de reglas, carga del equipo y pedidos atribuidos temporalmente. Expone sus datos, no afirma causalidad ni supervisa la pantalla.',
            },
            ru: {
                title: 'Прозрачно оценивайте работу с клиентами',
                description: 'Новый анализ объясняет время реакции, качество правил, нагрузку команд и временно связанные заказы. Он раскрывает основу данных, не утверждает причинность и не следит за экраном.',
            },
        },
    },
    {
        id: 'configurable-customer-data-document-headers',
        sequence: 59,
        version: '2026.10.2',
        publishedAt: '2026-09-06T12:00:00.000Z',
        category: 'NEW',
        linkUrl: '/sales/all',
        requiredAnyPermissions: [PERMISSIONS.DOCUMENT_CUSTOMER_HEADER_READ],
        commitRefs: [
            '0b41c8a',
            '16f5737',
            '97b5c19',
            'a4f0929',
            'e477b65',
            '7dcf9d1',
            'c002250',
            'b48ada6',
            '03f698e',
        ],
        translations: {
            de: {
                title: 'Kundendaten sicher im Belegkopf anzeigen',
                description: 'Ausgewählte Stammdaten und Zusatzfelder lassen sich je Belegart übersichtlich anordnen. Historische Werte bleiben eingefroren; PDF und Kundenportal zeigen ausschließlich ausdrücklich freigegebene Angaben.',
            },
            en: {
                title: 'Show customer data safely in document headers',
                description: 'Selected master data and custom fields can be arranged clearly for each document type. Historical values stay frozen, while PDFs and the customer portal show only explicitly approved information.',
            },
            tr: {
                title: 'Müşteri verilerini belge başlığında güvenle gösterin',
                description: 'Seçilen ana veriler ve ek alanlar her belge türü için anlaşılır biçimde düzenlenebilir. Tarihsel değerler sabit kalır; PDF ve müşteri portalı yalnızca açıkça onaylanan bilgileri gösterir.',
            },
            fr: {
                title: 'Afficher les données client en sécurité dans l’en-tête',
                description: 'Les données de base et champs personnalisés sélectionnés s’organisent clairement par type de document. Les valeurs historiques restent figées; PDF et portail ne montrent que les informations explicitement autorisées.',
            },
            es: {
                title: 'Muestre datos del cliente de forma segura en la cabecera',
                description: 'Los datos maestros y campos personalizados seleccionados se organizan por tipo de documento. Los valores históricos permanecen fijos; el PDF y el portal solo muestran información autorizada expresamente.',
            },
            ru: {
                title: 'Безопасно показывайте данные клиента в заголовке',
                description: 'Выбранные реквизиты и дополнительные поля настраиваются отдельно для каждого типа документа. Исторические значения остаются неизменными, а PDF и портал показывают только явно разрешённые сведения.',
            },
        },
    },
    {
        id: 'reliable-contextual-help',
        sequence: 60,
        version: '2026.10.3',
        publishedAt: '2026-09-09T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/?help=getting-started.navigation',
        requiredAnyPermissions: [],
        commitRefs: ['fix(help): restore contextual help content and fallbacks'],
        translations: {
            de: {
                title: 'Hilfe ist wieder zuverlässig erreichbar',
                description: 'Kontextartikel, Suche und Themennavigation laden wieder vollständig. Fehlende Übersetzungen und leere Rollenansichten werden verständlich aufgefangen.',
            },
            en: {
                title: 'Help is reliably available again',
                description: 'Context articles, search, and topic navigation load completely again. Missing translations and empty role views now have clear fallbacks.',
            },
            tr: {
                title: 'Yardım yeniden güvenilir biçimde erişilebilir',
                description: 'Bağlam makaleleri, arama ve konu gezintisi yeniden eksiksiz yüklenir. Eksik çeviriler ve boş rol görünümleri açıkça ele alınır.',
            },
            fr: {
                title: 'L’aide est à nouveau disponible de façon fiable',
                description: 'Les articles contextuels, la recherche et les rubriques se chargent à nouveau entièrement. Des replis clairs couvrent les traductions et vues manquantes.',
            },
            es: {
                title: 'La ayuda vuelve a estar disponible de forma fiable',
                description: 'Los artículos contextuales, la búsqueda y los temas vuelven a cargarse por completo. Las traducciones y vistas vacías tienen alternativas claras.',
            },
            ru: {
                title: 'Справка снова доступна надёжно',
                description: 'Контекстные статьи, поиск и навигация по темам снова загружаются полностью. Для отсутствующих переводов и пустых представлений предусмотрены понятные замены.',
            },
        },
    },
    {
        id: 'quick-customer-creation',
        sequence: 61,
        version: '2026.10.4',
        publishedAt: '2026-09-09T00:10:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/partners/customers',
        requiredAnyPermissions: [PERMISSIONS.CUSTOMER_WRITE],
        commitRefs: ['feat(customers): simplify customer creation'],
        translations: {
            de: {
                title: 'Kunden mit wenigen Angaben anlegen',
                description: 'Rolle und Name genügen für den Start. Mandantenstandards werden automatisch übernommen; Adresse, Kontakt und Abrechnung lassen sich sofort oder später ergänzen.',
            },
            en: {
                title: 'Create customers with fewer details',
                description: 'A role and name are enough to start. Tenant defaults are applied automatically, while address, contact, and billing details can be added now or later.',
            },
            tr: {
                title: 'Müşterileri daha az bilgiyle oluşturun',
                description: 'Başlangıç için rol ve ad yeterlidir. Kiracı varsayılanları otomatik uygulanır; adres, iletişim ve faturalama şimdi veya daha sonra eklenebilir.',
            },
            fr: {
                title: 'Créer des clients avec peu d’informations',
                description: 'Un rôle et un nom suffisent. Les valeurs du mandant sont reprises automatiquement; adresse, contact et facturation peuvent être complétés maintenant ou plus tard.',
            },
            es: {
                title: 'Cree clientes con pocos datos',
                description: 'Bastan un rol y un nombre. Los valores del tenant se aplican automáticamente; dirección, contacto y facturación pueden añadirse ahora o después.',
            },
            ru: {
                title: 'Создавайте клиентов с минимумом данных',
                description: 'Для начала достаточно роли и имени. Настройки клиента применяются автоматически, а адрес, контакты и расчёты можно заполнить сразу или позже.',
            },
        },
    },
    {
        id: 'preferred-document-language',
        sequence: 62,
        version: '2026.10.5',
        publishedAt: '2026-09-09T00:20:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/partners/customers',
        requiredAnyPermissions: [PERMISSIONS.CUSTOMER_WRITE],
        commitRefs: ['feat(customers): add preferred document language selection'],
        translations: {
            de: {
                title: 'Belegsprache verständlich auswählen',
                description: 'Kunden erhalten eine klar benannte Sprachauswahl. Neue Belege, PDFs und E-Mails übernehmen sie als unveränderlichen Snapshot mit sichtbarem Vorlagen-Fallback.',
            },
            en: {
                title: 'Choose document language clearly',
                description: 'Customers now have a clearly named language selector. New documents, PDFs, and emails copy it into an immutable snapshot with a visible template fallback.',
            },
            tr: {
                title: 'Belge dilini açıkça seçin',
                description: 'Müşteriler için anlaşılır bir dil seçimi sunulur. Yeni belgeler, PDF’ler ve e-postalar bunu görünür şablon geri dönüşüyle değişmez anlık görüntü olarak alır.',
            },
            fr: {
                title: 'Choisir clairement la langue des documents',
                description: 'Une sélection explicite est disponible pour chaque client. Les nouveaux documents, PDF et e-mails la copient dans un instantané immuable avec un repli visible.',
            },
            es: {
                title: 'Elija claramente el idioma de los documentos',
                description: 'Cada cliente dispone de una selección clara. Los nuevos documentos, PDF y correos la copian en una instantánea inmutable con alternativa visible.',
            },
            ru: {
                title: 'Понятно выбирайте язык документов',
                description: 'Для клиента доступен понятный выбор языка. Новые документы, PDF и письма сохраняют его в неизменяемом снимке с видимым запасным шаблоном.',
            },
        },
    },
    {
        id: 'unified-payment-terms',
        sequence: 63,
        version: '2026.10.6',
        publishedAt: '2026-09-09T00:30:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/partners/customers',
        requiredAnyPermissions: [PERMISSIONS.CUSTOMER_WRITE],
        commitRefs: ['feat(customers): unify payment terms and due dates'],
        translations: {
            de: {
                title: 'Zahlungsbedingungen eindeutig pflegen',
                description: 'Eine durchsuchbare Regelauswahl ersetzt unklare Tagesangaben. Belege berechnen die Fälligkeit und bewahren Kondition, Fristen und Skonto als historischen Snapshot.',
            },
            en: {
                title: 'Maintain payment terms consistently',
                description: 'A searchable rule selector replaces ambiguous day fields. Documents calculate due dates and preserve the rule, deadlines, and discount as a historical snapshot.',
            },
            tr: {
                title: 'Ödeme koşullarını tutarlı yönetin',
                description: 'Aranabilir kural seçimi belirsiz gün alanlarının yerini alır. Belgeler vade tarihini hesaplar ve kuralı, süreleri ve iskontoyu tarihsel anlık görüntü olarak korur.',
            },
            fr: {
                title: 'Gérer clairement les conditions de paiement',
                description: 'Une règle consultable remplace les champs de jours ambigus. Les documents calculent l’échéance et conservent règle, délais et escompte comme instantané historique.',
            },
            es: {
                title: 'Gestione claramente las condiciones de pago',
                description: 'Una regla con búsqueda sustituye los campos de días ambiguos. Los documentos calculan el vencimiento y conservan regla, plazos y descuento como instantánea histórica.',
            },
            ru: {
                title: 'Однозначно управляйте условиями оплаты',
                description: 'Поиск по правилам заменяет неясные поля дней. Документы рассчитывают срок оплаты и сохраняют правило, сроки и скидку в историческом снимке.',
            },
        },
    },
    {
        id: 'postcode-city-region-resolution',
        sequence: 64,
        version: '2026.10.7',
        publishedAt: '2026-09-09T00:40:00.000Z',
        category: 'NEW',
        linkUrl: '/partners/customers',
        requiredAnyPermissions: [PERMISSIONS.CUSTOMER_WRITE],
        commitRefs: ['feat(addresses): add postcode city and region resolution'],
        translations: {
            de: {
                title: 'Ort und Region aus der PLZ vorschlagen',
                description: 'Adressformulare schlagen für deutsche und französische Postleitzahlen passende Orte und Regionen vor. Mehrdeutige Treffer bleiben auswählbar, die manuelle Eingabe jederzeit erhalten.',
            },
            en: {
                title: 'Suggest city and region from the postcode',
                description: 'Address forms suggest matching cities and regions for German and French postcodes. Ambiguous results remain selectable and manual entry is always available.',
            },
            tr: {
                title: 'Posta kodundan şehir ve bölge önerin',
                description: 'Adres formları Alman ve Fransız posta kodları için uygun şehir ve bölgeleri önerir. Birden fazla sonuç seçilebilir kalır ve elle giriş her zaman kullanılabilir.',
            },
            fr: {
                title: 'Proposer commune et région à partir du code postal',
                description: 'Les formulaires proposent communes et régions pour les codes postaux allemands et français. Les résultats ambigus restent au choix et la saisie manuelle demeure disponible.',
            },
            es: {
                title: 'Sugiera ciudad y región desde el código postal',
                description: 'Los formularios sugieren ciudades y regiones para códigos postales alemanes y franceses. Los resultados ambiguos siguen siendo seleccionables y siempre se permite la entrada manual.',
            },
            ru: {
                title: 'Предлагайте город и регион по индексу',
                description: 'Формы адресов предлагают города и регионы для немецких и французских индексов. Неоднозначные результаты можно выбрать, а ручной ввод всегда доступен.',
            },
        },
    },
    {
        id: 'correct-vies-company-name-validation',
        sequence: 65,
        version: '2026.10.8',
        publishedAt: '2026-09-09T00:50:00.000Z',
        category: 'FIXED',
        linkUrl: '/partners/customers',
        requiredAnyPermissions: [PERMISSIONS.VAT_VALIDATION_READ],
        commitRefs: ['fix(tax): correct VIES company name validation'],
        translations: {
            de: {
                title: 'VIES-Namen korrekt und transparent vergleichen',
                description: 'Der tatsächlich gemeldete Name bleibt unverändert sichtbar. Eine getrennte Vergleichsansicht erklärt Übereinstimmungen, Abweichungen und fehlende Angaben, ohne Stammdaten zu überschreiben.',
            },
            en: {
                title: 'Compare VIES names correctly and transparently',
                description: 'The name actually reported remains visible unchanged. A separate comparison view explains matches, differences, and missing details without overwriting master data.',
            },
            tr: {
                title: 'VIES adlarını doğru ve şeffaf karşılaştırın',
                description: 'Gerçekte bildirilen ad değiştirilmeden görünür kalır. Ayrı karşılaştırma görünümü, ana verilerin üzerine yazmadan eşleşmeleri, farkları ve eksik bilgileri açıklar.',
            },
            fr: {
                title: 'Comparer les noms VIES correctement et clairement',
                description: 'Le nom réellement renvoyé reste visible sans modification. Une vue séparée explique concordances, écarts et données absentes sans écraser les données de base.',
            },
            es: {
                title: 'Compare nombres VIES de forma correcta y transparente',
                description: 'El nombre realmente devuelto permanece visible sin cambios. Una vista separada explica coincidencias, diferencias y datos ausentes sin sobrescribir los datos maestros.',
            },
            ru: {
                title: 'Сравнивайте названия VIES правильно и прозрачно',
                description: 'Фактически полученное название остаётся видимым без изменений. Отдельное сравнение объясняет совпадения, различия и отсутствие данных, не заменяя основные сведения.',
            },
        },
    },
    {
        id: 'explainable-intra-community-tax-determination',
        sequence: 66,
        version: '2026.10.9',
        publishedAt: '2026-09-09T23:45:00.000Z',
        category: 'NEW',
        linkUrl: '/documents',
        requiredAnyPermissions: [PERMISSIONS.DOCUMENT_READ],
        commitRefs: ['feat(tax): add explainable intra-community supply determination'],
        translations: {
            de: {
                title: 'Steuerempfehlungen im Beleg nachvollziehen',
                description: 'Lieferziel, Belegdatum, Warenart, VIES- und Versandnachweise fließen gemeinsam in eine erklärte Empfehlung ein. Offene Prüfungen und begründete Abweichungen bleiben revisionssicher sichtbar.',
            },
            en: {
                title: 'Understand document tax recommendations',
                description: 'Destination, document date, supply type, VIES and shipping evidence now produce one explained recommendation. Outstanding checks and reasoned overrides remain auditable.',
            },
            tr: {
                title: 'Belge vergi önerilerini anlayın',
                description: 'Teslimat yeri, belge tarihi, mal türü, VIES ve sevk kanıtları açıklanmış tek öneride birleşir. Açık kontroller ve gerekçeli sapmalar denetlenebilir kalır.',
            },
            fr: {
                title: 'Comprendre les recommandations fiscales des documents',
                description: 'Destination, date, nature de la livraison, preuves VIES et transport produisent une recommandation expliquée. Les contrôles ouverts et dérogations motivées restent auditables.',
            },
            es: {
                title: 'Comprenda las recomendaciones fiscales del documento',
                description: 'Destino, fecha, tipo de entrega y pruebas VIES y de transporte forman una recomendación explicada. Los controles y excepciones justificadas quedan auditables.',
            },
            ru: {
                title: 'Понимайте налоговые рекомендации документов',
                description: 'Страна поставки, дата, вид поставки, доказательства VIES и перевозки формируют объяснённую рекомендацию. Открытые проверки и обоснованные отклонения сохраняются для аудита.',
            },
        },
    },
    {
        id: 'russian-language-retired',
        sequence: 67,
        version: '2026.10.10',
        publishedAt: '2026-09-10T00:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/settings/profile',
        requiredAnyPermissions: [],
        commitRefs: ['chore(i18n): retire Russian as supported language'],
        translations: {
            de: {
                title: 'Aktive Sprachauswahl vereinheitlicht',
                description: 'Profile, Belege, Portal, Hilfe und Übersetzungen verwenden jetzt dieselben fünf aktiven Sprachen. Bestehende historische Inhalte bleiben unverändert lesbar.',
            },
            en: {
                title: 'Active language choices aligned',
                description: 'Profiles, documents, portal, help and translations now use the same five active languages. Existing historic content remains readable without alteration.',
            },
            tr: {
                title: 'Etkin dil seçimleri birleştirildi',
                description: 'Profiller, belgeler, portal, yardım ve çeviriler artık aynı beş etkin dili kullanır. Mevcut geçmiş içerik değiştirilmeden okunabilir kalır.',
            },
            fr: {
                title: 'Choix des langues actives harmonisés',
                description: 'Profils, documents, portail, aide et traductions utilisent désormais les mêmes cinq langues actives. Les contenus historiques restent lisibles sans modification.',
            },
            es: {
                title: 'Opciones de idioma activas unificadas',
                description: 'Perfiles, documentos, portal, ayuda y traducciones usan ahora los mismos cinco idiomas activos. El contenido histórico sigue siendo legible sin cambios.',
            },
        },
    },
    {
        id: 'document-custom-fields-visible',
        sequence: 68,
        version: '2026.10.11',
        publishedAt: '2026-09-10T00:10:00.000Z',
        category: 'FIXED',
        linkUrl: '/documents',
        requiredAnyPermissions: [PERMISSIONS.DOCUMENT_READ],
        commitRefs: ['fix(custom-fields): render document and product fields correctly'],
        translations: {
            de: {
                title: 'Zusatzfelder zuverlässig im Beleg bearbeiten',
                description: 'Belegfelder stehen im Belegkopf bereit, Artikel- und Positionsfelder als konfigurierbare Tabellenspalten. Formeln, Übersetzungen, historische Werte und externe PDF-Freigaben bleiben dabei nachvollziehbar getrennt.',
            },
            en: {
                title: 'Edit custom fields reliably in documents',
                description: 'Document fields are available in the header, while product and item fields appear as configurable table columns. Formulas, translations, historic values, and external PDF approval remain clearly separated.',
            },
            tr: {
                title: 'Özel alanları belgelerde güvenilir biçimde düzenleyin',
                description: 'Belge alanları üst bilgide, ürün ve satır alanları yapılandırılabilir tablo sütunlarında yer alır. Formüller, çeviriler, geçmiş değerler ve harici PDF izinleri açıkça ayrı tutulur.',
            },
            fr: {
                title: 'Modifier fiablement les champs personnalisés des documents',
                description: 'Les champs du document sont disponibles dans l’en-tête, ceux des articles et lignes dans des colonnes configurables. Formules, traductions, valeurs historiques et autorisations PDF externes restent clairement séparées.',
            },
            es: {
                title: 'Edite con fiabilidad los campos personalizados del documento',
                description: 'Los campos del documento están en la cabecera y los de producto y línea, en columnas configurables. Fórmulas, traducciones, valores históricos y permisos externos de PDF permanecen claramente separados.',
            },
        },
    },
    {
        id: 'operational-dashboard',
        sequence: 69,
        version: '2026.10.12',
        publishedAt: '2026-09-10T00:20:00.000Z',
        category: 'NEW',
        linkUrl: '/',
        requiredAnyPermissions: [PERMISSIONS.REPORT_READ],
        commitRefs: ['feat(dashboard): add operational insights and activity feed'],
        translations: {
            de: {
                title: 'Operatives Dashboard mit echten Arbeitsdaten',
                description: 'Rollenbezogene Kennzahlen, Aktivitäten, Produkthinweise und zulässige Teamwerte lassen sich nach Zeitraum vergleichen und öffnen direkt die passende Arbeitsliste.',
            },
            en: {
                title: 'Operational dashboard with live business data',
                description: 'Role-based metrics, activities, product insights, and permitted team values can be compared over time and open the relevant worklist directly.',
            },
            tr: {
                title: 'Gerçek iş verileriyle operasyon panosu',
                description: 'Role bağlı göstergeler, etkinlikler, ürün ipuçları ve izin verilen ekip değerleri dönemlere göre karşılaştırılır ve ilgili iş listesini doğrudan açar.',
            },
            fr: {
                title: 'Tableau de bord opérationnel fondé sur les données réelles',
                description: 'Indicateurs selon le rôle, activités, informations produit et valeurs d’équipe autorisées se comparent par période et ouvrent directement la liste de travail concernée.',
            },
            es: {
                title: 'Panel operativo con datos empresariales reales',
                description: 'Los indicadores por rol, actividades, avisos de producto y valores de equipo permitidos se comparan por periodo y abren directamente la lista de trabajo correspondiente.',
            },
        },
    },
    {
        id: 'backup-center-and-restore',
        sequence: 70,
        version: '2026.10.13',
        publishedAt: '2026-09-10T00:30:00.000Z',
        category: 'NEW',
        linkUrl: '/admin/backups',
        requiredAnyPermissions: [PERMISSIONS.BACKUP_VIEW],
        commitRefs: [
            'feat(backups): add configurable backup center',
            'feat(backups): add validated backup restore workflow',
            'feat(deploy): require verified backup before deployment',
            'feat(backups): secure backup permissions and auditing',
        ],
        translations: {
            de: {
                title: 'Sicheres Backup-Center mit geprüfter Wiederherstellung',
                description: 'Einstellungen, Stammdaten oder das vollständige System lassen sich verschlüsselt sichern. Trockenlauf, Konfliktprüfung, Rechte und ein zwingender Sicherungspunkt schützen Wiederherstellung und Bereitstellung.',
            },
            en: {
                title: 'Secure backup center with validated restore',
                description: 'Settings, master data, or the complete system can be backed up with encryption. Dry runs, conflict checks, permissions, and a mandatory safety point protect restores and deployments.',
            },
            tr: {
                title: 'Doğrulanmış geri yüklemeli güvenli yedekleme merkezi',
                description: 'Ayarlar, ana veriler veya tüm sistem şifreli olarak yedeklenir. Kuru çalışma, çakışma denetimi, izinler ve zorunlu güvenlik noktası geri yükleme ile dağıtımı korur.',
            },
            fr: {
                title: 'Centre de sauvegarde sécurisé avec restauration validée',
                description: 'Paramètres, données de base ou système complet sont sauvegardés sous chiffrement. Essai à blanc, contrôle des conflits, droits et point de sécurité obligatoire protègent restauration et déploiement.',
            },
            es: {
                title: 'Centro seguro de copias con restauración validada',
                description: 'La configuración, los datos maestros o el sistema completo se guardan cifrados. La simulación, los conflictos, los permisos y un punto de seguridad obligatorio protegen la restauración y el despliegue.',
            },
        },
    },
    {
        id: 'tenant-feature-management',
        sequence: 71,
        version: '2026.10.14',
        publishedAt: '2026-09-13T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/admin/features',
        requiredAnyPermissions: [PERMISSIONS.FEATURES_READ],
        commitRefs: [
            'feat(platform): add typed feature catalogue',
            'feat(platform): add tenant feature configuration',
            'feat(platform): add feature dependency impact analysis',
            'feat(api): enforce tenant feature availability',
            'fix(platform): enforce maintenance mode',
            'feat(web): apply feature availability across the interface',
            'feat(admin): add feature management console',
            'feat(workers): respect tenant feature configuration',
            'feat(backups): include feature configuration in settings backups',
        ],
        translations: {
            de: {
                title: 'Funktionen und Module sicher je Mandant steuern',
                description: 'Administratoren aktivieren optionale Module mit Abhängigkeits- und Auswirkungsprüfung. Abschalten stoppt Oberfläche, API und Hintergrundarbeit gemeinsam, ohne Daten oder historische Nachweise zu löschen.',
            },
            en: {
                title: 'Safely control features and modules per tenant',
                description: 'Administrators enable optional modules with dependency and impact checks. Disabling stops the interface, API, and background work together without deleting data or historic evidence.',
            },
            tr: {
                title: 'Özellikleri ve modülleri kiracı bazında güvenle yönetin',
                description: 'Yöneticiler isteğe bağlı modülleri bağımlılık ve etki denetimiyle açar. Kapatma; verileri veya geçmiş kanıtları silmeden arayüzü, API’yi ve arka plan işlerini birlikte durdurur.',
            },
            fr: {
                title: 'Piloter les fonctions et modules en sécurité par tenant',
                description: 'Les administrateurs activent les modules optionnels après contrôle des dépendances et impacts. La désactivation arrête interface, API et tâches de fond sans supprimer données ni preuves historiques.',
            },
            es: {
                title: 'Controle funciones y módulos de forma segura por tenant',
                description: 'Los administradores activan módulos opcionales tras revisar dependencias e impacto. Desactivar detiene interfaz, API y trabajos en segundo plano sin borrar datos ni pruebas históricas.',
            },
        },
    },
    {
        id: 'introduction-readiness-review',
        sequence: 72,
        version: '2026.9.0',
        publishedAt: '2026-09-16T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/settings/introduction',
        requiredAnyPermissions: ['introduction:manage'],
        commitRefs: ['introduction-readiness-working-tree'],
        translations: {
            de: {
                title: 'Einführung vorprüfen',
                description: 'Die Einführungs-Vorprüfung zeigt vorhandene Daten und Sperren je Mandant. Aktivierung und Bereinigung bleiben bis zur vollständigen Sicherheitsabnahme gesperrt.',
            },
            en: {
                title: 'Review introduction readiness',
                description: 'The introduction readiness review shows existing data and blockers for each tenant. Activation and cleanup remain blocked until full safety acceptance.',
            },
            tr: {
                title: 'Devreye alma hazırlığını inceleme',
                description: 'Devreye alma ön incelemesi kiracıya ait mevcut verileri ve engelleri gösterir. Etkinleştirme ve temizleme tam güvenlik kabulüne kadar engellenir.',
            },
            fr: {
                title: 'Vérifier la mise en service',
                description: 'L’examen préalable affiche les données existantes et les blocages par tenant. L’activation et le nettoyage restent bloqués jusqu’à la validation complète de sécurité.',
            },
            es: {
                title: 'Revisar la puesta en marcha',
                description: 'La revisión previa muestra los datos existentes y los bloqueos de cada tenant. La activación y la limpieza siguen bloqueadas hasta la validación completa de seguridad.',
            },
        },
    },
    {
        id: 'partial-partner-updates-preserve-data',
        sequence: 73,
        version: '2026.9.1',
        publishedAt: '2026-09-26T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/admin/data-hub',
        requiredAnyPermissions: ['imports:read'],
        commitRefs: ['ERP-QA-AP05', 'ERP-QA-AP02'],
        translations: {
            de: {
                title: 'Gezielte Stammdatenänderungen',
                description: 'Teiländerungen an Kunden, Interessenten und Lieferanten erhalten alle ausgelassenen Angaben. Bei Änderungsimporten bleiben nicht zugeordnete Felder und standardmäßig leere Zellen erhalten. Im Mapping kann für leere Zellen ausdrücklich das Löschen optionaler Werte gewählt werden; der Testlauf zeigt dafür null. Pflichtfelder können nicht gelöscht werden.',
            },
            en: {
                title: 'Targeted master data changes',
                description: 'Partial changes to customers, prospects and suppliers preserve omitted details. Update imports preserve unmapped fields and, by default, empty cells. Mapping can explicitly clear optional values for empty cells; the dry run shows null for these values. Required fields cannot be cleared.',
            },
            fr: {
                title: 'Modifications ciblées des données',
                description: 'Les modifications partielles des clients, prospects et fournisseurs conservent les données omises. Les imports de mise à jour préservent les champs non associés et, par défaut, les cellules vides. Le mapping permet de choisir explicitement de vider les valeurs facultatives ; le test affiche alors null. Les champs obligatoires ne peuvent pas être effacés.',
            },
            es: {
                title: 'Cambios específicos de datos',
                description: 'Los cambios parciales de clientes, clientes potenciales y proveedores conservan los datos omitidos. Las importaciones de actualización conservan los campos sin asignar y, por defecto, las celdas vacías. El mapeo permite borrar expresamente valores opcionales cuando la celda está vacía; la simulación muestra null. No se pueden borrar campos obligatorios.',
            },
            tr: {
                title: 'Ana verilerde hedefli değişiklikler',
                description: 'Müşteri, potansiyel müşteri ve tedarikçilerdeki kısmi değişiklikler gönderilmeyen bilgileri korur. Güncelleme içe aktarımları eşlenmeyen alanları ve varsayılan olarak boş hücreleri korur. Eşlemede boş hücreler için isteğe bağlı değerlerin silinmesi açıkça seçilebilir; deneme çalışması null gösterir. Zorunlu alanlar silinemez.',
            },
        },
    },
    {
        id: 'reliable-document-import-backup',
        sequence: 74,
        version: '2026.9.2',
        publishedAt: '2026-09-26T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/admin/data-hub',
        requiredAnyPermissions: ['imports:read'],
        commitRefs: [
            'ERP-QA-AP01',
            'ERP-QA-QU01',
            'ERP-QA-QU02',
            'ERP-QA-UI01',
            'ERP-QA-AP04',
            'ERP-QA-AP06',
            'ERP-QA-AP07',
            'ERP-QA-QU06',
            'ERP-QA-QU07',
            'ERP-QA-OP01',
            'ERP-QA-OP02',
        ],
        translations: {
            de: {
                title: 'Verlässliche Übernahmen, Importe und Ausdrucke',
                description: 'Belegübernahmen schützen vor doppelter Wirkung bei Doppelklick und Wiederholung; erlaubte Teilmengen bleiben möglich. Positionsrabatte werden nach der Mengenberechnung gerundet, Gesamtrabatte centgenau ohne negative Positionsrabatte verteilt. Importe bieten bestehende Zusatzfelder an, verarbeiten lokalisierte Werte und berücksichtigen Mandantensprache und Währung bei neuen Kunden. Rechteänderungen wirken auf bestehende Sitzungen. Einkaufs-PDFs verwenden Sprache, Vorlage und freigegebene Lieferantenfelder. Vollbackups prüfen die DB-/DMS-Zuordnung und Dateihashes. Der Hostmonitor startet auch bei Symlinkinstallationen. Änderungen an Stammdaten berechnen finalisierte Belege nicht neu.',
            },
            en: {
                title: 'Reliable conversions, imports and printouts',
                description: 'Document conversion prevents duplicate effects from double clicks and retries while allowing partial quantities. Line discounts round after quantity calculation; overall discounts are allocated to cents without negative line discounts. Imports offer existing custom fields, normalize localized values and use tenant language and currency for new customers. Permission changes affect existing sessions. Purchase PDFs use the selected language, template and approved supplier fields. Full backups verify database/DMS references and file hashes. The host monitor also starts through symlinks. Master data changes do not recalculate finalized documents.',
            },
            fr: {
                title: 'Conversions, imports et impressions fiables',
                description: 'Les conversions évitent les doublons lors des doubles clics et des reprises, tout en permettant les quantités partielles. Les remises de ligne sont arrondies après calcul des quantités ; les remises globales sont réparties au centime sans remise négative. Les imports proposent les champs existants, normalisent les valeurs locales et appliquent la langue et la devise du tenant aux nouveaux clients. Les changements de droits affectent les sessions ouvertes. Les PDF d’achat utilisent la langue, le modèle et les champs fournisseur autorisés. Les sauvegardes complètes vérifient les liens base/DMS et les empreintes des fichiers. Le moniteur démarre aussi via les liens symboliques. Les documents finalisés ne sont pas recalculés après modification des données de base.',
            },
            es: {
                title: 'Conversiones, importaciones e impresiones fiables',
                description: 'Las conversiones evitan duplicados por doble clic o reintentos y permiten cantidades parciales. Los descuentos de línea se redondean tras calcular las cantidades; el descuento global se distribuye por céntimos sin descuentos negativos. Las importaciones ofrecen campos existentes, normalizan valores locales y aplican el idioma y la moneda del cliente empresarial a nuevos clientes. Los cambios de permisos afectan a las sesiones abiertas. Los PDF de compra usan el idioma, la plantilla y los campos autorizados del proveedor. Las copias completas verifican referencias entre base de datos y DMS y hashes de archivos. El monitor también arranca mediante enlaces simbólicos. Los documentos finalizados no se recalculan al cambiar datos maestros.',
            },
            tr: {
                title: 'Güvenilir aktarımlar, içe aktarımlar ve çıktılar',
                description: 'Belge dönüşümleri çift tıklama ve yeniden denemede yinelenen işlemleri önler; kısmi miktarlar desteklenir. Satır indirimi miktar hesabından sonra yuvarlanır, genel indirim negatif satır indirimi oluşturmadan kuruş düzeyinde dağıtılır. İçe aktarma mevcut özel alanları sunar, yerel değerleri dönüştürür ve yeni müşteriler için firma dilini ve para birimini kullanır. Yetki değişiklikleri açık oturumlarda etkilidir. Satın alma PDF’leri dil, şablon ve izin verilen tedarikçi alanlarını kullanır. Tam yedekler veritabanı/DMS ilişkilerini ve dosya özetlerini doğrular. Sunucu izleyicisi sembolik bağlantılarla da başlar. Ana veri değişiklikleri kesinleşmiş belgeleri yeniden hesaplamaz.',
            },
        },
    },
    {
        id: 'validated-entries-readable-printouts',
        sequence: 75,
        version: '2026.9.3',
        publishedAt: '2026-09-26T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/documents',
        requiredAnyPermissions: ['document:read'],
        commitRefs: [
            'ERP-QA-AP03',
            'ERP-QA-QU04',
            'ERP-QA-QU05',
            'ERP-QA-UI02',
            'ERP-QA-UI03',
            'ERP-QA-PDF01',
            'ERP-QA-PDF02',
            'ERP-QA-PDF03',
            'ERP-QA-OP03',
            'ERP-QA-REMEDIATION-R01',
        ],
        translations: {
            de: {
                title: 'Eingaben und Ausdrucke sicher prüfen',
                description: 'Datumsfelder verlangen gültige Kalendertage, Ganzzahlfelder lehnen Bruchteile ab. Ungespeicherte Partneränderungen werden vor dem Schließen abgefragt. Bestellpositionen erlauben leere Zwischenwerte und Dezimalkommas; auf kleinen Bildschirmen bleiben die Angaben lesbar. WhatsApp-Aktionen benötigen ein aktives, konfiguriertes Modul und passende Rechte. Lange Artikelnummern bleiben in ihrer Zelle, Tabellenköpfe wiederholen sich auf Folgeseiten. Eingebettete Ersatzschriften erhalten türkische und japanische Zeichen. Die Backup-Retention berücksichtigt Sicherungen vor Änderungen samt Prüfsummen und bewahrt den Mindestbestand. Nachgeladene Artikelpreise erhalten zwischenzeitliche Eingaben und berücksichtigen die aktuelle Menge.',
            },
            en: {
                title: 'Check entries and printouts safely',
                description: 'Date fields require valid calendar dates and integer fields reject fractions. Unsaved partner changes prompt before closing. Purchase order lines allow empty intermediate values and decimal commas, with readable layouts on small screens. WhatsApp actions require an enabled, configured module and appropriate permissions. Long article numbers stay inside their cells and table headers repeat on continuation pages. Embedded fallback fonts preserve Turkish and Japanese characters. Backup retention includes archives created before changes and their checksums while retaining the minimum count. Delayed article prices preserve intervening edits and use the current quantity.',
            },
            fr: {
                title: 'Vérifier les saisies et les impressions',
                description: 'Les dates doivent être valides et les champs entiers refusent les fractions. Les modifications de partenaire non enregistrées demandent confirmation avant fermeture. Les commandes acceptent les valeurs temporairement vides et la virgule décimale, avec un affichage lisible sur petit écran. WhatsApp exige un module actif, configuré et les droits requis. Les références longues restent dans leur cellule ; les en-têtes se répètent sur les pages suivantes. Les polices intégrées préservent les caractères turcs et japonais. La rétention inclut les sauvegardes avant modification et leurs sommes de contrôle, tout en conservant le minimum prévu. Les prix chargés en retard préservent les saisies intermédiaires et utilisent la quantité actuelle.',
            },
            es: {
                title: 'Comprobar entradas e impresiones',
                description: 'Las fechas deben ser válidas y los campos enteros rechazan fracciones. Se pide confirmación al cerrar cambios de socios sin guardar. Los pedidos permiten valores temporalmente vacíos y comas decimales, con diseños legibles en pantallas pequeñas. WhatsApp requiere un módulo activo y configurado y los permisos adecuados. Los códigos largos permanecen en su celda y las cabeceras se repiten en las páginas siguientes. Las fuentes integradas conservan caracteres turcos y japoneses. La retención incluye copias previas a cambios y sus sumas de verificación, manteniendo el mínimo de archivos. Los precios cargados con retraso conservan las ediciones intermedias y usan la cantidad actual.',
            },
            tr: {
                title: 'Girişleri ve çıktıları güvenle kontrol edin',
                description: 'Tarih alanları geçerli takvim günleri ister, tam sayı alanları kesirleri reddeder. Kaydedilmemiş iş ortağı değişiklikleri kapanmadan önce onay ister. Sipariş satırları geçici boş değerleri ve ondalık virgülü kabul eder; küçük ekranlarda bilgiler okunabilir kalır. WhatsApp etkin, yapılandırılmış modül ve uygun yetkiler gerektirir. Uzun ürün numaraları hücre içinde kalır, tablo başlıkları sonraki sayfalarda tekrarlanır. Gömülü yedek yazı tipleri Türkçe ve Japonca karakterleri korur. Yedek saklama, değişiklik öncesi arşivleri ve sağlama toplamlarını kapsar, asgari sayıyı korur. Gecikmeli fiyatlar aradaki düzenlemeleri korur ve güncel miktarı kullanır.',
            },
        },
    },
    {
        id: 'french-address-regions',
        sequence: 76,
        version: '2026.9.4',
        publishedAt: '2026-09-26T12:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/partners',
        requiredAnyPermissions: ['customer:read'],
        commitRefs: ['FR-ADDRESS-REGIONS'],
        translations: {
            de: {
                title: 'Französische Regionen automatisch ergänzen',
                description: 'Französische Haupt-, Rechnungs-, Liefer- und weitere Partneradressen erhalten bei eindeutiger Zuordnung automatisch ihre Region, auch bei Schnellerfassung und Import. Manuelle Regionen bleiben erhalten; Mehrdeutigkeiten werden angezeigt. Importtestläufe frieren geplante Ergänzungen ein. Bestehende leere Regionen können im Import-Center nach Vorschau und Bestätigung ergänzt werden; geänderte Datensätze und historische Belege bleiben geschützt.',
            },
            en: {
                title: 'Complete French regions automatically',
                description: 'French main, billing, shipping and other partner addresses receive their region automatically when the assignment is unambiguous, including quick creation and imports. Manual regions are preserved and ambiguities are shown. Import dry runs freeze planned additions. Existing empty regions can be completed in the Import Center after preview and confirmation; changed records and historical documents remain protected.',
            },
            fr: {
                title: 'Compléter automatiquement les régions françaises',
                description: 'Les adresses françaises principales, de facturation, de livraison et autres reçoivent automatiquement leur région lorsque l’attribution est certaine, y compris en création rapide et à l’import. Les régions manuelles sont conservées et les ambiguïtés signalées. Les tests d’import figent les compléments prévus. Les régions vides existantes peuvent être complétées dans le centre d’import après aperçu et confirmation ; les fiches modifiées et les documents historiques restent protégés.',
            },
            es: {
                title: 'Completar automáticamente las regiones francesas',
                description: 'Las direcciones francesas principales, de facturación, envío y otras reciben su región automáticamente cuando la asignación es inequívoca, también en creación rápida e importaciones. Se conservan regiones manuales y se muestran ambigüedades. Las pruebas de importación fijan los cambios previstos. Las regiones vacías existentes pueden completarse en el centro de importación tras vista previa y confirmación; los registros modificados y documentos históricos quedan protegidos.',
            },
            tr: {
                title: 'Fransız bölgelerini otomatik tamamlayın',
                description: 'Fransız ana, fatura, teslimat ve diğer iş ortağı adreslerine kesin eşleşmede bölge otomatik atanır; hızlı kayıt ve içe aktarma da kapsanır. Elle girilen bölgeler korunur ve belirsizlikler gösterilir. İçe aktarma denemeleri planlanan eklemeleri sabitler. Mevcut boş bölgeler İçe Aktarma Merkezinde önizleme ve onaydan sonra tamamlanabilir; değiştirilmiş kayıtlar ve geçmiş belgeler korunur.',
            },
        },
    },
    {
        id: 'reacceptance-imports-historical-fields',
        sequence: 77,
        version: '2026.9.5',
        publishedAt: '2026-09-26T16:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/admin/data-hub',
        requiredAnyPermissions: ['imports:read', 'document:read', 'custom_fields:read'],
        commitRefs: [
            'ERP-QA-R2-AP02',
            'ERP-QA-R2-PDF01',
            'ERP-QA-R2-AP01',
            'ERP-QA-R2-PDF02',
            'ERP-QA-R2-UI01',
            'ERP-QA-R2-UI02',
            'ERP-QA-R2-QU01',
            'ERP-QA-R2-AUTH01',
        ],
        translations: {
            de: {
                title: 'Zuverlässige Teilimporte und historische Ausdrucke',
                description: 'Bestätigte Teilimporte übernehmen gültige Zeilen auch bei fehlerhaften Zusatzfeldwerten; Rechte und Definitionen werden weiter geprüft. Neue Belege bewahren Feldlabels, Auswahltexte und Formelparameter auch bei späteren Veröffentlichungen. Für Altbelege ohne historischen Definitionsstand ist der ursprüngliche Ausdruck maßgeblich; Bearbeitung und Übernahme erfordern einen neuen geprüften Entwurf. Mehrseitige Feldtexte stehen ohne überlagerten Tabellenkopf im PDF. Unvollständige Feldentwürfe bleiben prüfbar, deaktivierte Module laden keine gesperrten Zusatzdaten. Kundenlisten zeigen übersetzte Auswahltexte. Produktnews laden für alle Rollen. Ein falscher Authenticator-Einrichtungscode kann im selben Dialog korrigiert werden.',
            },
            en: {
                title: 'Reliable partial imports and historical printouts',
                description: 'Confirmed partial imports process valid rows despite invalid custom-field values, while still checking permissions and definitions. New documents preserve field labels, option texts and formula settings after later publications. For legacy documents without historical definitions, use the original printout and create a reviewed new draft for editing or conversion. Multi-page field text no longer overlaps table headers. Incomplete field drafts remain reviewable; disabled modules do not fetch restricted extra data. Customer lists display translated option labels. Product news loads for every role. An incorrect authenticator setup code can be corrected in the same dialog.',
            },
            fr: {
                title: 'Imports partiels et impressions historiques fiables',
                description: 'Les imports partiels confirmés traitent les lignes valides malgré les valeurs personnalisées incorrectes, sans supprimer les contrôles de droits et de définitions. Les nouveaux documents conservent les libellés, options et paramètres de formule après publication de nouvelles versions. Pour les anciens documents sans définitions historiques, utilisez l’original et créez un nouveau brouillon vérifié avant modification ou conversion. Les textes longs ne chevauchent plus les en-têtes du PDF. Les brouillons incomplets restent contrôlables ; les modules désactivés ne chargent pas de données interdites. Les listes clients affichent les options traduites. Les actualités sont accessibles à tous les rôles. Un code de configuration incorrect se corrige dans la même fenêtre.',
            },
            es: {
                title: 'Importaciones parciales e impresiones históricas fiables',
                description: 'Las importaciones parciales confirmadas procesan filas válidas aunque haya valores personalizados incorrectos, manteniendo los controles de permisos y definiciones. Los nuevos documentos conservan etiquetas, opciones y parámetros de fórmulas tras publicar nuevas versiones. Para documentos antiguos sin definiciones históricas, use el original y cree un borrador nuevo revisado antes de editar o convertir. Los textos largos no se superponen a las cabeceras del PDF. Los borradores incompletos siguen siendo revisables; los módulos desactivados no solicitan datos restringidos. Las listas muestran opciones traducidas. Las novedades cargan para todos los roles. Un código de configuración incorrecto puede corregirse en el mismo diálogo.',
            },
            tr: {
                title: 'Güvenilir kısmi içe aktarma ve geçmiş çıktılar',
                description: 'Onaylı kısmi içe aktarma, hatalı özel alan değerlerine rağmen geçerli satırları işler; yetki ve tanım denetimleri korunur. Yeni belgeler sonraki yayınlardan sonra da alan etiketlerini, seçenek metinlerini ve formül ayarlarını korur. Geçmiş tanımları bulunmayan eski belgelerde özgün çıktıyı kullanın; düzenleme veya dönüşüm için incelenmiş yeni bir taslak oluşturun. Çok sayfalı alan metinleri PDF tablo başlıklarıyla çakışmaz. Eksik alan taslakları incelenebilir; kapalı modüller kısıtlı ek verileri istemez. Müşteri listeleri çevrilmiş seçenekleri gösterir. Ürün haberleri tüm roller için yüklenir. Yanlış doğrulayıcı kurulum kodu aynı pencerede düzeltilebilir.',
            },
        },
    },
    {
        id: 'compact-order-entry',
        sequence: 78,
        version: '2026.9.6',
        publishedAt: '2026-09-27T07:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/documents',
        requiredAnyPermissions: ['document:read'],
        commitRefs: ['ORDER-EDITOR-WORKSPACE'],
        translations: {
            de: {
                title: 'Aufträge kompakt erfassen',
                description: 'Die Auftragserfassung zeigt zuerst kompakte Belegangaben, Zusatzfelder und breite Positionen mit Summen. Texte, gespeicherte Kundendaten und Anhänge stehen darunter. Die erreichbare Aktionsleiste bündelt weitere Aktionen; die PDF-Vorschau öffnet bedarfsgerecht. Fehler öffnen betroffene Bereiche, ungespeicherte Eingaben bleiben geschützt.',
            },
            en: {
                title: 'Enter orders efficiently',
                description: 'Order entry now starts with compact document details, additional fields and wide items with totals. Texts, saved customer information and attachments follow below. The accessible action bar groups further actions; the PDF preview opens on demand. Errors open the affected sections and unsaved entries remain protected.',
            },
            fr: {
                title: 'Saisir les commandes efficacement',
                description: 'La saisie commence par les informations compactes, champs supplémentaires et lignes larges avec totaux. Textes, données client enregistrées et pièces jointes suivent. La barre accessible regroupe les actions ; l’aperçu PDF s’ouvre à la demande. Les erreurs ouvrent les sections concernées et les saisies non enregistrées restent protégées.',
            },
            es: {
                title: 'Registrar pedidos de forma eficiente',
                description: 'La entrada comienza con datos compactos, campos adicionales y posiciones amplias con totales. Debajo aparecen textos, datos guardados del cliente y adjuntos. La barra accesible agrupa acciones; la vista previa PDF se abre cuando se necesita. Los errores abren las secciones afectadas y se protegen los cambios sin guardar.',
            },
            tr: {
                title: 'Siparişleri verimli kaydedin',
                description: 'Sipariş girişi kompakt belge bilgileri, ek alanlar ve toplamlarıyla geniş kalem alanıyla başlar. Metinler, kayıtlı müşteri bilgileri ve ekler alttadır. Erişilebilir işlem çubuğu işlemleri gruplar; PDF önizlemesi gerektiğinde açılır. Hatalar ilgili bölümleri açar ve kaydedilmemiş girdiler korunur.',
            },
        },
    },
    {
        id: 'customer-industry-code',
        sequence: 79,
        version: '2026.9.7',
        publishedAt: '2026-09-27T09:00:00.000Z',
        category: 'NEW',
        linkUrl: '/partners/customers',
        requiredAnyPermissions: ['customer:read'],
        commitRefs: ['CUSTOMER-INDUSTRY-CODE'],
        translations: {
            de: {
                title: 'Optionalen Branchencode pflegen',
                description: 'Beim Kunden steht neben der Branche ein optionaler Branchencode zur Verfügung. Texte bis 50 Zeichen behalten führende Nullen, Punkte und Buchstaben. Die Kundenliste bietet eine einblendbare Spalte und einen exakten Filter. CSV- und XLSX-Import und Export unterstützen den Code; nicht zugeordnete Spalten erhalten bestehende Werte. Belege und PDF-Ausgaben bleiben unverändert.',
            },
            en: {
                title: 'Maintain an optional industry code',
                description: 'Customers now have an optional industry code alongside their industry selection. Text up to 50 characters preserves leading zeros, periods and letters. The customer list offers an optional column and an exact filter. CSV and XLSX import and export support the code; unmapped columns preserve existing values. Documents and PDF output remain unchanged.',
            },
            fr: {
                title: 'Renseigner un code de secteur facultatif',
                description: 'Un code de secteur facultatif complète désormais le secteur du client. Le texte de 50 caractères maximum conserve les zéros initiaux, points et lettres. La liste clients propose une colonne facultative et un filtre exact. Les imports et exports CSV et XLSX prennent en charge ce code ; les colonnes non associées préservent les valeurs existantes. Les documents et PDF restent inchangés.',
            },
            es: {
                title: 'Gestionar un código de sector opcional',
                description: 'El cliente dispone de un código de sector opcional junto al sector. El texto de hasta 50 caracteres conserva ceros iniciales, puntos y letras. La lista ofrece una columna opcional y un filtro exacto. La importación y exportación CSV y XLSX admiten el código; las columnas sin asignar conservan los valores existentes. Los documentos y PDF no cambian.',
            },
            tr: {
                title: 'İsteğe bağlı sektör kodu kaydedin',
                description: 'Müşterinin sektör seçiminin yanında isteğe bağlı sektör kodu bulunur. En fazla 50 karakterlik metin baştaki sıfırları, noktaları ve harfleri korur. Müşteri listesi isteğe bağlı sütun ve tam eşleşme filtresi sunar. CSV ve XLSX içe ve dışa aktarma kodu destekler; eşlenmeyen sütunlar mevcut değerleri korur. Belgeler ve PDF çıktıları değişmez.',
            },
        },
    },
    {
        id: 'delivery-address-planning',
        sequence: 80,
        version: '2026.9.0',
        publishedAt: '2026-09-27T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/partners/customers',
        requiredAnyPermissions: ['customer:read', 'document:read'],
        commitRefs: ['delivery-planning'],
        translations: {
            de: {
                title: 'Lieferplanung je Lieferadresse',
                description: 'Warenannahmezeiten und regelmäßige Liefertage lassen sich direkt an einer Lieferadresse aktivieren. Aufträge und Lieferscheine bewahren ihren eigenen Stand und drucken ihn in der Belegsprache.',
            },
            en: {
                title: 'Delivery planning per address',
                description: 'Enable receiving hours and regular delivery weekdays directly at a shipping address. Orders and delivery notes retain their own snapshot and print it in the document language.',
            },
            fr: {
                title: 'Planification par adresse de livraison',
                description: 'Activez les horaires de réception et les jours de livraison dans chaque adresse. Les commandes et bons de livraison conservent leurs informations et les impriment dans la langue du document.',
            },
            es: {
                title: 'Planificación por dirección de entrega',
                description: 'Active horarios de recepción y días habituales en cada dirección. Los pedidos y albaranes conservan sus propios datos y los imprimen en el idioma del documento.',
            },
            tr: {
                title: 'Adrese göre teslimat planlaması',
                description: 'Mal kabul saatlerini ve düzenli teslimat günlerini teslimat adresinde etkinleştirin. Siparişler ve irsaliyeler kendi kayıtlarını korur ve belge dilinde yazdırır.',
            },
        },
    },
    {
        id: 'shipping-address-labels',
        sequence: 81,
        version: '2026.9.7',
        publishedAt: '2026-09-27T13:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/sales/orders',
        requiredAnyPermissions: ['document:read'],
        commitRefs: ['SHIPPING-ADDRESS-LABELS'],
        translations: {
            de: {
                title: 'Lieferadressen leichter unterscheiden',
                description: 'Angebote, Aufträge und Lieferscheine zeigen Lieferadressen mit Bezeichnung, Empfänger und Ort. Alle drei Angaben sind durchsuchbar. Leere Angaben entfallen, lange Texte bleiben auch mobil lesbar.',
            },
            en: {
                title: 'Distinguish shipping addresses easily',
                description: 'Quotations, orders and delivery notes show shipping addresses with label, recipient and city. Search all three details. Blank details are omitted and long text remains readable on mobile screens.',
            },
            fr: {
                title: 'Distinguer facilement les adresses de livraison',
                description: 'Les devis, commandes et bons de livraison affichent le libellé, le destinataire et la ville. Recherchez dans ces trois informations. Les données vides sont omises et les textes longs restent lisibles sur mobile.',
            },
            es: {
                title: 'Distinguir fácilmente las direcciones de envío',
                description: 'Los presupuestos, pedidos y albaranes muestran etiqueta, destinatario y ciudad. Busque en los tres datos. Se omiten los datos vacíos y los textos largos siguen siendo legibles en pantallas móviles.',
            },
            tr: {
                title: 'Teslimat adreslerini kolayca ayırt edin',
                description: 'Teklifler, siparişler ve irsaliyeler teslimat adreslerini etiket, alıcı ve şehir ile gösterir. Üç bilgide de arama yapılır. Boş bilgiler atlanır ve uzun metinler mobil ekranlarda da okunabilir kalır.',
            },
        },
    },
    {
        id: 'document-row-packaging',
        sequence: 82,
        version: '2026.9.8',
        publishedAt: '2026-09-27T00:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/documents',
        requiredAnyPermissions: ['document:read'],
        commitRefs: ['document-row-packaging'],
        translations: {
            de: {
                title: 'Einheit und Gebinde direkt in der Position',
                description: 'Basiseinheit, Karton oder Palette wählen und Mengen sowie Preise prüfen.',
            },
            en: {
                title: 'Select units and packaging in document rows',
                description: 'Choose the base unit, carton or pallet and check quantities and prices.',
            },
            fr: {
                title: 'Choisir le conditionnement dans les lignes',
                description: 'Choisir l’unité de base, le carton ou la palette et vérifier les quantités et prix.',
            },
            es: {
                title: 'Elegir unidades y embalajes en las líneas',
                description: 'Elegir unidad base, caja o palé y comprobar cantidades y precios.',
            },
            tr: {
                title: 'Belge satırında birim ve ambalaj seçimi',
                description: 'Temel birim, koli veya palet seçin; miktarları ve fiyatları kontrol edin.',
            },
        },
    },
    {
        id: 'international-master-data-call-preparation',
        sequence: 83,
        version: '2026.9.0',
        publishedAt: '2026-09-28T00:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/partners/customers',
        requiredAnyPermissions: ['customer:read'],
        commitRefs: ['international-master-data-call-preparation'],
        translations: {
            de: {
                title: 'Internationale Stammdaten und Gesprächsvorbereitung',
                description: 'Länder und lokale Rechtsformen durchsuchen, Kontaktzuständigkeiten unter Einstellungen pflegen und Gespräche mit Fakten, Ansprechpartnern und direkten Aktionen vorbereiten. Suchlisten bleiben auch ohne Eingabe geöffnet.',
            },
            en: {
                title: 'International master data and call preparation',
                description: 'Search countries and local legal forms, manage contact responsibilities in Settings, and prepare calls with facts, contacts and direct actions. Search lists stay open without typing.',
            },
            fr: {
                title: 'Données internationales et préparation des échanges',
                description: 'Recherchez les pays et formes juridiques locales, gérez les responsabilités dans les paramètres et préparez les échanges avec faits, contacts et actions. Les listes restent ouvertes sans saisie.',
            },
            es: {
                title: 'Datos internacionales y preparación de conversaciones',
                description: 'Busque países y formas jurídicas locales, gestione responsabilidades en Ajustes y prepare conversaciones con hechos, contactos y acciones. Las listas permanecen abiertas sin escribir.',
            },
            tr: {
                title: 'Uluslararası ana veriler ve görüşme hazırlığı',
                description: 'Ülke ve yerel hukuki biçimleri arayın, Ayarlar’da kişi sorumluluklarını yönetin; gerçekler, kişiler ve doğrudan işlemlerle görüşme hazırlayın. Arama listeleri yazmadan açık kalır.',
            },
        },
    },
    {
        id: 'compact-responsive-header',
        sequence: 84,
        version: '2026.9.0',
        publishedAt: '2026-09-28T00:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/',
        requiredAnyPermissions: [],
        commitRefs: ['compact-responsive-header'],
        translations: {
            de: {
                title: 'Aufgeräumte Kopfzeile auf kleinen Bildschirmen',
                description: 'Navigation, Marke, Suche und Benachrichtigungen bleiben direkt erreichbar. Weitere Aktionen und das Benutzerkonto stehen im beschrifteten Menü. Die kompakte Statuszeile zeigt Umgebung und tatsächlichen Betriebsmodus mit Details.',
            },
            en: {
                title: 'A clearer header on small screens',
                description: 'Navigation, branding, search and notifications remain directly accessible. A labelled menu contains further actions and your account. The compact status bar shows the environment and actual operating mode with details.',
            },
            fr: {
                title: 'Un en-tête plus clair sur petit écran',
                description: 'Navigation, marque, recherche et notifications restent accessibles directement. Les autres actions et le compte sont réunis dans un menu libellé. La barre compacte affiche l’environnement et le mode réel avec leurs détails.',
            },
            es: {
                title: 'Cabecera más clara en pantallas pequeñas',
                description: 'Navegación, marca, búsqueda y notificaciones siguen accesibles directamente. Un menú con texto reúne otras acciones y su cuenta. La barra compacta muestra el entorno y el modo operativo real con detalles.',
            },
            tr: {
                title: 'Küçük ekranlarda daha düzenli üst çubuk',
                description: 'Gezinme, marka, arama ve bildirimlere doğrudan erişilir. Diğer işlemler ve hesap açıklamalı menüde toplanır. Kompakt durum çubuğu ortamı ve gerçek işletim modunu ayrıntılarıyla gösterir.',
            },
        },
    },
    {
        id: 'customer-file-document-editor',
        sequence: 85,
        version: '2026.9.0',
        publishedAt: '2026-09-28T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/partners/customers',
        requiredAnyPermissions: ['customer:read'],
        commitRefs: ['customer-file-document-editor'],
        translations: {
            de: {
                title: 'Belege direkt aus der Kundenakte bearbeiten',
                description: 'Beleg erstellen öffnet den Editor mit dem gewählten Kunden und seinen Vorgaben. Wählen Sie die passende Belegart, prüfen Sie Adressen und Konditionen und ergänzen Sie Positionen. Erst Speichern legt den Beleg an.',
            },
            en: {
                title: 'Edit documents directly from the customer file',
                description: 'Create document opens the editor with the selected customer and their defaults. Choose the document type, check addresses and terms, and add items. The document is created only when you save.',
            },
            fr: {
                title: 'Modifier les documents depuis le dossier client',
                description: 'Créer un document ouvre l’éditeur avec le client et ses valeurs. Choisissez le type, vérifiez les adresses et conditions, puis ajoutez des lignes. Le document est créé uniquement à l’enregistrement.',
            },
            es: {
                title: 'Editar documentos desde la ficha del cliente',
                description: 'Crear documento abre el editor con el cliente y sus valores. Elija el tipo, compruebe direcciones y condiciones y añada líneas. El documento se crea solo al guardar.',
            },
            tr: {
                title: 'Müşteri dosyasından doğrudan belge düzenleyin',
                description: 'Belge oluştur, müşteriyi ve varsayılanlarını düzenleyicide açar. Belge türünü seçin, adres ve koşulları kontrol edip satırları ekleyin. Belge yalnızca kaydettiğinizde oluşturulur.',
            },
        },
    },
    {
        id: 'french-geographic-subdivisions',
        sequence: 86,
        version: '2026.9.0',
        publishedAt: '2026-09-28T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/partners/customers',
        requiredAnyPermissions: ['customer:read'],
        commitRefs: ['french-geographic-subdivisions'],
        translations: {
            de: {
                title: 'Französische Adressen mit eigenem Département',
                description: 'Kunden, Interessenten und Lieferanten können Départementcode und Namen getrennt von Ort, Region und Unternehmensabteilung speichern. Adressvorschläge übernehmen die Zuordnung; Auswahl nach Code oder Name, Kundenfilter sowie Import und Export unterstützen sie.',
            },
            en: {
                title: 'French addresses with a separate département',
                description: 'Customers, prospects and suppliers can store département codes and names separately from city, region and company department. Address suggestions, code/name selection, customer filters, import and export support the new fields.',
            },
            fr: {
                title: 'Un département distinct pour les adresses françaises',
                description: 'Clients, prospects et fournisseurs peuvent enregistrer le code et le nom du département séparément de la commune, de la région et du service de l’entreprise. Propositions d’adresse, recherche par code ou nom, filtre clients, import et export les prennent en charge.',
            },
            es: {
                title: 'Departamento separado en direcciones francesas',
                description: 'Clientes, prospectos y proveedores pueden guardar código y nombre del departamento separados de localidad, región y departamento empresarial. Las sugerencias, búsqueda por código o nombre, filtro de clientes, importación y exportación los admiten.',
            },
            tr: {
                title: 'Fransız adreslerinde ayrı departman bilgisi',
                description: 'Müşteri, aday ve tedarikçiler departman kodunu ve adını şehir, bölge ve şirket bölümünden ayrı kaydedebilir. Adres önerileri, kod/ad araması, müşteri filtresi, içe ve dışa aktarma bu alanları destekler.',
            },
        },
    },
    {
        id: 'packaging-weight-summary',
        sequence: 87,
        version: '2026.9.0',
        publishedAt: '2026-09-28T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/settings/packaging-weights',
        requiredAnyPermissions: ['settings:read'],
        commitRefs: ['packaging-weight-summary'],
        translations: {
            de: {
                title: 'Gebinde und Gewicht im Beleg',
                description: 'Aktivieren Sie optionale Gebinde- und Gewichtssummen, ordnen Sie zentrale Gebindearten am Artikel zu und bestätigen Sie bei Bedarf tatsächliche Versandmengen. PDFs unterscheiden berechnete und bestätigte Angaben.',
            },
            en: {
                title: 'Packaging and weight in documents',
                description: 'Enable optional packaging and weight totals, assign central packaging types to articles and confirm actual shipping quantities when needed. PDFs distinguish calculated and confirmed values.',
            },
            fr: {
                title: 'Conditionnements et poids dans les documents',
                description: 'Activez les totaux facultatifs, attribuez les types centraux aux articles et confirmez les quantités réelles si nécessaire. Les PDF distinguent valeurs calculées et confirmées.',
            },
            es: {
                title: 'Embalajes y peso en documentos',
                description: 'Active totales opcionales, asigne tipos centrales a artículos y confirme cantidades reales cuando sea necesario. Los PDF distinguen valores calculados y confirmados.',
            },
            tr: {
                title: 'Belgelerde ambalaj ve ağırlık',
                description: 'İsteğe bağlı toplamları etkinleştirin, merkezi ambalaj türlerini ürünlere atayın ve gerektiğinde gerçek sevkiyat miktarlarını onaylayın. PDF hesaplanan ve onaylanan değerleri ayırır.',
            },
        },
    },
    {
        id: 'central-price-groups',
        sequence: 88,
        version: '2026.9.0',
        publishedAt: '2026-09-28T20:00:00.000Z',
        category: 'NEW',
        linkUrl: '/settings/price-groups',
        requiredAnyPermissions: ['settings:read'],
        commitRefs: ['central-price-groups'],
        translations: {
            de: {
                title: 'Preisgruppen und Artikelkonditionen',
                description: 'Preisgruppen zentral pflegen, Kunden zuordnen und passende Artikelpreise verwenden.',
            },
            en: {
                title: 'Price groups and product terms',
                description: 'Manage central groups, assign customers and apply the right product prices.',
            },
            fr: {
                title: 'Groupes de prix et conditions par article',
                description: 'Gérez les groupes centraux, affectez les clients et appliquez les prix adaptés.',
            },
            es: {
                title: 'Grupos de precios y condiciones por artículo',
                description: 'Gestione grupos centrales, asigne clientes y aplique los precios adecuados.',
            },
            tr: {
                title: 'Fiyat grupları ve ürün koşulları',
                description: 'Merkezi grupları yönetin, müşteri atayın ve uygun ürün fiyatlarını kullanın.',
            },
        },
    },
    {
        id: 'portal-checkout-error-history',
        sequence: 89,
        version: '2026.9.28',
        publishedAt: '2026-09-28T20:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/partners',
        requiredAnyPermissions: [PERMISSIONS.PORTAL_ACTIVITY_READ],
        commitRefs: ['portal-checkout-error-history'],
        translations: {
            de: {
                title: 'Verlässliche Portalbestellungen und nachvollziehbare Fehler',
                description: 'Portalbestellungen unterscheiden Preisänderungen von Bestands-, Sitzungs- und anderen Fehlern. Geänderte Preise lassen sich prüfen und ausdrücklich bestätigen. Die Kundenhistorie zeigt Portalfehler mit Meldung und Referenz.',
            },
            en: {
                title: 'Reliable portal orders and traceable errors',
                description: 'Portal orders distinguish changed prices from stock, session and other failures. Updated prices can be reviewed and explicitly confirmed. Customer history shows portal errors with the displayed message and reference.',
            },
            fr: {
                title: 'Commandes du portail fiables et erreurs traçables',
                description: 'Les commandes distinguent changements de prix, manque de stock, sessions expirées et autres erreurs. Les prix actualisés sont vérifiés et confirmés explicitement. L’historique client présente les erreurs avec message et référence.',
            },
            es: {
                title: 'Pedidos del portal fiables y errores trazables',
                description: 'Los pedidos distinguen cambios de precio de fallos de existencias, sesión y otros errores. Los precios actualizados se revisan y confirman expresamente. El historial muestra los errores con el mensaje y la referencia.',
            },
            tr: {
                title: 'Güvenilir portal siparişleri ve izlenebilir hatalar',
                description: 'Siparişler fiyat değişikliklerini stok, oturum ve diğer hatalardan ayırır. Güncel fiyatlar incelenip açıkça onaylanır. Müşteri geçmişinde portal hataları mesaj ve referansıyla gösterilir.',
            },
        },
    },
    {
        id: 'document-finalization-readiness',
        sequence: 90,
        version: '2026.9.28',
        publishedAt: '2026-09-28T21:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/documents',
        requiredAnyPermissions: ['document:read'],
        commitRefs: ['document-finalization-readiness'],
        translations: {
            de: {
                title: 'Festschreiben mit nachvollziehbaren Voraussetzungen',
                description: 'Angebote und Aufträge verlangen keine Rechnungsanschrift mit Ort und Postleitzahl und keinen bereits erfolgten Versand. Direkt am Beleg sehen Sie fehlende Angaben, Berechtigungen und andere Sperren mit Korrekturwegen. Erfolgreiche und fehlgeschlagene Versuche erscheinen beim Beleg und in der Kundenhistorie.',
            },
            en: {
                title: 'Finalize documents with clear prerequisites',
                description: 'Quotes and orders no longer require invoice-only city and postal code details or proof of completed shipment. Documents show missing information, permissions and other blockers with correction links. Successful and failed attempts appear on the document and in customer history.',
            },
            fr: {
                title: 'Validation définitive avec conditions explicites',
                description: 'Les devis et commandes ne nécessitent plus les ville et code postal réservés à la facturation ni la preuve d’une expédition déjà effectuée. Le document présente les données et droits manquants, les autres blocages et les accès aux corrections. Les tentatives réussies ou échouées figurent sur le document et dans l’historique client.',
            },
            es: {
                title: 'Fijación de documentos con requisitos claros',
                description: 'Los presupuestos y pedidos ya no exigen ciudad y código postal propios de la facturación ni prueba de un envío ya realizado. El documento muestra datos y permisos pendientes, otros bloqueos y enlaces para corregirlos. Los intentos exitosos y fallidos aparecen en el documento y en el historial del cliente.',
            },
            tr: {
                title: 'Açık ön koşullarla belge kesinleştirme',
                description: 'Teklif ve siparişlerde artık faturaya özgü şehir ve posta kodu bilgileri veya tamamlanmış sevkiyat kanıtı aranmaz. Belgede eksik bilgiler, yetkiler ve diğer engeller düzeltme bağlantılarıyla gösterilir. Başarılı ve başarısız denemeler belgede ve müşteri geçmişinde yer alır.',
            },
        },
    },
    {
        id: 'automatic-pdf-custom-fields',
        sequence: 91,
        version: '2026.9.0',
        publishedAt: '2026-09-28T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/settings/pdf-designer',
        requiredAnyPermissions: ['settings:read'],
        commitRefs: ['automatic-pdf-custom-fields'],
        translations: {
            de: {
                title: 'Automatische Zusatzfelder im PDF',
                description: 'Aktivieren Sie Im PDF anzeigen an einem öffentlichen Zusatzfeld und speichern bzw. veröffentlichen Sie die Definition im üblichen Verfahren. Erfassen Sie den Wert beim passenden Kunden, Artikel oder Beleg. Neue Belege zeigen Label und Wert automatisch: Kunden- und Belegwerte vor den Positionen, Artikel- und Positionswerte an der jeweiligen Position. Eine zusätzliche Feldliste oder ein Kundenblock ist dafür nicht nötig. Kategorien und Reihenfolgen werden berücksichtigt; es entstehen keine zusätzlichen breiten Tabellenspalten. Bei bestehenden Entwürfen öffnet **Aktuelle Kundendaten prüfen** den Vergleich zwischen gespeichertem Belegwert und aktuellem Kundenwert.',
            },
            en: {
                title: 'Automatic custom fields in PDFs',
                description: 'Enable Show in PDF on a public custom field and save or publish its definition through the usual process. Enter its value on the relevant customer, product or document. New documents automatically print labels and values: customer and document fields before the lines, product and line fields at their own line. No second field list or customer block is required. Categories and order are respected without adding wide table columns. For existing drafts, **Check current customer data** compares the saved document value with the current customer value.',
            },
            fr: {
                title: 'Champs supplémentaires automatiques dans le PDF',
                description: 'Activez Afficher dans le PDF sur un champ public et enregistrez ou publiez sa définition selon la procédure habituelle. Saisissez la valeur chez le client, sur l’article ou dans le document concerné. Les nouveaux documents impriment automatiquement libellés et valeurs : données client et document avant les lignes, données article et ligne sur leur propre ligne. Aucune seconde liste ni bloc client n’est nécessaire. Les catégories et l’ordre sont respectés sans ajouter de larges colonnes. Pour les brouillons existants, **Vérifier les données client actuelles** compare valeur enregistrée et valeur actuelle du client.',
            },
            es: {
                title: 'Campos adicionales automáticos en PDF',
                description: 'Active Mostrar en PDF en un campo público y guarde o publique la definición mediante el procedimiento habitual. Introduzca el valor en el cliente, artículo o documento correspondiente. Los nuevos documentos imprimen automáticamente etiqueta y valor: cliente y documento antes de las líneas, artículo y posición junto a su línea. No necesita otra lista ni un bloque de cliente. Se respetan categorías y orden sin añadir columnas anchas. En borradores existentes, **Revisar datos actuales del cliente** compara el valor guardado con el actual.',
            },
            tr: {
                title: 'PDF’de otomatik ek alanlar',
                description: 'Herkese açık bir ek alanda PDF’de göster seçeneğini açın ve tanımı normal süreçle kaydedin veya yayımlayın. Değeri ilgili müşteri, ürün veya belgede girin. Yeni belgeler etiket ve değeri otomatik basar: müşteri ve belge alanları kalemlerden önce, ürün ve kalem alanları kendi satırında. İkinci alan listesi veya müşteri bloğu gerekmez. Kategori ve sıra korunur; geniş yeni tablo sütunları eklenmez. Mevcut taslaklarda **Güncel müşteri verilerini kontrol et**, kayıtlı belge değeri ile güncel müşteri değerini karşılaştırır.',
            },
        },
    },
    {
        id: 'integrated-document-and-portal-guidance',
        sequence: 92,
        version: '2026.9.29',
        publishedAt: '2026-09-28T22:55:00.000Z',
        category: 'FIXED',
        linkUrl: '/documents',
        requiredAnyPermissions: ['document:read'],
        commitRefs: ['integrated-document-and-portal-guidance'],
        translations: {
            de: {
                title: 'Belegeingaben und Fehlermeldungen verbessert',
                description: 'Die Rechnungsadresse lässt sich zusammenhängend bearbeiten. Schnelle Datumsänderungen übernehmen keine veralteten Artikelpreise. Portalhistorie und Importfehler zeigen verständliche Meldungen in der gewählten Sprache.',
            },
            en: {
                title: 'Clearer document entry and error messages',
                description: 'Edit the billing address together in one place. Quick date changes no longer apply outdated product prices. Portal history and import errors show clear messages in the selected language.',
            },
            fr: {
                title: 'Saisie des documents et messages améliorés',
                description: 'Modifiez toute l’adresse de facturation au même endroit. Les changements rapides de date n’appliquent plus d’anciens prix d’articles. L’historique du portail et les erreurs d’import affichent des messages clairs dans la langue choisie.',
            },
            es: {
                title: 'Mejoras en documentos y mensajes de error',
                description: 'Edite toda la dirección de facturación en un mismo lugar. Los cambios rápidos de fecha no aplican precios de artículos desactualizados. El historial del portal y los errores de importación muestran mensajes claros en el idioma elegido.',
            },
            tr: {
                title: 'Belge girişi ve hata mesajları iyileştirildi',
                description: 'Fatura adresini aynı yerde birlikte düzenleyin. Hızlı tarih değişiklikleri eski ürün fiyatlarını uygulamaz. Portal geçmişi ve içe aktarma hataları seçilen dilde anlaşılır mesajlar gösterir.',
            },
        },
    },
    {
        id: 'stock-adjustment-inline-batch',
        sequence: 93,
        version: '2026.9.29',
        publishedAt: '2026-09-29T06:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/products',
        requiredAnyPermissions: ['inventory:write'],
        commitRefs: ['stock-adjustment-inline-batch'],
        translations: {
            de: {
                title: 'Neue Charge direkt bei der Bestandskorrektur',
                description: 'Lege Chargen im Korrekturdialog an, prüfe die Vorschau mit Einheit und zähle gezielt einzelne Chargen. Menge und Begründung bleiben erhalten; Bestandsabweichungen werden sichtbar und wiederholtes Absenden bucht nicht doppelt.',
            },
            en: {
                title: 'Create batches directly in stock adjustments',
                description: 'Create a batch in the adjustment dialog, review quantities with units and count individual batches. Quantity and reason are preserved; stock discrepancies are visible and repeated submission does not post twice.',
            },
            fr: {
                title: 'Créer un lot dans la correction de stock',
                description: 'Créez un lot dans le dialogue, vérifiez les quantités avec leurs unités et comptez chaque lot séparément. Quantité et motif sont conservés ; les écarts sont signalés et une demande répétée ne double pas l’écriture.',
            },
            es: {
                title: 'Crear lotes desde la corrección de existencias',
                description: 'Crea un lote en el diálogo, revisa cantidades y unidades y cuenta cada lote por separado. Se conservan cantidad y motivo; se muestran discrepancias y repetir el envío no duplica el asiento.',
            },
            tr: {
                title: 'Stok düzeltmesinde doğrudan parti oluşturma',
                description: 'Düzeltme penceresinde parti oluşturun, miktarları birimleriyle inceleyin ve partileri ayrı sayın. Miktar ve gerekçe korunur; stok farkları gösterilir ve yeniden gönderim çift kayıt oluşturmaz.',
            },
        },
    },
    {
        id: 'document-order-progress',
        sequence: 94,
        version: '2026.9.29',
        publishedAt: '2026-09-29T12:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/documents',
        requiredAnyPermissions: ['document:read'],
        commitRefs: ['document-order-progress'],
        translations: {
            de: {
                title: 'Auftragsfortschritt',
                description: 'Verknüpfte Belege, wirksame Mengen, Entwürfe und nächste Aktionen nachvollziehen.',
            },
            en: {
                title: 'Order progress',
                description: 'Understand linked documents, effective quantities, drafts and next actions.',
            },
            fr: {
                title: 'Avancement de la commande',
                description: 'Comprendre les documents liés, quantités effectives, brouillons et actions suivantes.',
            },
            es: {
                title: 'Progreso del pedido',
                description: 'Comprender documentos vinculados, cantidades efectivas, borradores y acciones siguientes.',
            },
            tr: {
                title: 'Sipariş ilerlemesi',
                description: 'Bağlı belgeleri, gerçekleşen miktarları, taslakları ve sonraki işlemleri anlayın.',
            },
        },
    },
    {
        id: 'delivery-batch-suitability',
        sequence: 95,
        version: '2026.9.29',
        publishedAt: '2026-09-29T14:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/documents',
        requiredAnyPermissions: ['document:write'],
        commitRefs: ['delivery-batch-suitability'],
        translations: {
            de: {
                title: 'Chargen für die Lieferung auswählen',
                description: 'Geeignete Chargen nach Anlieferdatum, Restlaufzeit und verfügbarem Bestand auswählen.',
            },
            en: {
                title: 'Select batches for delivery',
                description: 'Choose suitable batches using arrival date, shelf life and available stock.',
            },
            fr: {
                title: 'Choisir les lots pour la livraison',
                description: 'Choisir les lots selon la date d’arrivée, la conservation et le stock disponible.',
            },
            es: {
                title: 'Seleccionar lotes para la entrega',
                description: 'Elegir lotes por fecha de llegada, vida útil y existencias disponibles.',
            },
            tr: {
                title: 'Teslimat için parti seçimi',
                description: 'Varış tarihi, raf ömrü ve kullanılabilir stoka göre uygun partileri seçin.',
            },
        },
    },
    {
        id: 'pdf-custom-field-diagnostics',
        sequence: 96,
        version: '2026.9.29',
        publishedAt: '2026-09-29T15:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/documents',
        requiredAnyPermissions: ['document:read'],
        commitRefs: ['pdf-custom-field-diagnostics'],
        translations: {
            de: {
                title: 'Zusatzfelder in der PDF-Ausgabe prüfen',
                description: 'Feldwerte, Herkunft, Platzierung und fehlende Ausgaben direkt in der Vorschau nachvollziehen.',
            },
            en: {
                title: 'Check custom fields in PDF output',
                description: 'Understand field values, origins, placement and missing output directly in the preview.',
            },
            fr: {
                title: 'Vérifier les champs personnalisés du PDF',
                description: 'Comprendre les valeurs, leur origine, le placement et les absences directement dans l’aperçu.',
            },
            es: {
                title: 'Comprobar los campos adicionales del PDF',
                description: 'Comprender valores, origen, ubicación y ausencias directamente en la vista previa.',
            },
            tr: {
                title: 'PDF çıktısındaki ek alanları kontrol etme',
                description: 'Alan değerlerini, kaynaklarını, yerleşimlerini ve eksik çıktıları önizlemede anlayın.',
            },
        },
    },
    {
        id: 'portal-order-templates',
        sequence: 97,
        version: '2026.9.29',
        publishedAt: '2026-09-29T16:00:00.000Z',
        category: 'NEW',
        linkUrl: '/partners/customers',
        requiredAnyPermissions: ['portal_access:manage'],
        commitRefs: ['portal-order-templates'],
        translations: {
            de: {
                title: 'Bestellvorlagen im Kundenportal',
                description: 'Wiederkehrende Bestellungen als persönliche oder gemeinsame Vorlagen speichern und Warenkörbe mit aktuellen Preisen sicher vorbereiten.',
            },
            en: {
                title: 'Customer portal order templates',
                description: 'Save recurring orders as personal or shared templates and safely prepare carts with current prices.',
            },
            fr: {
                title: 'Modèles de commande du portail client',
                description: 'Enregistrer des commandes récurrentes comme modèles personnels ou partagés et préparer des paniers aux prix actuels.',
            },
            es: {
                title: 'Plantillas de pedido del portal de clientes',
                description: 'Guardar pedidos recurrentes como plantillas personales o compartidas y preparar carritos con precios actuales.',
            },
            tr: {
                title: 'Müşteri portalı sipariş şablonları',
                description: 'Tekrarlanan siparişleri kişisel veya paylaşılan şablon olarak kaydedin ve güncel fiyatlarla güvenle sepet hazırlayın.',
            },
        },
    },
    {
        id: 'saved-list-views',
        sequence: 98,
        version: '2026.9.29',
        publishedAt: '2026-09-29T17:00:00.000Z',
        category: 'NEW',
        linkUrl: '/partners/customers',
        requiredAnyPermissions: ['customer:read'],
        commitRefs: ['saved-list-views'],
        translations: {
            de: {
                title: 'Listenansichten speichern',
                description: 'Filter, Spalten und Sortierung wiederverwenden.',
            },
            en: {
                title: 'Save list views',
                description: 'Reuse filters, columns and sorting.',
            },
            fr: {
                title: 'Enregistrer des vues de liste',
                description: 'Réutiliser les filtres, colonnes et tris.',
            },
            es: {
                title: 'Guardar vistas de lista',
                description: 'Reutilizar filtros, columnas y ordenación.',
            },
            tr: {
                title: 'Liste görünümlerini kaydetme',
                description: 'Filtreleri, sütunları ve sıralamayı yeniden kullanın.',
            },
        },
    },
    {
        id: 'dashboard-action-needs',
        sequence: 99,
        version: '2026.9.29',
        publishedAt: '2026-09-29T19:00:00.000Z',
        category: 'NEW',
        linkUrl: '/',
        requiredAnyPermissions: ['document:read', 'inventory:read', 'portal_activity:read'],
        commitRefs: ['dashboard-action-needs'],
        translations: {
            de: {
                title: 'Handlungsbedarf im Dashboard',
                description: 'Offene Probleme prüfen und nachvollziehbar bearbeiten.',
            },
            en: {
                title: 'Action needed on the dashboard',
                description: 'Review outstanding issues and handle them traceably.',
            },
            fr: {
                title: 'Actions requises dans le tableau de bord',
                description: 'Vérifier et traiter les problèmes ouverts avec traçabilité.',
            },
            es: {
                title: 'Acciones pendientes en el panel',
                description: 'Revisar y gestionar problemas abiertos con trazabilidad.',
            },
            tr: {
                title: 'Panoda işlem gerekenler',
                description: 'Açık sorunları izlenebilir biçimde inceleyin ve işleyin.',
            },
        },
    },
    {
        id: 'partner-map',
        sequence: 100,
        version: '2026.9.0',
        publishedAt: '2026-09-29T18:00:00.000Z',
        category: 'NEW',
        linkUrl: '/partners/map',
        requiredAnyPermissions: ['customer:read'],
        commitRefs: ['partner-map'],
        translations: {
            de: {
                title: 'Partnerkarte und Besuchsvorbereitung',
                description: 'Standorte filtern, Adressen prüfen und persönliche Besuche planen.',
            },
            en: {
                title: 'Partner map and visit preparation',
                description: 'Filter locations, review addresses and prepare personal visits.',
            },
            fr: {
                title: 'Carte des partenaires et préparation des visites',
                description: 'Filtrer les sites, vérifier les adresses et préparer les visites.',
            },
            es: {
                title: 'Mapa de socios y preparación de visitas',
                description: 'Filtrar sedes, revisar direcciones y preparar visitas.',
            },
            tr: {
                title: 'İş ortağı haritası ve ziyaret hazırlığı',
                description: 'Konumları filtreleyin, adresleri kontrol edin ve ziyaret hazırlayın.',
            },
        },
    },
    {
        id: 'persistent-address-geocoding',
        sequence: 101,
        version: '2026.9.1',
        publishedAt: '2026-09-30T01:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/partners/map',
        requiredAnyPermissions: ['customer:read'],
        commitRefs: ['persistent-address-geocoding'],
        translations: {
            de: {
                title: 'Gespeicherte Adresspositionen',
                description: 'Die Partnerkarte verwendet dauerhaft gespeicherte Positionen. Öffentliche Geschäftsadressen werden bei Bedarf mit Nominatim zugeordnet; private und unklare Adressen bleiben zur manuellen Prüfung.',
            },
            en: {
                title: 'Persistent address positions',
                description: 'The partner map uses saved positions. Public business addresses are located with Nominatim when needed; private and uncertain addresses remain for manual review.',
            },
            fr: {
                title: 'Positions d’adresses enregistrées',
                description: 'La carte utilise les positions enregistrées. Nominatim localise les adresses professionnelles publiques selon les besoins ; les autres nécessitent une vérification manuelle.',
            },
            es: {
                title: 'Posiciones de direcciones guardadas',
                description: 'El mapa utiliza posiciones guardadas. Nominatim localiza direcciones comerciales públicas cuando es necesario; las privadas o dudosas requieren revisión manual.',
            },
            tr: {
                title: 'Kalıcı adres konumları',
                description: 'Harita kayıtlı konumları kullanır. Herkese açık iş adresleri gerektiğinde Nominatim ile konumlandırılır; özel ve belirsiz adresler elle incelenir.',
            },
        },
    },
    {
        id: 'partner-map-provider-recovery',
        sequence: 102,
        version: '2026.9.1',
        publishedAt: '2026-09-30T05:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/partners/map',
        requiredAnyPermissions: ['customer:read'],
        commitRefs: ['partner-map-provider-recovery'],
        translations: {
            de: {
                title: 'Zuverlässigere Partnerkarte',
                description: 'Kartenanzeige und erneutes Laden wurden korrigiert. Freigegebene Adressen können vom Hintergrunddienst wieder zugeordnet werden.',
            },
            en: {
                title: 'More reliable partner map',
                description: 'Map rendering and retry have been corrected. The background worker can locate approved addresses again.',
            },
            fr: {
                title: 'Carte des partenaires plus fiable',
                description: 'L’affichage de la carte et son rechargement sont corrigés. Le traitement en arrière-plan peut à nouveau localiser les adresses autorisées.',
            },
            es: {
                title: 'Mapa de socios más fiable',
                description: 'Se han corregido la visualización y la recarga del mapa. El proceso en segundo plano puede volver a localizar las direcciones autorizadas.',
            },
            tr: {
                title: 'Daha güvenilir iş ortağı haritası',
                description: 'Harita görünümü ve yeniden yükleme düzeltildi. Arka plan işlemi onaylanan adresleri yeniden konumlandırabilir.',
            },
        },
    },
    {
        id: 'connected-complaints-returns',
        sequence: 103,
        version: '2026.9.30',
        publishedAt: '2026-09-30T12:00:00.000Z',
        category: 'NEW',
        linkUrl: '/returns',
        requiredAnyPermissions: ['returns:read'],
        commitRefs: ['connected-operational-workflows'],
        translations: {
            de: {
                title: 'Reklamationen und Retouren',
                description: 'Prüft Reklamationen, nimmt Ware in Sperrbestand zurück und verknüpft Ersatz, Gutschrift und Erstattung.',
            },
            en: {
                title: 'Complaints and returns',
                description: 'Reviews complaints, receives returned goods into quarantine and links replacement, credit and refund.',
            },
            tr: {
                title: 'Şikâyetler ve iadeler',
                description: 'Şikâyetleri inceler, iadeleri karantinaya alır; ikame, alacak ve geri ödemeyi bağlar.',
            },
            fr: {
                title: 'Réclamations et retours',
                description: 'Examine les réclamations, reçoit les retours en quarantaine et relie remplacement, avoir et remboursement.',
            },
            es: {
                title: 'Reclamaciones y devoluciones',
                description: 'Revisa reclamaciones, recibe devoluciones en cuarentena y vincula sustitución, abono y reembolso.',
            },
        },
    },
    {
        id: 'connected-scanner-picking',
        sequence: 104,
        version: '2026.9.30',
        publishedAt: '2026-09-30T12:00:00.000Z',
        category: 'NEW',
        linkUrl: '/picking',
        requiredAnyPermissions: ['picking:read'],
        commitRefs: ['connected-operational-workflows'],
        translations: {
            de: {
                title: 'Scanner-Kommissionierung',
                description: 'Erfasst Kommissionierung mit Gebindeumrechnung, Chargenprüfung und gespeichertem Fortschritt. Der Belegfortschritt zeigt Positionen zuverlässig in ihrer Belegreihenfolge.',
            },
            en: {
                title: 'Scanner picking',
                description: 'Records picking with packaging conversion, lot checks and saved progress. Document progress shows positions consistently in their document order.',
            },
            tr: {
                title: 'Barkodlu toplama',
                description: 'Ambalaj dönüşümü, parti kontrolü ve kayıtlı ilerleme ile toplama yapar. Belge ilerlemesi, satırları tutarlı biçimde belge sırasıyla gösterir.',
            },
            fr: {
                title: 'Préparation par scanner',
                description: 'Enregistre la préparation avec conversion des emballages, contrôle des lots et progression sauvegardée. La progression du document affiche les lignes de manière fiable dans l’ordre du document.',
            },
            es: {
                title: 'Preparación con escáner',
                description: 'Registra la preparación con conversión de envases, control de lotes y progreso guardado. El progreso del documento muestra las posiciones de forma consistente en el orden del documento.',
            },
        },
    },
    {
        id: 'connected-full-inventory',
        sequence: 105,
        version: '2026.9.30',
        publishedAt: '2026-09-30T12:00:00.000Z',
        category: 'NEW',
        linkUrl: '/inventory-sessions',
        requiredAnyPermissions: ['inventory:read'],
        commitRefs: ['connected-operational-workflows'],
        translations: {
            de: {
                title: 'Vollständige Inventur',
                description: 'Eröffnet Zählaufgaben, sperrt betroffene Artikel und bucht geprüfte Differenzen beim berechtigten Abschluss.',
            },
            en: {
                title: 'Full inventory count',
                description: 'Opens count tasks, freezes affected products and posts reviewed variances at authorized close.',
            },
            tr: {
                title: 'Tam stok sayımı',
                description: 'Sayım görevleri açar, ilgili ürünleri kilitler ve onaylı kapanışta farkları kaydeder.',
            },
            fr: {
                title: 'Inventaire complet',
                description: 'Ouvre des tâches de comptage, bloque les articles concernés et comptabilise les écarts contrôlés à la clôture autorisée.',
            },
            es: {
                title: 'Inventario completo',
                description: 'Abre tareas de recuento, bloquea los artículos afectados y registra diferencias revisadas al cierre autorizado.',
            },
        },
    },
    {
        id: 'connected-delivery-tours',
        sequence: 106,
        version: '2026.9.30',
        publishedAt: '2026-09-30T12:00:00.000Z',
        category: 'NEW',
        linkUrl: '/delivery-tours',
        requiredAnyPermissions: ['tours:read', 'tours:drive'],
        commitRefs: ['connected-operational-workflows'],
        translations: {
            de: {
                title: 'Liefertouren und Liefernachweise',
                description: 'Plant Lieferstopps manuell und speichert mobile Mengen- und Empfängerbestätigungen ohne erneute Lagerbuchung.',
            },
            en: {
                title: 'Delivery tours and proof',
                description: 'Plans stops manually and saves mobile quantity and recipient confirmations without another stock posting.',
            },
            tr: {
                title: 'Teslimat turları ve kanıtlar',
                description: 'Durakları elle planlar ve stoğu yeniden düşmeden mobil miktar ve alıcı onaylarını kaydeder.',
            },
            fr: {
                title: 'Tournées et preuves de livraison',
                description: 'Planifie les arrêts manuellement et enregistre les quantités et confirmations du destinataire sans nouveau mouvement de stock.',
            },
            es: {
                title: 'Rutas y comprobantes de entrega',
                description: 'Planifica paradas manualmente y guarda cantidades y confirmaciones del receptor sin registrar otra salida de existencias.',
            },
        },
    },
    {
        id: 'connected-reusable-containers',
        sequence: 107,
        version: '2026.9.30',
        publishedAt: '2026-09-30T12:00:00.000Z',
        category: 'NEW',
        linkUrl: '/reusable-containers',
        requiredAnyPermissions: ['containers:read'],
        commitRefs: ['connected-operational-workflows'],
        translations: {
            de: {
                title: 'Mehrweg- und Pfandkonten',
                description: 'Führt bestätigte Ausgaben, Rückgaben und Korrekturen; Mengen bleiben von Pfandbelegen und Zahlungen getrennt. Lieferscheine behalten den gespeicherten Ausgabesaldo; fehlende historische Salden bleiben als unbekannt erkennbar.',
            },
            en: {
                title: 'Reusable containers and deposits',
                description: 'Tracks confirmed issues, returns and corrections; quantities remain separate from deposit documents and payments. Delivery notes keep the captured issue balance; missing historical balances remain explicitly unknown.',
            },
            tr: {
                title: 'İadeli ambalaj ve depozito hesapları',
                description: 'Onaylı çıkışları, iadeleri ve düzeltmeleri izler; miktarlar depozito belgeleri ve ödemelerinden ayrı tutulur. İrsaliyeler çıkışta kaydedilen bakiyeyi korur; geçmişte kaydedilmemiş bakiyeler bilinmiyor olarak gösterilir.',
            },
            fr: {
                title: 'Comptes d’emballages et consignes',
                description: 'Suit les sorties confirmées, retours et corrections ; les quantités restent séparées des documents de consigne et paiements. Les bons de livraison conservent le solde enregistré à la sortie ; les soldes historiques manquants restent explicitement inconnus.',
            },
            es: {
                title: 'Cuentas de envases retornables y depósitos',
                description: 'Registra entregas confirmadas, devoluciones y correcciones; las cantidades se separan de documentos y pagos del depósito. Los albaranes conservan el saldo registrado a la entrega; los saldos históricos ausentes se indican como desconocidos.',
            },
        },
    },
    {
        id: 'connected-electronic-invoices',
        sequence: 108,
        version: '2026.9.30',
        publishedAt: '2026-09-30T12:00:00.000Z',
        category: 'NEW',
        linkUrl: '/electronic-invoices',
        requiredAnyPermissions: ['einvoice:read'],
        commitRefs: ['connected-operational-workflows'],
        translations: {
            de: {
                title: 'Elektronische Rechnungen',
                description: 'Prüft strukturierte Ausgangsrechnungen und übernimmt geprüfte Eingangsdateien als kontrollierte Entwürfe.',
            },
            en: {
                title: 'Electronic invoices',
                description: 'Validates structured outgoing invoices and adopts reviewed incoming files as controlled drafts.',
            },
            tr: {
                title: 'Elektronik faturalar',
                description: 'Yapılandırılmış satış faturalarını doğrular ve incelenmiş alış dosyalarını kontrollü taslaklara aktarır.',
            },
            fr: {
                title: 'Factures électroniques',
                description: 'Valide les factures structurées sortantes et reprend les fichiers entrants contrôlés sous forme de brouillons.',
            },
            es: {
                title: 'Facturas electrónicas',
                description: 'Valida facturas estructuradas emitidas e incorpora archivos recibidos revisados como borradores controlados.',
            },
        },
    },
    {
        id: 'responsive-partner-list-actions',
        sequence: 109,
        version: '2026.9.30',
        publishedAt: '2026-09-30T19:30:00.000Z',
        category: 'FIXED',
        linkUrl: '/partners/map',
        requiredAnyPermissions: ['customer:read'],
        commitRefs: ['responsive-partner-list-actions'],
        translations: {
            de: {
                title: 'Partnerlisten auf schmalen Geräten',
                description: 'Die Aktionen für Liste, Karte, Export und neue Geschäftspartner bleiben auch auf schmalen Bildschirmen erreichbar.',
            },
            en: {
                title: 'Partner lists on narrow screens',
                description: 'List, map, export and new partner actions remain accessible on narrow screens.',
            },
            fr: {
                title: 'Listes de partenaires sur petit écran',
                description: 'Les actions de liste, carte, export et création de partenaire restent accessibles sur les petits écrans.',
            },
            es: {
                title: 'Listas de socios en pantallas pequeñas',
                description: 'Las acciones de lista, mapa, exportación y creación de socios siguen accesibles en pantallas pequeñas.',
            },
            tr: {
                title: 'Dar ekranlarda iş ortağı listeleri',
                description: 'Liste, harita, dışa aktarma ve yeni iş ortağı işlemleri dar ekranlarda da erişilebilir kalır.',
            },
        },
    },
    {
        id: 'operations-alert-recovery',
        sequence: 110,
        version: '2026.10.1',
        publishedAt: '2026-10-01T04:50:00.000Z',
        category: 'FIXED',
        linkUrl: '/settings/operations',
        requiredAnyPermissions: ['settings:read'],
        commitRefs: ['operations-alert-recovery'],
        translations: {
            de: {
                title: 'Betriebsalarme ohne Mailserien',
                description: 'Unveränderte Störungen werden einmal gemeldet. Neue Ursachen und Entwarnungen bleiben sichtbar; KI-Dienste sind auch für Hintergrundabläufe erreichbar.',
            },
            en: {
                title: 'Operations alerts without repeated emails',
                description: 'Unchanged incidents are reported once. New causes and recovery remain visible; AI services are also reachable by background tasks.',
            },
            tr: {
                title: 'Tekrarlanan e-postalar olmadan işletim uyarıları',
                description: 'Değişmeyen arızalar bir kez bildirilir. Yeni nedenler ve düzelme görünür kalır; yapay zekâ hizmetlerine arka plan işlemleri de erişebilir.',
            },
            fr: {
                title: 'Alertes de fonctionnement sans courriels répétés',
                description: 'Les incidents inchangés sont signalés une fois. Les nouvelles causes et le rétablissement restent visibles ; les tâches en arrière-plan accèdent aussi aux services d’IA.',
            },
            es: {
                title: 'Alertas operativas sin correos repetidos',
                description: 'Las incidencias sin cambios se notifican una vez. Las nuevas causas y la recuperación siguen visibles; las tareas en segundo plano también acceden a los servicios de IA.',
            },
        },
    },
    {
        id: 'operations-alert-settings',
        sequence: 111,
        version: '2026.10.1',
        publishedAt: '2026-10-01T08:04:44.000Z',
        category: 'NEW',
        linkUrl: '/settings/operations-alerts',
        requiredAnyPermissions: ['operations:read'],
        commitRefs: ['operations-alert-settings'],
        translations: {
            de: {
                title: 'Betriebsalarme selbst steuern',
                description: 'Empfänger, E-Mail-Versand, Versandgrenzen und Erinnerungen pro Mandant einstellen. E-Mails sind zunächst ausgeschaltet. Das Journal zeigt Störungen, Entwarnungen und den Versandstatus auch ohne E-Mail-Versand.',
            },
            en: {
                title: 'Control operations alerts',
                description: 'Set recipients, email delivery, sending limits and reminders for each tenant. Email starts switched off. The journal shows incidents, recovery and delivery status even with email switched off.',
            },
            tr: {
                title: 'İşletim uyarılarını yönetin',
                description: 'Her şirket için alıcıları, e-posta gönderimini, gönderim sınırlarını ve hatırlatmaları ayarlayın. E-posta başlangıçta kapalıdır. Günlük, e-posta kapalıyken de arızaları, düzelmeleri ve gönderim durumunu gösterir.',
            },
            fr: {
                title: 'Gérez les alertes de fonctionnement',
                description: 'Réglez les destinataires, les courriels, les limites d’envoi et les rappels par entreprise. Les courriels sont désactivés au départ. Le journal montre les incidents, le rétablissement et l’état d’envoi même sans courriel.',
            },
            es: {
                title: 'Controle las alertas operativas',
                description: 'Configure destinatarios, correos, límites de envío y recordatorios para cada empresa. El correo está desactivado inicialmente. El registro muestra incidencias, recuperación y estado de envío incluso sin correo.',
            },
        },
    },
    {
        id: 'whatsapp-baileys-connection',
        sequence: 112,
        version: '2026.10.2',
        publishedAt: '2026-10-02T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/whatsapp',
        requiredAnyPermissions: [PERMISSIONS.WHATSAPP_READ],
        commitRefs: ['whatsapp-baileys-connection'],
        translations: {
            de: {
                title: 'WhatsApp-Konto per QR verbinden',
                description: 'Verbinden Sie Ihr eigenes WhatsApp-Konto per QR und senden Sie einzelne Kundennachrichten sowie PDF-Belege. WhatsApp (Baileys) steht bei aktivierter Serveranbindung und regulären Benutzerrechten neben der WhatsApp Business Cloud API bereit. Die inoffizielle Verbindung bleibt gekennzeichnet; Nachrichten zeigen den tatsächlichen Versand- und Zustellstatus.',
            },
            en: {
                title: 'Link your WhatsApp account by QR',
                description: 'Link your own WhatsApp account by QR and send individual customer messages and PDF documents. WhatsApp (Baileys) is available alongside WhatsApp Business Cloud API when the server connection is enabled and normal user permissions apply. The unofficial connection stays labelled; messages show actual sending and delivery status.',
            },
            tr: {
                title: 'WhatsApp hesabınızı QR ile bağlayın',
                description: 'Kendi WhatsApp hesabınızı QR ile bağlayıp tekil müşteri mesajları ve PDF belgeleri gönderin. WhatsApp (Baileys), sunucu bağlantısı etkin olduğunda ve normal kullanıcı yetkileriyle WhatsApp Business Cloud API yanında kullanılabilir. Resmî olmayan bağlantı açıklaması kalıcıdır; mesajlar gerçek gönderim ve teslimat durumunu gösterir.',
            },
            fr: {
                title: 'Associer votre compte WhatsApp par QR',
                description: 'Associez votre propre compte WhatsApp par QR et envoyez des messages clients individuels et des documents PDF. WhatsApp (Baileys) est disponible à côté de WhatsApp Business Cloud API lorsque la connexion serveur est active et selon les droits utilisateurs habituels. La connexion non officielle reste signalée ; les messages affichent l’état réel d’envoi et de livraison.',
            },
            es: {
                title: 'Vincular su cuenta de WhatsApp por QR',
                description: 'Vincule su propia cuenta de WhatsApp por QR y envíe mensajes individuales a clientes y documentos PDF. WhatsApp (Baileys) está disponible junto a WhatsApp Business Cloud API cuando la conexión del servidor está activa y según los permisos habituales. La conexión no oficial sigue identificada; los mensajes muestran el estado real de envío y entrega.',
            },
        },
    },
    {
        id: 'whatsapp-baileys-employee-accounts',
        sequence: 113,
        version: '2026.10.3',
        publishedAt: '2026-10-03T00:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/whatsapp',
        requiredAnyPermissions: ['whatsapp:read'],
        commitRefs: ['whatsapp-baileys-multi-account'],
        translations: {
            de: {
                title: 'WhatsApp-Konten mit gezielter Mitarbeitendenzuordnung',
                description: 'Nutzen Sie mehrere unabhängige WhatsApp-Konten für Kundenchats und PDF-Belege. Nur zugeordnete Mitarbeitende sehen die zugehörigen Chats und erhalten Hinweise bei Verknüpfungsverlust. Lokale Textvorlagen unterstützen den bewussten Versand auch mit PDF. Wählen Sie vorhandene Kontaktmobilnummern, verwenden Sie übliche Nummernformate und ändern Sie eine Chatnummer mit einer eigenen neuen Konversation; der bisherige Verlauf bleibt erhalten. Verfügbare historische Textnachrichten eindeutig bekannter ERP-Kontakte lassen sich ausdrücklich anfordern. Der Umfang hängt vom verknüpften Gerät ab; private Verläufe und das gesamte Adressbuch werden nicht automatisch übernommen. Für einen ersten Verlauf wählen Sie die Übernahme vor dem QR-Scan; bei bestehenden Verknüpfungen kann bewusstes Abmelden und erneutes Verknüpfen nötig sein.',
            },
            en: {
                title: 'WhatsApp accounts with targeted employee access',
                description: 'Use multiple independent WhatsApp accounts for customer chats and PDF documents. Only assigned employees see the matching chats and receive pairing-loss notices. Local text templates support deliberate sending, including PDFs. Select existing contact mobile numbers, use common number formats and change a chat number through a separate new conversation; previous history is preserved. Available historical text messages from unambiguously known ERP contacts can be requested explicitly. The scope depends on the linked device; private history and the full address book are not imported automatically. For initial history, choose the import before the first QR scan; an existing link may require deliberate logout and new pairing.',
            },
            tr: {
                title: 'Çalışan erişimi belirlenen WhatsApp hesapları',
                description: 'Müşteri sohbetleri ve PDF belgeleri için birden fazla bağımsız WhatsApp hesabı kullanın. Yalnızca atanan çalışanlar ilgili sohbetleri görür ve eşleştirme kaybı bildirimi alır. Yerel metin şablonları, PDF dâhil bilinçli gönderimi destekler. Mevcut kişi cep telefonu numaralarını seçin, yaygın numara biçimlerini kullanın ve sohbet numarasını ayrı bir yeni sohbetle değiştirin; önceki geçmiş korunur. Tekil biçimde bilinen ERP kişilerinin mevcut geçmiş metin mesajları açıkça istenebilir. Kapsam bağlı cihaza bağlıdır; özel geçmiş ve tüm adres defteri otomatik aktarılmaz. İlk geçmiş için QR taramasından önce aktarımı seçin; mevcut bağlantıda bilinçli çıkış ve yeniden eşleştirme gerekebilir.',
            },
            fr: {
                title: 'Comptes WhatsApp avec accès ciblé des employés',
                description: 'Utilisez plusieurs comptes WhatsApp indépendants pour les conversations clients et les PDF. Seuls les employés affectés voient les conversations correspondantes et reçoivent les avis de perte d’association. Les modèles texte locaux permettent un envoi explicite, également avec PDF. Choisissez les mobiles existants des contacts, utilisez les formats habituels et changez un numéro avec une nouvelle conversation distincte ; l’ancien historique est conservé. Les anciens messages texte disponibles des contacts ERP connus de manière univoque peuvent être demandés explicitement. Leur étendue dépend de l’appareil associé ; les historiques privés et l’ensemble du carnet d’adresses ne sont pas importés automatiquement. Pour un premier historique, choisissez l’importation avant le scan QR ; une connexion existante peut exiger une déconnexion volontaire et une nouvelle association.',
            },
            es: {
                title: 'Cuentas de WhatsApp con acceso de empleados asignados',
                description: 'Utilice varias cuentas de WhatsApp independientes para conversaciones con clientes y PDF. Solo los empleados asignados ven las conversaciones correspondientes y reciben avisos de pérdida de vinculación. Las plantillas de texto locales permiten enviar de forma explícita, también con PDF. Seleccione móviles existentes de contactos, use formatos habituales y cambie un número mediante una nueva conversación separada; se conserva el historial anterior. Los mensajes de texto históricos disponibles de contactos ERP conocidos de forma inequívoca pueden solicitarse expresamente. El alcance depende del dispositivo vinculado; no se importan automáticamente historiales privados ni toda la agenda. Para el primer historial, elija la importación antes del escaneo QR; una vinculación existente puede requerir cerrar sesión y vincular de nuevo de forma deliberada.',
            },
        },
    },
    {
        id: 'native-ios-customer-visits',
        sequence: 114,
        version: '2026.10.3',
        publishedAt: '2026-10-03T12:00:00.000Z',
        category: 'NEW',
        linkUrl: '/field',
        requiredAnyPermissions: [PERMISSIONS.CUSTOMER_READ],
        commitRefs: ['native-ios-customer-visits'],
        translations: {
            de: {
                title: 'Besuch vorbereiten',
                description: 'Bereiten Sie Kundenbesuche mit Katalog, Fragebögen, Dokumenten und Fotos für die native iPhone- und iPad-App vor. Der geschützte Kundenmodus liefert ausschließlich freigegebene Informationen. Der Mitarbeiter entsperrt zur Übernahme in einen Angebots- oder Auftragsentwurf.',
            },
            en: {
                title: 'Prepare visit',
                description: 'Prepare customer visits with a catalogue, questionnaires, documents and photos in the native iPhone and iPad app. Protected customer mode delivers released information only. The employee unlocks to transfer the selection into a quotation or order draft.',
            },
            tr: {
                title: 'Ziyareti hazırla',
                description: 'Yerel iPhone ve iPad uygulamasında katalog, anket, belge ve fotoğraflarla müşteri ziyaretlerini hazırlayın. Korumalı müşteri modu yalnızca onaylı bilgileri sunar. Çalışan, seçimi teklif veya sipariş taslağına aktarmak için kilidi açar.',
            },
            fr: {
                title: 'Préparer la visite',
                description: 'Préparez les visites clients avec catalogue, questionnaires, documents et photos dans l’application native iPhone et iPad. Le mode client protégé fournit uniquement les informations autorisées. L’employé déverrouille pour transférer le choix en devis ou commande en brouillon.',
            },
            es: {
                title: 'Preparar visita',
                description: 'Prepare visitas con catálogo, cuestionarios, documentos y fotos en la aplicación nativa para iPhone y iPad. El modo cliente protegido muestra solo información autorizada. El empleado desbloquea para transferir la selección a un borrador de oferta o pedido.',
            },
        },
    },
    {
        id: 'native-ios-visit-recovery',
        sequence: 115,
        version: '2026.10.3',
        publishedAt: '2026-10-03T16:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/field',
        requiredAnyPermissions: [PERMISSIONS.CUSTOMER_READ],
        commitRefs: ['native-ios-visit-recovery'],
        translations: {
            de: {
                title: 'Ausstehende Besuchsdaten sicher übernehmen',
                description: 'Mitarbeitende können ausstehende Warenkörbe und Aufnahmen nach Ablauf einer Kundensitzung zum ursprünglichen Kunden übertragen. Die Preise werden vor dem Belegentwurf erneut angezeigt und geprüft. Bei ausgeblendeten Preisen bleiben ältere Fragebogendateien geschützt.',
            },
            en: {
                title: 'Recover pending visit data safely',
                description: 'Employees can transfer pending carts and captures to the original customer after a customer session expires. Prices are shown and checked again before creating a document draft. Older questionnaire files stay protected when prices are hidden.',
            },
            tr: {
                title: 'Bekleyen ziyaret verilerini güvenle aktarın',
                description: 'Çalışanlar müşteri oturumu sona erdiğinde bekleyen sepet ve çekimleri ilk müşteriye aktarabilir. Belge taslağı öncesinde fiyatlar yeniden gösterilir ve kontrol edilir. Fiyatlar gizliyken eski anket dosyaları korunur.',
            },
            fr: {
                title: 'Reprendre les données de visite en attente',
                description: 'Les employés peuvent transférer les paniers et captures en attente au client d’origine après expiration de la session. Les prix sont affichés et revérifiés avant le brouillon. Les anciens fichiers de questionnaire restent protégés lorsque les prix sont masqués.',
            },
            es: {
                title: 'Recuperar datos pendientes de la visita',
                description: 'Los empleados pueden transferir carritos y capturas pendientes al cliente original tras caducar la sesión. Los precios se muestran y revisan antes del borrador. Los archivos anteriores del cuestionario siguen protegidos cuando se ocultan los precios.',
            },
        },
    },
    {
        id: 'native-ios-price-free-files',
        sequence: 116,
        version: '2026.10.3',
        publishedAt: '2026-10-03T18:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/field',
        requiredAnyPermissions: [PERMISSIONS.CUSTOMER_READ],
        commitRefs: ['native-ios-price-free-files'],
        translations: {
            de: {
                title: 'Preisfreie Unterlagen für den Besuch bestätigen',
                description: 'Preisfreie freigegebene Unterlagen können auch bei ausgeblendeten Verkaufspreisen ausgewählt werden. Der Mitarbeiter muss jede Datei für den Besuch prüfen und ausdrücklich bestätigen.',
            },
            en: {
                title: 'Confirm price-free visit files',
                description: 'Released files without prices can also be selected when sales prices are hidden. The employee must review and explicitly confirm each file for the visit.',
            },
            tr: {
                title: 'Fiyatsız ziyaret belgelerini onaylayın',
                description: 'Satış fiyatları gizliyken fiyat içermeyen onaylı belgeler de seçilebilir. Çalışan her dosyayı ziyaret için kontrol edip açıkça onaylamalıdır.',
            },
            fr: {
                title: 'Confirmer les documents de visite sans prix',
                description: 'Les documents autorisés sans prix peuvent aussi être sélectionnés lorsque les prix sont masqués. L’employé doit vérifier et confirmer chaque fichier pour la visite.',
            },
            es: {
                title: 'Confirmar documentos de visita sin precios',
                description: 'También se pueden seleccionar documentos autorizados sin precios cuando se ocultan los precios de venta. El empleado debe revisar y confirmar cada archivo para la visita.',
            },
        },
    },
    {
        id: 'native-ios-protected-file-previews',
        sequence: 117,
        version: '2026.10.3',
        publishedAt: '2026-10-03T18:05:00.000Z',
        category: 'FIXED',
        linkUrl: '/field',
        requiredAnyPermissions: [PERMISSIONS.CUSTOMER_READ],
        commitRefs: ['native-ios-protected-file-previews'],
        translations: {
            de: {
                title: 'Geschützte Dateivorschau im Kundenmodus',
                description: 'Im Kundenmodus bleiben PDF- und Bildvorschauen innerhalb der App. Andere Dateiformate lassen sich erst nach Mitarbeiterentsperrung öffnen, damit private Geräteinhalte geschützt bleiben.',
            },
            en: {
                title: 'Protected file previews in customer mode',
                description: 'In customer mode, PDF and image previews stay inside the app. Other file formats can only be opened after employee unlock to protect private device content.',
            },
            tr: {
                title: 'Müşteri modunda korumalı dosya önizlemesi',
                description: 'Müşteri modunda PDF ve görsel önizlemeleri uygulama içinde kalır. Özel cihaz içeriğini korumak için diğer dosya biçimleri yalnızca çalışan kilidi açıldıktan sonra açılabilir.',
            },
            fr: {
                title: 'Aperçu protégé des fichiers en mode client',
                description: 'En mode client, les aperçus PDF et image restent dans l’application. Les autres formats ne peuvent être ouverts qu’après le déverrouillage employé afin de protéger les contenus privés de l’appareil.',
            },
            es: {
                title: 'Vista previa protegida en modo cliente',
                description: 'En modo cliente, las vistas previas de PDF e imágenes permanecen dentro de la aplicación. Los demás formatos solo pueden abrirse tras el desbloqueo de empleado para proteger el contenido privado del dispositivo.',
            },
        },
    },
    {
        id: 'native-ios-introduction-protection',
        sequence: 118,
        version: '2026.10.3',
        publishedAt: '2026-10-03T18:10:00.000Z',
        category: 'FIXED',
        linkUrl: '/field',
        requiredAnyPermissions: [PERMISSIONS.CUSTOMER_READ],
        commitRefs: ['native-ios-introduction-protection'],
        translations: {
            de: {
                title: 'Besuchsdaten bei Einführungsphasen schützen',
                description: 'Kundenbesuche beachten die ERP-Einführungsphase. Während einer Bereinigung sind Änderungen gesperrt; bereits bestehende Besuche bleiben erhalten.',
            },
            en: {
                title: 'Protect visits during introduction phases',
                description: 'Customer visits follow the ERP introduction phase. Changes are blocked during cleanup; existing visits are preserved.',
            },
            tr: {
                title: 'Devreye alma aşamalarında ziyaretleri koruyun',
                description: 'Müşteri ziyaretleri ERP devreye alma aşamasına uyar. Temizlik sırasında değişiklikler engellenir; mevcut ziyaretler korunur.',
            },
            fr: {
                title: 'Protéger les visites pendant les phases d’introduction',
                description: 'Les visites clients respectent la phase d’introduction ERP. Les modifications sont bloquées pendant le nettoyage ; les visites existantes sont conservées.',
            },
            es: {
                title: 'Proteger las visitas durante las fases de introducción',
                description: 'Las visitas de clientes respetan la fase de introducción del ERP. Los cambios se bloquean durante la limpieza; se conservan las visitas existentes.',
            },
        },
    },
    {
        id: 'everyday-usability-settings',
        sequence: 119,
        version: '2026.10.1',
        publishedAt: '2026-10-04T12:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/settings',
        requiredAnyPermissions: [],
        commitRefs: ['everyday-usability-20261004'],
        translations: {
            de: {
                title: 'Einstellungen schneller finden',
                description: 'Suchen Sie nach Ihrer Aufgabe und finden Sie Einstellungen in verständlichen Bereichen. Navigation und Tastaturkürzel führen zu tatsächlich verfügbaren Seiten.',
            },
            en: {
                title: 'Find settings faster',
                description: 'Search by task and find settings in clear groups. Navigation and keyboard shortcuts lead to pages you can actually access.',
            },
            tr: {
                title: 'Ayarları daha hızlı bulun',
                description: 'Yapacağınız işi arayın ve ayarları anlaşılır gruplarda bulun. Gezinme ve klavye kısayolları erişilebilir sayfalara yönlendirir.',
            },
            fr: {
                title: 'Trouver les paramètres plus vite',
                description: 'Recherchez votre tâche et trouvez les paramètres dans des rubriques claires. Navigation et raccourcis ouvrent des pages réellement accessibles.',
            },
            es: {
                title: 'Encontrar ajustes más rápido',
                description: 'Busque su tarea y encuentre ajustes en grupos claros. La navegación y los atajos abren páginas realmente accesibles.',
            },
        },
    },
    {
        id: 'everyday-usability-customers',
        sequence: 120,
        version: '2026.10.1',
        publishedAt: '2026-10-04T12:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/partners/customers',
        requiredAnyPermissions: ['customer:read'],
        commitRefs: ['everyday-usability-20261004'],
        translations: {
            de: {
                title: 'Kundendaten einfacher bearbeiten',
                description: 'Bearbeiten Sie Kundendaten in übersichtlichen Bereichen. Speichern bleibt erreichbar, Eingaben bleiben bei nachgeladenen Vorgaben erhalten und Fehler führen direkt zum betroffenen Feld.',
            },
            en: {
                title: 'Edit customer information more easily',
                description: 'Edit customer information in clear sections. Save stays within reach, later defaults preserve your input and errors link directly to the affected field.',
            },
            tr: {
                title: 'Müşteri bilgilerini daha kolay düzenleyin',
                description: 'Müşteri bilgilerini düzenli bölümlerde değiştirin. Kaydet erişilebilir kalır, sonradan gelen varsayılanlar girdilerinizi korur ve hatalar ilgili alana yönlendirir.',
            },
            fr: {
                title: 'Modifier les données clients plus facilement',
                description: 'Modifiez les données clients dans des rubriques claires. Enregistrer reste accessible, les valeurs tardives préservent vos saisies et les erreurs mènent au champ concerné.',
            },
            es: {
                title: 'Editar datos de clientes con más facilidad',
                description: 'Edite datos de clientes en secciones claras. Guardar sigue accesible, los valores tardíos conservan sus datos y los errores llevan al campo afectado.',
            },
        },
    },
    {
        id: 'everyday-usability-custom-fields',
        sequence: 121,
        version: '2026.10.1',
        publishedAt: '2026-10-04T12:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/admin/custom-fields',
        requiredAnyPermissions: ['custom_fields:read'],
        commitRefs: ['everyday-usability-20261004'],
        translations: {
            de: {
                title: 'Zusatzfelder verständlicher einrichten',
                description: 'Beginnen Sie mit Bezeichnung, Feldtyp und Kategorie. Technische Einstellungen öffnen Sie bei Bedarf. Beispiele erklären die Eingabeart; Standardwerte wählen Sie nach ihrer Bezeichnung.',
            },
            en: {
                title: 'Set up custom fields more clearly',
                description: 'Start with the label, field type and category. Open technical settings when needed. Examples explain the input type; select defaults by their readable labels.',
            },
            tr: {
                title: 'Ek alanları daha anlaşılır biçimde ayarlayın',
                description: 'Etiket, alan türü ve kategoriyle başlayın. Teknik ayarları gerektiğinde açın. Örnekler girdi türünü açıklar; varsayılanları okunabilir etiketleriyle seçin.',
            },
            fr: {
                title: 'Configurer les champs personnalisés plus clairement',
                description: 'Commencez par le libellé, le type et la catégorie. Ouvrez les paramètres techniques au besoin. Les exemples expliquent la saisie ; choisissez les valeurs par leur libellé.',
            },
            es: {
                title: 'Configurar campos personalizados con más claridad',
                description: 'Empiece por la etiqueta, el tipo y la categoría. Abra los ajustes técnicos cuando los necesite. Los ejemplos explican la entrada; elija valores por su etiqueta.',
            },
        },
    },
    {
        id: 'orgamax-historical-documents',
        sequence: 122,
        version: '2026.10.2',
        publishedAt: '2026-10-05T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/legacy-documents',
        requiredAnyPermissions: ['document:read', 'purchase:read'],
        commitRefs: ['orgamax-migration-20261005'],
        translations: {
            de: {
                title: 'Importierte Stammdaten und Altbelege geschützt lesen',
                description: 'Lesen Sie übernommene Partner und Artikel mit Kontakten, Adressen und Originalbildern intern unter einer festen Prüfsperre. Öffnen Sie historische Beleginhalte, Beziehungen und verfügbare Originalversionen. Die Übernahme gibt keine Daten für Portal oder Versand frei und bucht keine Bestände oder offenen Posten.',
            },
            en: {
                title: 'Read protected imported records and historical documents',
                description: 'Read imported partners and products internally, including contacts, addresses and original images, under a fixed review hold. Open historical document contents, relationships and available original versions. Importing does not release data to the portal or for sending, or post stock or open items.',
            },
            fr: {
                title: 'Consulter les fiches importées et les documents historiques protégés',
                description: 'Consultez en interne les partenaires et articles importés, avec contacts, adresses et images originales, sous un blocage de vérification fixe. Ouvrez les contenus historiques, leurs relations et les versions originales disponibles. L’importation ne publie rien sur le portail, n’autorise aucun envoi et ne comptabilise ni stocks ni postes ouverts.',
            },
            es: {
                title: 'Consultar fichas importadas y documentos históricos protegidos',
                description: 'Consulte internamente socios y productos importados, con contactos, direcciones e imágenes originales, bajo un bloqueo fijo de revisión. Abra contenidos históricos, relaciones y versiones originales disponibles. La importación no autoriza la publicación en el portal ni el envío, y no contabiliza existencias ni partidas abiertas.',
            },
            tr: {
                title: 'Korunan içe aktarılmış kayıtları ve geçmiş belgeleri okuyun',
                description: 'İçe aktarılan iş ortaklarını ve ürünleri, ilgili kişiler, adresler ve özgün görsellerle birlikte sabit inceleme kilidi altında dahili olarak okuyun. Geçmiş belge içeriklerini, ilişkileri ve mevcut özgün sürümleri açın. İçe aktarma portal yayınına veya gönderime izin vermez; stok ya da açık kalem kaydı oluşturmaz.',
            },
        },
    },
    {
        id: 'protected-import-actions',
        sequence: 123,
        version: '2026.10.3',
        publishedAt: '2026-10-06T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/admin/data-hub',
        requiredAnyPermissions: ['imports:read'],
        commitRefs: ['orgamax-protected-import-actions-20261006'],
        translations: {
            de: {
                title: 'Passende Aktionen für geschützte Importe',
                description: 'Geschützte Datenübernahmen lassen sich im allgemeinen Import-Center nicht pauschal zurücksetzen oder fortsetzen. Für eine Wiederaufnahme ist der geprüfte Übernahmeablauf erforderlich.',
            },
            en: {
                title: 'Appropriate actions for protected imports',
                description: 'Protected imports cannot be rolled back or resumed through the general import center. Resuming them requires the verified transfer procedure.',
            },
            fr: {
                title: 'Actions adaptées aux importations protégées',
                description: 'Les importations protégées ne peuvent pas être annulées ou reprises depuis le centre général d’importation. Leur reprise suit la procédure de transfert vérifiée.',
            },
            es: {
                title: 'Acciones adecuadas para importaciones protegidas',
                description: 'Las importaciones protegidas no se pueden revertir ni reanudar desde el centro general de importación. La reanudación sigue el procedimiento de transferencia verificado.',
            },
            tr: {
                title: 'Korunan içe aktarmalar için uygun işlemler',
                description: 'Korunan veri aktarımları genel içe aktarma merkezinden geri alınamaz veya sürdürülemez. Sürdürme işlemi doğrulanmış aktarım yordamı üzerinden yapılır.',
            },
        },
    },
    {
        id: 'readable-imported-product-details',
        sequence: 124,
        version: '2026.10.4',
        publishedAt: '2026-10-06T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/products',
        requiredAnyPermissions: ['product:read'],
        commitRefs: ['fix-products-wrap-imported-source-details'],
        translations: {
            de: {
                title: 'Lange Artikelangaben auf kleinen Bildschirmen lesen',
                description: 'Artikel und übernommene Quellangaben bleiben auch auf schmalen Bildschirmen lesbar. Lange Namen, Feldbezeichnungen und Werte umbrechen vollständig.',
            },
            en: {
                title: 'Read long product details on small screens',
                description: 'Product details and imported source values remain readable on narrow screens. Long names, field labels and values wrap without truncation.',
            },
            fr: {
                title: 'Lire les longues données article sur un petit écran',
                description: 'La fiche article et les données source reprises restent lisibles sur les écrans étroits. Les noms, libellés et valeurs longs passent à la ligne sans être tronqués.',
            },
            es: {
                title: 'Leer datos largos de artículos en pantallas pequeñas',
                description: 'Los detalles de los artículos y los datos originales importados se mantienen legibles en pantallas estrechas. Los nombres, etiquetas y valores largos se ajustan a varias líneas sin truncarse.',
            },
            tr: {
                title: 'Uzun ürün bilgilerini küçük ekranlarda okuyun',
                description: 'Ürün bilgileri ve içe aktarılan kaynak değerleri dar ekranlarda okunabilir kalır. Uzun adlar, alan etiketleri ve değerler kesilmeden alt satırlara kaydırılır.',
            },
        },
    },
    {
        id: 'orgamax-editable-masters',
        sequence: 125,
        version: '2026.10.5',
        publishedAt: '2026-10-06T05:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/customers',
        requiredAnyPermissions: ['customer:write', 'product:write'],
        commitRefs: ['orgamax-editable-masters-20261006'],
        translations: {
            de: {
                title: 'Mit übernommenen Stammdaten weiterarbeiten',
                description: 'Bearbeiten Sie übernommene Kunden, Kontakte, Adressen und Artikel und verwenden Sie sie für neue Entwürfe. Originalnachweise und Altbelege bleiben unverändert; offene Angaben werden vor den davon abhängigen Vorgängen geprüft.',
            },
            en: {
                title: 'Continue working with imported master data',
                description: 'Edit imported customers, contacts, addresses and products and use them in new drafts. Original evidence and historical documents remain unchanged; missing facts are checked before their dependent operations.',
            },
            fr: {
                title: 'Continuer avec les données de base reprises',
                description: 'Modifiez les clients, contacts, adresses et articles repris et utilisez-les dans de nouveaux brouillons. Les justificatifs originaux et les documents historiques restent inchangés ; les informations manquantes sont vérifiées avant les opérations qui en dépendent.',
            },
            es: {
                title: 'Seguir trabajando con datos maestros importados',
                description: 'Edite clientes, contactos, direcciones y artículos importados y úselos en nuevos borradores. Las pruebas originales y los documentos históricos permanecen intactos; los datos ausentes se comprueban antes de las operaciones que los necesitan.',
            },
            tr: {
                title: 'Aktarılan ana verilerle çalışmaya devam edin',
                description: 'Aktarılan müşterileri, ilgili kişileri, adresleri ve ürünleri düzenleyin ve yeni taslaklarda kullanın. Özgün kanıtlar ve geçmiş belgeler değişmez; eksik bilgiler ilgili işlemlerden önce kontrol edilir.',
            },
        },
    },
    {
        id: 'document-concurrent-master-use',
        sequence: 126,
        version: '2026.10.6',
        publishedAt: '2026-10-06T13:40:00.000Z',
        category: 'FIXED',
        linkUrl: '/documents',
        requiredAnyPermissions: ['document:write'],
        commitRefs: ['orgamax-concurrent-master-use-20261006'],
        translations: {
            de: {
                title: 'Aufträge gleichzeitig erfassen',
                description: 'Mehrere Benutzer können Aufträge mit denselben Artikeln gleichzeitig erfassen. Wiederholte Portalbestellungen erzeugen weiterhin nur einen Auftrag. Übernahmenachweise bleiben auch beim Zurücksetzen eines Einführungsmandanten erhalten.',
            },
            en: {
                title: 'Create orders concurrently',
                description: 'Several users can create orders for the same products concurrently. Repeated portal submissions still create only one order. Import evidence is retained when an introduction tenant is reset.',
            },
            fr: {
                title: 'Saisir des commandes simultanément',
                description: 'Plusieurs utilisateurs peuvent saisir simultanément des commandes pour les mêmes articles. Les envois répétés depuis le portail ne créent toujours qu’une seule commande. Les justificatifs de reprise sont conservés lors de la réinitialisation d’un locataire en phase d’introduction.',
            },
            es: {
                title: 'Crear pedidos simultáneamente',
                description: 'Varios usuarios pueden crear pedidos con los mismos artículos simultáneamente. Los envíos repetidos desde el portal siguen creando un solo pedido. Las pruebas de importación se conservan al restablecer un entorno de introducción.',
            },
            tr: {
                title: 'Siparişleri eş zamanlı oluşturun',
                description: 'Birden fazla kullanıcı aynı ürünler için eş zamanlı sipariş oluşturabilir. Portaldan tekrarlanan gönderimler yine yalnızca bir sipariş oluşturur. Başlangıç aşamasındaki kiracı sıfırlandığında aktarım kanıtları korunur.',
            },
        },
    },
    {
        id: 'migration-readable-failures',
        sequence: 127,
        version: '2026.10.6',
        publishedAt: '2026-10-06T20:20:00.000Z',
        category: 'FIXED',
        linkUrl: '/admin/data-hub',
        requiredAnyPermissions: ['imports:read'],
        commitRefs: ['orgamax-import-job-status-20261006'],
        translations: {
            de: {
                title: 'Status und Hinweise zu Übernahmen prüfen',
                description: 'Auch unterbrochene Übernahmen und Vorschauen mit Fehlern lassen sich in der Importhistorie öffnen. Hinweise unterscheiden den gesamten Lauf von einer bestimmten Quellzeile. Klären Sie die Ursache vor der kontrollierten Fortsetzung; bereits gespeicherte Nachweise bleiben unverändert.',
            },
            en: {
                title: 'Review data transfer status and issues',
                description: 'Interrupted data transfers and previews with errors remain accessible in import history. Issues distinguish the whole run from a specific source row. Resolve the cause before controlled resumption; stored evidence remains unchanged.',
            },
            fr: {
                title: 'Vérifier l’état et les anomalies des reprises',
                description: 'Les reprises interrompues et les aperçus comportant des erreurs restent accessibles dans l’historique des imports. Les indications distinguent toute la reprise d’une ligne source précise. Résolvez la cause avant la reprise contrôlée ; les justificatifs enregistrés restent inchangés.',
            },
            es: {
                title: 'Revisar el estado y las incidencias de las importaciones',
                description: 'Las importaciones interrumpidas y las vistas previas con errores siguen accesibles en el historial. Las indicaciones distinguen toda la ejecución de una fila de origen concreta. Resuelva la causa antes de continuar de forma controlada; las pruebas guardadas permanecen intactas.',
            },
            tr: {
                title: 'Aktarım durumunu ve sorunlarını inceleyin',
                description: 'Kesintiye uğrayan aktarımlara ve hata içeren önizlemelere aktarım geçmişinden erişilebilir. Bildirimler tüm aktarımı belirli bir kaynak satırından ayırır. Kontrollü devam etmeden önce nedeni giderin; kaydedilen kanıtlar değişmez.',
            },
        },
    },
    {
        id: 'historical-customer-search',
        sequence: 128,
        version: '2026.10.7',
        publishedAt: '2026-10-07T08:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/legacy-documents',
        requiredAnyPermissions: ['document:read', 'purchase:read'],
        commitRefs: ['orgamax-customer-history-search-20261007'],
        translations: {
            de: {
                title: 'Altbelege in der Kundenakte und Suche',
                description: 'Altbelege erscheinen direkt in der Kundenakte und lassen sich über ihre ursprüngliche Belegnummer in der globalen Suche finden. Die geschützten Originale bleiben unverändert; historische Beträge werden nicht erneut gebucht.',
            },
            en: {
                title: 'Historical documents in customer records and search',
                description: 'Historical documents appear directly in customer records and can be found by their original number in global search. Protected originals remain unchanged; historical amounts are not posted again.',
            },
            fr: {
                title: 'Documents historiques dans la fiche client et la recherche',
                description: 'Les documents historiques apparaissent dans la fiche client et sont accessibles par leur numéro original dans la recherche globale. Les originaux protégés restent inchangés ; les montants historiques ne sont pas comptabilisés à nouveau.',
            },
            es: {
                title: 'Documentos históricos en la ficha del cliente y la búsqueda',
                description: 'Los documentos históricos aparecen en la ficha del cliente y se encuentran por su número original en la búsqueda global. Los originales protegidos permanecen intactos; los importes históricos no se contabilizan de nuevo.',
            },
            tr: {
                title: 'Müşteri kaydında ve aramada geçmiş belgeler',
                description: 'Geçmiş belgeler müşteri kaydında görünür ve genel aramada özgün numaralarıyla bulunabilir. Korunan özgün belgeler değişmez; geçmiş tutarlar yeniden kaydedilmez.',
            },
        },
    },
    {
        id: 'historical-document-categories',
        sequence: 129,
        version: '2026.10.7',
        publishedAt: '2026-10-07T09:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/documents',
        requiredAnyPermissions: ['document:read'],
        commitRefs: ['orgamax-category-provenance-20261007'],
        translations: {
            de: {
                title: 'Belege in den gewohnten Kategorien',
                description: 'Übernommene Angebote, Aufträge, Lieferscheine und Rechnungen sind direkt in der passenden Belegkategorie auffindbar. Herkunftsdetails lassen sich aufklappen und wieder ausblenden; Originale und fachliche Sperren bleiben erhalten.',
            },
            en: {
                title: 'Documents in familiar categories',
                description: 'Imported quotes, orders, delivery notes and invoices are available in their matching document categories. Source details can be expanded and hidden again; originals and business restrictions remain intact.',
            },
            fr: {
                title: 'Documents dans les catégories habituelles',
                description: 'Les devis, commandes, bons de livraison et factures importés sont accessibles dans leur catégorie respective. Les détails de provenance peuvent être affichés ou masqués ; les originaux et restrictions métier restent préservés.',
            },
            es: {
                title: 'Documentos en las categorías habituales',
                description: 'Las ofertas, pedidos, albaranes y facturas importados están disponibles en su categoría correspondiente. Los detalles del origen se pueden mostrar y ocultar; se conservan los originales y las restricciones de negocio.',
            },
            tr: {
                title: 'Belgeler alışılmış kategorilerde',
                description: 'Aktarılan teklifler, siparişler, irsaliyeler ve faturalar ilgili belge kategorilerinde bulunabilir. Kaynak ayrıntıları açılıp gizlenebilir; özgün belgeler ve iş kısıtlamaları korunur.',
            },
        },
    },
    {
        id: 'imported-native-additional-fields',
        sequence: 130,
        version: '2026.10.7',
        publishedAt: '2026-10-07T16:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/partners/customers',
        requiredAnyPermissions: ['customer:read'],
        commitRefs: ['orgamax-native-additional-fields-20261007'],
        translations: {
            de: {
                title: 'Übernommene Zusatzfelder bearbeiten',
                description: 'Bearbeiten Sie bestätigte übernommene Zusatzfelder direkt am Kunden, Lieferanten oder Artikel. Ungeklärte Auswahlwerte bleiben erkennbar; Originalnachweise und historische Belege bleiben unverändert. Definitionen werden nicht automatisch veröffentlicht.',
            },
            en: {
                title: 'Edit imported additional fields',
                description: 'Edit confirmed imported additional fields directly on a customer, supplier or product. Unresolved selections remain visible; original evidence and historical documents stay unchanged. Definitions are not published automatically.',
            },
            fr: {
                title: 'Modifier les champs supplémentaires importés',
                description: 'Modifiez les champs importés confirmés directement sur un client, fournisseur ou article. Les sélections non résolues restent identifiables ; les justificatifs originaux et documents historiques restent inchangés. Les définitions ne sont pas publiées automatiquement.',
            },
            es: {
                title: 'Editar campos adicionales importados',
                description: 'Edite campos importados confirmados directamente en un cliente, proveedor o artículo. Las selecciones sin resolver siguen visibles; las pruebas originales y documentos históricos permanecen intactos. Las definiciones no se publican automáticamente.',
            },
            tr: {
                title: 'Aktarılan ek alanları düzenleyin',
                description: 'Onaylanan aktarılmış ek alanları müşteri, tedarikçi veya üründe doğrudan düzenleyin. Çözümlenmemiş seçimler görünür kalır; özgün kanıtlar ve geçmiş belgeler değişmez. Tanımlar otomatik yayımlanmaz.',
            },
        },
    },
    {
        id: 'efficient-introduction-inventory',
        sequence: 131,
        version: '2026.10.7',
        publishedAt: '2026-10-07T22:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/settings/introduction',
        requiredAnyPermissions: ['introduction:manage'],
        commitRefs: ['introduction-inventory-projection-20261007'],
        translations: {
            de: {
                title: 'Bestand vor der Einführung schneller prüfen',
                description: 'Die Einführungs-Vorprüfung zählt auch umfangreiche Bestände effizienter. Erhaltene Datensätze und Testdaten bleiben getrennt; Aktivierungs- und Bereinigungssperren bleiben bestehen.',
            },
            en: {
                title: 'Review introduction inventories faster',
                description: 'The introduction review counts large inventories more efficiently. Preserved records and test data remain separate; activation and cleanup restrictions stay in place.',
            },
            fr: {
                title: 'Vérifier plus rapidement les données existantes',
                description: 'La vérification de mise en service compte plus efficacement les volumes importants. Les enregistrements conservés et les données de test restent séparés ; les restrictions d’activation et de nettoyage sont maintenues.',
            },
            es: {
                title: 'Revisar más rápido los datos existentes',
                description: 'La revisión de puesta en marcha cuenta grandes volúmenes de datos de forma más eficiente. Los registros conservados y los datos de prueba siguen separados; se mantienen los bloqueos de activación y limpieza.',
            },
            tr: {
                title: 'Mevcut verileri daha hızlı inceleyin',
                description: 'Devreye alma incelemesi büyük veri kümelerini daha verimli sayar. Korunan kayıtlar ile test verileri ayrı kalır; etkinleştirme ve temizleme kısıtlamaları korunur.',
            },
        },
    },
    {
        id: 'focused-master-data-provenance',
        sequence: 132,
        version: '2026.10.8',
        publishedAt: '2026-10-08T00:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/partners/customers',
        requiredAnyPermissions: ['customer:read'],
        commitRefs: ['orgamax-daily-ui-20261008'],
        translations: {
            de: {
                title: 'Stammdaten übersichtlicher bearbeiten',
                description: 'Kunden- und Artikeldaten stehen im Mittelpunkt. Datenherkunft ist am Ende der Stammdaten einklappbar; Hinweise zur Nutzung übernommener Zusatzfelder sind je Feldgruppe zusammengefasst.',
            },
            en: {
                title: 'Clearer master data screens',
                description: 'Customer and product data take priority. Data origin can be expanded at the end of master data; availability notes for imported additional fields are grouped by category.',
            },
            fr: {
                title: 'Des fiches plus lisibles',
                description: 'Les données clients et articles passent au premier plan. Leur origine peut être consultée en bas de la fiche ; les indications d’utilisation des champs importés sont regroupées par catégorie.',
            },
            es: {
                title: 'Fichas de datos más claras',
                description: 'Los datos de clientes y artículos ocupan el primer plano. Su origen se puede consultar al final de la ficha; las indicaciones de uso de campos importados se agrupan por categoría.',
            },
            tr: {
                title: 'Daha anlaşılır ana veri ekranları',
                description: 'Müşteri ve ürün bilgileri ön plandadır. Veri kaynağı ana verilerin sonunda açılabilir; aktarılan ek alanların kullanım açıklamaları kategori başına birleştirilmiştir.',
            },
        },
    },
    {
        id: 'controlled-self-service-orgamax-import',
        sequence: 133,
        version: '2026.10.8',
        publishedAt: '2026-10-08T06:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/admin/data-hub',
        requiredAnyPermissions: ['imports:read'],
        commitRefs: ['orgamax-self-import-20261008'],
        translations: {
            de: {
                title: 'Daten selbst kontrolliert übernehmen',
                description: 'Importieren Sie Stammdaten, kundenbezogene Preise, Lieferantenstaffeln sowie vorbereitete Bild- und Altbelegpakete in Staging. Quellschlüssel erhalten Zuordnungen und manuelle Änderungen bleiben beim Überspringen bestehen.',
            },
            en: {
                title: 'Import your data with control',
                description: 'Import master data, customer prices, supplier tiers and prepared image or historical document packages in Staging. Source keys retain links and Skip preserves manual edits.',
            },
            fr: {
                title: 'Importer vos données de manière contrôlée',
                description: 'Importez fiches, prix clients, paliers fournisseurs et paquets préparés d’images ou de documents historiques dans Staging. Les identifiants conservent les liens et Ignorer préserve les modifications manuelles.',
            },
            es: {
                title: 'Importar sus datos de forma controlada',
                description: 'Importe fichas, precios de cliente, escalas de proveedor y paquetes preparados de imágenes o documentos históricos en Staging. Las claves conservan los enlaces y Omitir preserva cambios manuales.',
            },
            tr: {
                title: 'Verilerinizi kontrollü aktarın',
                description: 'Ana verileri, müşteri fiyatlarını, tedarikçi kademelerini ve hazırlanmış görsel veya geçmiş belge paketlerini Staging ortamına aktarın. Kaynak anahtarları bağlantıları, Atla seçeneği manuel değişiklikleri korur.',
            },
        },
    },
    {
        id: 'complete-imported-contact-responsibilities',
        sequence: 134,
        version: '2026.10.8',
        publishedAt: '2026-10-08T07:30:00.000Z',
        category: 'FIXED',
        linkUrl: '/admin/data-hub',
        requiredAnyPermissions: ['imports:read'],
        commitRefs: ['self-import-contact-responsibilities-20261008'],
        translations: {
            de: {
                title: 'Zuständigkeiten vollständig importieren',
                description: 'Ansprechpartner-Zuständigkeiten werden als vollständige Liste übernommen. Kommas innerhalb einer Zuständigkeit bleiben erhalten; unklare Listen werden zur Korrektur angezeigt.',
            },
            en: {
                title: 'Import complete contact responsibilities',
                description: 'Contact responsibilities are imported as complete lists. Commas inside a responsibility are preserved; unclear lists are flagged for correction.',
            },
            fr: {
                title: 'Importer toutes les responsabilités des contacts',
                description: 'Les responsabilités des contacts sont importées sous forme de listes complètes. Les virgules dans un intitulé sont conservées ; les listes ambiguës sont signalées.',
            },
            es: {
                title: 'Importar responsabilidades completas de contactos',
                description: 'Las responsabilidades de los contactos se importan como listas completas. Se conservan las comas dentro de cada responsabilidad y se señalan las listas ambiguas.',
            },
            tr: {
                title: 'İlgili kişilerin sorumluluklarını eksiksiz aktarın',
                description: 'İlgili kişilerin sorumlulukları eksiksiz listeler olarak aktarılır. Sorumluluk içindeki virgüller korunur; belirsiz listeler düzeltme için işaretlenir.',
            },
        },
    },
    {
        id: 'spreadsheet-originals-and-purchase-price-basis',
        sequence: 135,
        version: '2026.10.8',
        publishedAt: '2026-10-08T08:30:00.000Z',
        category: 'FIXED',
        linkUrl: '/admin/data-hub',
        requiredAnyPermissions: ['imports:read'],
        commitRefs: ['self-import-originals-price-basis-20261008'],
        translations: {
            de: {
                title: 'Originalanlagen und Einkaufspreise zuverlässig übernehmen',
                description: 'Bildpakete verknüpfen auch Tabellenartikel. Geschützte Originalanlagen bleiben erreichbar. Automatische Einkaufspreise folgen Menge, Einheit und Währung; unklare Preise erfordern eine ausdrückliche Eingabe.',
            },
            en: {
                title: 'Reliable original attachments and purchase prices',
                description: 'Image packages link spreadsheet products too. Protected original attachments remain accessible. Automatic purchase prices follow quantity, unit and currency; unknown prices require explicit input.',
            },
            fr: {
                title: 'Reprendre les pièces originales et les prix d’achat',
                description: 'Les paquets d’images relient aussi les articles de tableurs. Les pièces originales protégées restent accessibles. Les prix automatiques suivent quantité, unité et devise ; les prix inconnus nécessitent une saisie explicite.',
            },
            es: {
                title: 'Conservar adjuntos originales y precios de compra',
                description: 'Los paquetes de imágenes vinculan también artículos de hojas de cálculo. Los originales protegidos siguen accesibles. Los precios automáticos siguen cantidad, unidad y moneda; los desconocidos requieren entrada explícita.',
            },
            tr: {
                title: 'Özgün ekleri ve alış fiyatlarını güvenilir aktarın',
                description: 'Görsel paketleri tablodan aktarılan ürünlere de bağlanır. Korunan özgün ekler erişilebilir kalır. Otomatik alış fiyatları miktar, birim ve para birimine göre kontrol edilir; bilinmeyen fiyatlar açık giriş gerektirir.',
            },
        },
    },
    {
        id: 'efficient-large-additional-field-spreadsheets',
        sequence: 136,
        version: '2026.10.8',
        publishedAt: '2026-10-08T20:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/admin/data-hub',
        requiredAnyPermissions: ['imports:read'],
        commitRefs: ['efficient-xlsx-analysis-20261008'],
        translations: {
            de: {
                title: 'Große Zusatzfeld-Dateien zügig einlesen',
                description: 'Umfangreiche Excel-Dateien mit Zusatzfeldwerten werden effizient geprüft. Tabellenblätter, Zeilenzahlen und Vorschau bleiben erhalten. Erst eine bestätigte Ausführung übernimmt Werte.',
            },
            en: {
                title: 'Read large additional-field files efficiently',
                description: 'Large Excel files containing additional-field values are checked efficiently. Worksheets, row counts and previews are preserved. Values are imported only after explicit confirmation.',
            },
            fr: {
                title: 'Lire efficacement les fichiers de champs volumineux',
                description: 'Les fichiers Excel volumineux de valeurs de champs personnalisés sont contrôlés efficacement. Les feuilles, nombres de lignes et aperçus sont conservés. Les valeurs sont reprises après confirmation explicite.',
            },
            es: {
                title: 'Leer archivos grandes de campos adicionales',
                description: 'Los archivos Excel grandes con valores de campos adicionales se comprueban con rapidez. Se conservan las hojas, recuentos y vistas previas. Los valores solo se importan tras una confirmación explícita.',
            },
            tr: {
                title: 'Büyük ek alan dosyalarını verimli okuyun',
                description: 'Ek alan değerleri içeren büyük Excel dosyaları verimli biçimde kontrol edilir. Sayfalar, satır sayıları ve önizlemeler korunur. Değerler yalnız açık onaydan sonra aktarılır.',
            },
        },
    },
    {
        id: 'configured-product-base-units',
        sequence: 137,
        version: '2026.10.9',
        publishedAt: '2026-10-09T19:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/products',
        requiredAnyPermissions: ['product:read'],
        commitRefs: ['custom-base-units-20261009'],
        translations: {
            de: {
                title: 'Gespeicherte Basiseinheiten verwenden',
                description: 'In der geführten Einrichtung gespeicherte Einheiten stehen jetzt bei Artikeln und beim Import zur Verfügung. Bestehende Artikel behalten ihre Einheit, bis sie ausdrücklich geändert wird.',
            },
            en: {
                title: 'Use saved base units',
                description: 'Units saved in guided setup are now available for products and imports. Existing products keep their unit until it is explicitly changed.',
            },
            fr: {
                title: 'Utiliser les unités de base enregistrées',
                description: 'Les unités enregistrées dans la configuration guidée sont disponibles pour les articles et les imports. Les articles existants conservent leur unité jusqu’à une modification explicite.',
            },
            es: {
                title: 'Usar unidades base guardadas',
                description: 'Las unidades guardadas en la configuración guiada están disponibles en artículos e importaciones. Los artículos existentes conservan su unidad hasta que se cambie expresamente.',
            },
            tr: {
                title: 'Kaydedilen temel birimleri kullanın',
                description: 'Rehberli kurulumda kaydedilen birimler artık ürünlerde ve içe aktarmada kullanılabilir. Mevcut ürünler, açıkça değiştirilene kadar birimlerini korur.',
            },
        },
    },
    {
        id: 'orgamax-packages-in-production',
        sequence: 138,
        version: '2026.10.9',
        publishedAt: '2026-10-09T20:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/admin/data-hub',
        requiredAnyPermissions: ['imports:read'],
        commitRefs: ['orgamax-production-import-20261009'],
        translations: {
            de: {
                title: 'orgaMAX-Bilder und Historie in Produktion importieren',
                description: 'Vorbereitete Bild- und Altbelegpakete lassen sich auch in Produktion übernehmen. Prüfen und bestätigen Sie den Mandanten und die Umgebung, kontrollieren Sie die Vorschau und bestätigen Sie anschließend die Übernahme.',
            },
            en: {
                title: 'Import orgaMAX images and history in production',
                description: 'Prepared image and historical document packages can also be imported in production. Check and confirm the tenant and environment, review the preview and then explicitly confirm the import.',
            },
            fr: {
                title: 'Importer les images et l’historique orgaMAX en production',
                description: 'Les paquets préparés d’images et de documents historiques peuvent aussi être importés en production. Vérifiez et confirmez le tenant et l’environnement, contrôlez l’aperçu, puis confirmez explicitement l’import.',
            },
            es: {
                title: 'Importar imágenes e historial de orgaMAX en producción',
                description: 'Los paquetes preparados de imágenes y documentos históricos también se pueden importar en producción. Compruebe y confirme el tenant y el entorno, revise la vista previa y confirme expresamente la importación.',
            },
            tr: {
                title: 'orgaMAX görsellerini ve geçmişini üretimde içe aktarın',
                description: 'Hazırlanmış görsel ve geçmiş belge paketleri üretim ortamında da içe aktarılabilir. Kiracıyı ve ortamı kontrol edip onaylayın, önizlemeyi inceleyin ve ardından aktarımı açıkça onaylayın.',
            },
        },
    },
    {
        id: 'partial-product-import-updates',
        sequence: 139,
        version: '2026.10.9',
        publishedAt: '2026-10-09T20:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/admin/data-hub',
        requiredAnyPermissions: ['imports:read'],
        commitRefs: ['partial-product-import-updates-20261009'],
        translations: {
            de: {
                title: 'Einzelne Artikelangaben importieren',
                description: 'Aktualisieren Sie Artikel anhand ihrer Artikelnummer, etwa nur die EAN. Ein Name ist nur für neue Artikel nötig. Nicht zugeordnete Felder und standardmäßig leere Zellen erhalten bestehende Werte. Als Text gelieferte EAN-Werte behalten führende Nullen.',
            },
            en: {
                title: 'Import selected product details',
                description: 'Update products by article number, for example just the EAN. A name is only needed for new products. Unmapped fields and, by default, empty cells preserve existing values. EAN values supplied as text retain leading zeros.',
            },
            fr: {
                title: 'Importer certains détails des articles',
                description: 'Mettez à jour les articles par leur numéro, par exemple uniquement l’EAN. Le nom est nécessaire seulement pour les nouveaux articles. Les champs non associés et, par défaut, les cellules vides conservent les valeurs existantes. Les EAN fournis comme texte conservent les zéros initiaux.',
            },
            es: {
                title: 'Importar datos concretos de artículos',
                description: 'Actualice artículos por su número, por ejemplo solo el EAN. El nombre solo es necesario para artículos nuevos. Los campos sin asignar y, por defecto, las celdas vacías conservan los valores existentes. Los EAN proporcionados como texto conservan los ceros iniciales.',
            },
            tr: {
                title: 'Ürünlerin belirli bilgilerini içe aktarın',
                description: 'Ürünleri ürün numarasıyla, örneğin yalnızca EAN değerini değiştirerek güncelleyin. Ad yalnızca yeni ürünler için gereklidir. Eşlenmeyen alanlar ve varsayılan olarak boş hücreler mevcut değerleri korur. Metin olarak sağlanan EAN değerleri baştaki sıfırları korur.',
            },
        },
    },
    {
        id: 'persistent-import-duplicate-decisions',
        sequence: 140,
        version: '2026.10.9',
        publishedAt: '2026-10-09T21:39:00.000Z',
        category: 'FIXED',
        linkUrl: '/admin/data-hub',
        requiredAnyPermissions: ['imports:read'],
        commitRefs: ['import-duplicate-decisions-20261009'],
        translations: {
            de: {
                title: 'Dublettenentscheidungen im Import weiterbearbeiten',
                description: 'Beim Auswählen einer Dublettenentscheidung bleibt die Liste sichtbar. Mehrere Entscheidungen können nacheinander getroffen werden. Ein neuer Testlauf prüft die Auswahl und zeigt weitere offene Entscheidungen auch bei umfangreichen Dateien. Erst das aktuelle Prüfergebnis kann bestätigt werden.',
            },
            en: {
                title: 'Continue reviewing import duplicates',
                description: 'The list stays visible when a duplicate decision is selected. Several decisions can be made in sequence. A new dry run checks the choices and shows further pending decisions, including in large files. Only the current validated result can be confirmed.',
            },
            fr: {
                title: 'Poursuivre les décisions sur les doublons à importer',
                description: 'La liste reste visible après le choix d’une décision sur un doublon. Plusieurs décisions peuvent être prises à la suite. Un nouveau test vérifie les choix et affiche les décisions restantes, même pour les fichiers volumineux. Seul le résultat validé à jour peut être confirmé.',
            },
            es: {
                title: 'Continuar revisando duplicados de la importación',
                description: 'La lista permanece visible al elegir una decisión sobre un duplicado. Se pueden tomar varias decisiones seguidas. Una nueva prueba comprueba las opciones y muestra las decisiones pendientes, también en archivos grandes. Solo se puede confirmar el resultado validado actual.',
            },
            tr: {
                title: 'İçe aktarma mükerrer kararlarına devam edin',
                description: 'Mükerrer kayıt için bir karar seçildiğinde liste görünür kalır. Birden fazla karar art arda verilebilir. Yeni test seçimleri doğrular ve büyük dosyalarda da kalan kararları gösterir. Yalnızca güncel doğrulama sonucu onaylanabilir.',
            },
        },
    },
    {
        id: 'bulk-import-duplicate-decisions',
        sequence: 141,
        version: '2026.10.10',
        publishedAt: '2026-10-10T00:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/admin/data-hub',
        requiredAnyPermissions: ['imports:read'],
        commitRefs: ['import-bulk-decisions-20261010'],
        translations: {
            de: {
                title: 'Dubletten im Import gemeinsam auswählen',
                description: 'Wählen Sie die Aktualisierung für alle Einträge mit genau einem passenden bestehenden Datensatz, auch außerhalb der Vorschau. Einzelentscheidungen bleiben erhalten; mehrdeutige Treffer bleiben offen. Prüfen Sie einen neuen Testlauf und bestätigen Sie den Import ausdrücklich.',
            },
            en: {
                title: 'Resolve import duplicates together',
                description: 'Choose updates for all records with exactly one matching existing record, including rows outside the preview. Individual decisions are retained; ambiguous matches remain open. Review a new dry run and explicitly confirm the import.',
            },
            fr: {
                title: 'Traiter les doublons d’import ensemble',
                description: 'Choisissez la mise à jour de tous les enregistrements ayant exactement une correspondance existante, même hors de l’aperçu. Les décisions individuelles sont conservées ; les correspondances ambiguës restent en attente. Vérifiez un nouveau test et confirmez explicitement l’import.',
            },
            es: {
                title: 'Resolver juntos los duplicados de la importación',
                description: 'Seleccione la actualización de todos los registros con exactamente una coincidencia existente, también fuera de la vista previa. Se conservan las decisiones individuales; las coincidencias ambiguas quedan pendientes. Revise una nueva prueba y confirme expresamente la importación.',
            },
            tr: {
                title: 'İçe aktarma mükerrerlerini topluca seçin',
                description: 'Önizleme dışındaki satırlar dahil, tam olarak bir mevcut kayıtla eşleşen tüm kayıtları güncellemek üzere seçin. Tek tek verilen kararlar korunur; belirsiz eşleşmeler açık kalır. Yeni bir testi inceleyin ve içe aktarımı açıkça onaylayın.',
            },
        },
    },
    {
        id: 'standalone-lexware-historical-archive',
        sequence: 142,
        version: '2026.10.10',
        publishedAt: '2026-10-10T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/legacy-documents?sourceSystem=LEXWARE',
        requiredAnyPermissions: [PERMISSIONS.DOCUMENT_READ, PERMISSIONS.PURCHASE_READ],
        commitRefs: ['standalone-lexware-archive-20261010'],
        translations: {
            de: {
                title: 'Lexware ZIP hochladen und Altbelege lesen',
                description: 'Berechtigte laden ihre Lexware-Sicherungs-ZIP separat hoch; die Installation enthält keine Sicherungsdaten. Auch große Uploads lassen sich pausieren und fortsetzen. Prüfung und bestätigte Übernahme laufen im Hintergrund. Durchsuchen Sie das eigenständige Lese-Archiv nach alter Kunden- oder Belegnummer, Name oder PDF-Text und laden Sie Originale herunter; aktuelle Stammdaten und Buchhaltung bleiben unverknüpft.',
            },
            en: {
                title: 'Upload a Lexware ZIP and read historical documents',
                description: 'Authorized users upload their Lexware backup ZIP separately; installation contains no backup data. Large uploads can be paused and resumed. Checking and confirmed importing run in the background. Search the standalone read-only archive by old customer or document number, name or PDF text and download originals, without links to current master data or accounting.',
            },
            fr: {
                title: 'Téléverser un ZIP Lexware et lire les documents',
                description: 'Les utilisateurs autorisés téléversent leur ZIP Lexware séparément ; l’installation ne contient aucune sauvegarde. Les grands téléversements peuvent être suspendus et repris. La vérification et l’import confirmé continuent en arrière-plan. Recherchez dans l’archive autonome en lecture seule par ancien numéro client ou document, nom ou texte PDF et téléchargez les originaux, sans lien avec les fiches ou la comptabilité actuelles.',
            },
            es: {
                title: 'Subir un ZIP de Lexware y consultar documentos',
                description: 'Los usuarios autorizados suben su ZIP de Lexware por separado; la instalación no contiene datos de copias. Las subidas grandes pueden pausarse y continuarse. La comprobación e importación confirmada se ejecutan en segundo plano. Busque en el archivo independiente de solo lectura por número antiguo de cliente o documento, nombre o texto PDF y descargue originales, sin vínculos con fichas ni contabilidad actuales.',
            },
            tr: {
                title: 'Lexware ZIP yükleyin ve geçmiş belgeleri okuyun',
                description: 'Yetkili kullanıcılar Lexware ZIP yedeğini ayrıca yükler; kurulum yedek verisi içermez. Büyük yüklemeler duraklatılıp sürdürülebilir. Kontrol ve onaylanan içe aktarım arka planda çalışır. Bağımsız salt okunur arşivde eski müşteri veya belge numarası, ad veya PDF metniyle arayın ve özgün dosyaları indirin; güncel ana veri veya muhasebe bağlantısı kurulmaz.',
            },
        },
    },
    {
        id: 'lexware-upload-existing-tenants',
        sequence: 143,
        version: '2026.10.10',
        publishedAt: '2026-10-10T07:30:00.000Z',
        category: 'FIXED',
        linkUrl: '/legacy-documents?sourceSystem=LEXWARE',
        requiredAnyPermissions: [PERMISSIONS.DOCUMENT_READ, PERMISSIONS.PURCHASE_READ],
        commitRefs: ['lexware-upload-uuid-tenant-20261010'],
        translations: {
            de: {
                title: 'Lexware ZIP-Upload wieder möglich',
                description: 'Lexware-Sicherungen lassen sich auch in bisher betroffenen Mandanten hochladen. Bereits angelegte Uploads können mit derselben ZIP fortgesetzt werden, auch wenn noch keine Daten übertragen wurden.',
            },
            en: {
                title: 'Lexware ZIP uploads restored',
                description: 'Lexware backups can now be uploaded in previously affected tenants. Existing uploads can resume with the same ZIP, even when no data has been transferred yet.',
            },
            fr: {
                title: 'Téléversement des ZIP Lexware rétabli',
                description: 'Les sauvegardes Lexware peuvent désormais être téléversées dans les tenants précédemment concernés. Les téléversements existants peuvent reprendre avec le même ZIP, même si aucune donnée n’a encore été transférée.',
            },
            es: {
                title: 'Carga de ZIP de Lexware restablecida',
                description: 'Las copias de Lexware ya se pueden subir en los tenants afectados anteriormente. Las cargas existentes pueden continuar con el mismo ZIP, incluso si todavía no se han transferido datos.',
            },
            tr: {
                title: 'Lexware ZIP yüklemesi yeniden kullanılabilir',
                description: 'Lexware yedekleri artık daha önce etkilenen kiracılarda da yüklenebilir. Henüz veri aktarılmamış olsa bile mevcut yüklemeler aynı ZIP ile sürdürülebilir.',
            },
        },
    },
    {
        id: 'industry-code-catalogue-selection',
        sequence: 144,
        version: '2026.10.10',
        publishedAt: '2026-10-10T11:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/partners/customers',
        requiredAnyPermissions: [PERMISSIONS.CUSTOMER_READ],
        commitRefs: ['industry-code-dropdown-20261010'],
        translations: {
            de: {
                title: 'Branchencode auswählen und Branche übernehmen',
                description: 'Wählen Sie den Branchencode aus dem vollständigen WZ-2025-Katalog für Deutschland oder dem NAF/APE-Katalog für Frankreich. Suchen Sie nach Code oder amtlicher Bezeichnung, auch ohne Punkte. Die Auswahl füllt die Branche automatisch. Bestehende freie Codes bleiben erhalten.',
            },
            en: {
                title: 'Select industry codes and fill the industry',
                description: 'Select an industry code from the complete WZ 2025 catalogue for Germany or NAF/APE catalogue for France. Search by code or official name, including codes without dots. Selecting a code automatically fills the industry. Existing free-text codes are retained.',
            },
            fr: {
                title: 'Choisir un code et renseigner le secteur',
                description: 'Choisissez un code dans le catalogue complet WZ 2025 pour l’Allemagne ou NAF/APE pour la France. Recherchez un code ou un libellé officiel, même sans points. La sélection renseigne automatiquement le secteur. Les anciens codes libres sont conservés.',
            },
            es: {
                title: 'Seleccionar códigos y completar el sector',
                description: 'Seleccione un código del catálogo completo WZ 2025 para Alemania o NAF/APE para Francia. Busque por código o denominación oficial, incluso sin puntos. La selección rellena automáticamente el sector. Se conservan los códigos de texto libre existentes.',
            },
            tr: {
                title: 'Sektör kodunu seçin ve sektörü doldurun',
                description: 'Almanya için eksiksiz WZ 2025 veya Fransa için NAF/APE kataloğundan bir kod seçin. Noktasız kodlarla da kod veya resmî ad üzerinden arayın. Seçim sektörü otomatik doldurur. Mevcut serbest metin kodları korunur.',
            },
        },
    },
    {
        id: 'document-recipient-responsibilities',
        sequence: 145,
        version: '2026.10.10',
        publishedAt: '2026-10-10T12:00:00.000Z',
        category: 'NEW',
        linkUrl: '/settings/contact-responsibilities',
        requiredAnyPermissions: ['settings:read'],
        commitRefs: ['document-recipient-responsibilities'],
        translations: {
            de: {
                title: 'Belege an zuständige Ansprechpartner senden',
                description: 'Ordnen Sie Belegarten wie Rechnungen oder Lieferscheine einer Kontaktzuständigkeit zu. Beim E-Mail-Versand werden die passenden Ansprechpartner des Partners vorgeschlagen; Empfänger und Kopien bleiben vor dem Versand änderbar.',
            },
            en: {
                title: 'Send documents to responsible contacts',
                description: 'Assign document types such as invoices or delivery notes to a contact responsibility. Email delivery suggests the partner’s matching contacts; recipients and copies remain editable before sending.',
            },
            fr: {
                title: 'Envoyer les documents aux contacts responsables',
                description: 'Associez les types de documents, comme les factures ou bons de livraison, à une responsabilité. L’envoi par e-mail propose les contacts correspondants du partenaire ; destinataires et copies restent modifiables avant l’envoi.',
            },
            es: {
                title: 'Enviar documentos a los contactos responsables',
                description: 'Asigne tipos de documento, como facturas o albaranes, a una responsabilidad. El envío por correo propone los contactos correspondientes del socio; destinatarios y copias siguen siendo editables antes del envío.',
            },
            tr: {
                title: 'Belgeleri sorumlu kişilere gönderin',
                description: 'Fatura veya irsaliye gibi belge türlerini bir kişi sorumluluğuna atayın. E-posta gönderiminde iş ortağının uygun kişileri önerilir; alıcılar ve bilgi alıcıları göndermeden önce değiştirilebilir.',
            },
        },
    },
    {
        id: 'tenant-email-delivery-control',
        sequence: 146,
        version: '2026.10.10',
        publishedAt: '2026-10-10T12:00:00.000Z',
        category: 'NEW',
        linkUrl: '/admin/mail-backups',
        requiredAnyPermissions: [PERMISSIONS.SETTINGS_WRITE],
        commitRefs: ['codex/tenant-mail-settings'],
        translations: {
            de: {
                title: 'E-Mail-Versand pro Mandant steuern',
                description: 'Unter Mailserver & Backups können Sie einen eigenen SMTP-Server einrichten und sämtliche E-Mails für Ihren Mandanten sperren, einschließlich Testmails, Sicherheitscodes und Betriebsalarmen.',
            },
            en: {
                title: 'Control email delivery for each tenant',
                description: 'Configure your own SMTP server under Mail server & backups and block every email for your tenant, including test messages, security codes and operations alerts.',
            },
            fr: {
                title: 'Contrôler les e-mails par entreprise',
                description: 'Configurez votre serveur SMTP dans Serveur de messagerie et sauvegardes et bloquez tous les e-mails de votre entreprise, y compris les tests, codes de sécurité et alertes.',
            },
            es: {
                title: 'Controlar el correo por empresa',
                description: 'Configure su servidor SMTP en Servidor de correo y copias de seguridad y bloquee todos los correos de su empresa, incluidas pruebas, códigos de seguridad y alertas.',
            },
            tr: {
                title: 'Şirket bazında e-posta gönderimini yönetin',
                description: 'Posta sunucusu ve yedeklemeler bölümünde kendi SMTP sunucunuzu yapılandırın; test iletileri, güvenlik kodları ve işletim uyarıları dahil şirketinizin tüm e-postalarını engelleyin.',
            },
        },
    },
    {
        id: 'configurable-address-types',
        sequence: 147,
        version: '2026.10.10',
        publishedAt: '2026-10-10T12:00:00.000Z',
        category: 'NEW',
        linkUrl: '/settings/address-types',
        requiredAnyPermissions: ['settings:read'],
        commitRefs: ['address-types-configuration-20261010'],
        translations: {
            de: {
                title: 'Adressarten einschließlich Postfach',
                description: 'Adressarten in den Einstellungen anlegen, umbenennen, sortieren und deaktivieren; Postfach direkt bei Kundenadressen auswählen.',
            },
            en: {
                title: 'Address types including PO boxes',
                description: 'Create, rename, sort and deactivate address types in settings; select PO boxes directly on customer addresses.',
            },
            fr: {
                title: 'Types d’adresse et boîtes postales',
                description: 'Créer, renommer, trier et désactiver les types d’adresse ; sélectionner une boîte postale dans les adresses client.',
            },
            es: {
                title: 'Tipos de dirección y apartados de correos',
                description: 'Crear, renombrar, ordenar y desactivar tipos de dirección; seleccionar apartados de correos en direcciones de clientes.',
            },
            tr: {
                title: 'Posta kutusu dahil adres türleri',
                description: 'Ayarlarda adres türleri oluşturun, adlarını ve sıralarını değiştirin, devre dışı bırakın; müşteri adreslerinde posta kutusu seçin.',
            },
        },
    },
    {
        id: 'customer-conditions-categories',
        sequence: 148,
        version: '2026.10.10',
        publishedAt: '2026-10-10T12:20:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/settings/conditions',
        requiredAnyPermissions: [PERMISSIONS.SETTINGS_READ],
        commitRefs: ['customer-conditions-categories-20261010'],
        translations: {
            de: {
                title: 'Konditionen und Kundenkategorien einfacher verwalten',
                description: 'Zahlungs- und Lieferbedingungen sowie Kundenkategorien sind direkt in den Einstellungen erreichbar. Für neue Einträge genügt meist ein Name. Lieferadressen wählen abweichende Lieferbedingungen per Dropdown oder übernehmen die Kundenkondition. Eigene Kategorien lassen sich anlegen, umbenennen und deaktivieren; bestehende Zuordnungen bleiben erhalten.',
            },
            en: {
                title: 'Simpler terms and customer category management',
                description: 'Payment terms, delivery terms and customer categories are directly accessible in settings. Most new entries only need a name. Shipping addresses select delivery overrides from a dropdown or inherit customer terms. Create, rename and deactivate your own categories while retaining existing assignments.',
            },
            fr: {
                title: 'Gestion simplifiée des conditions et catégories de clients',
                description: 'Les conditions de paiement, de livraison et les catégories de clients sont accessibles directement dans les paramètres. Un nom suffit généralement pour un nouvel élément. Les adresses choisissent une condition différente dans une liste ou reprennent celle du client. Créez, renommez et désactivez vos catégories en conservant les affectations existantes.',
            },
            es: {
                title: 'Gestión más sencilla de condiciones y categorías de clientes',
                description: 'Las condiciones de pago, de entrega y las categorías de clientes están directamente en configuración. La mayoría de las nuevas entradas solo necesitan un nombre. Las direcciones eligen condiciones diferentes en una lista o usan las del cliente. Cree, cambie nombres y desactive categorías conservando las asignaciones existentes.',
            },
            tr: {
                title: 'Koşulları ve müşteri kategorilerini daha kolay yönetin',
                description: 'Ödeme ve teslimat koşulları ile müşteri kategorilerine ayarlardan doğrudan erişilir. Yeni kayıtlar için çoğunlukla bir ad yeterlidir. Teslimat adreslerinde farklı koşulu listeden seçin veya müşteri koşulunu kullanın. Kendi kategorilerinizi oluşturun, yeniden adlandırın ve devre dışı bırakın; mevcut atamalar korunur.',
            },
        },
    },
    {
        id: 'warehouse-stock-spreadsheet-import',
        sequence: 149,
        version: '2026.10.10',
        publishedAt: '2026-10-10T12:40:00.000Z',
        category: 'NEW',
        linkUrl: '/inventory/import',
        requiredAnyPermissions: ['inventory:read'],
        commitRefs: ['warehouse-stock-import-20261010'],
        translations: {
            de: {
                title: 'Lagerbestand mit einer Excel-Datei hinzufügen',
                description: 'Unter Artikel & Lager → Import stehen eine Vorlage und eine vollständige Vorschau bereit. Prüfen Sie Gebindefaktoren, Basismengen, Chargen, MHD und Chargen-Zusatzfelder gemeinsam und bestätigen Sie die Bestandszugänge ausdrücklich. Fehler sperren die gesamte Datei; eine bereits gebuchte Datei wird nicht doppelt übernommen.',
            },
            en: {
                title: 'Add warehouse stock from one Excel file',
                description: 'Products & inventory → Import provides a template and a complete preview. Review packaging factors, base quantities, batches, best-before dates and batch custom fields together, then explicitly confirm the stock additions. Errors block the whole file; a completed file cannot be posted twice.',
            },
            fr: {
                title: 'Ajouter du stock depuis un fichier Excel',
                description: 'Articles et stock → Import propose un modèle et un aperçu complet. Vérifiez ensemble les facteurs de conditionnement, quantités de base, lots, DDM et champs personnalisés, puis confirmez explicitement les entrées. Les erreurs bloquent tout le fichier ; un fichier déjà comptabilisé ne peut pas être repris deux fois.',
            },
            es: {
                title: 'Añadir existencias desde un archivo Excel',
                description: 'Artículos y existencias → Importar ofrece plantilla y vista previa completa. Revise juntos factores de envase, cantidades base, lotes, fechas y campos adicionales, y confirme expresamente las entradas. Los errores bloquean todo el archivo; uno ya contabilizado no puede registrarse dos veces.',
            },
            tr: {
                title: 'Tek Excel dosyasından depo stoğu ekleyin',
                description: 'Ürünler ve stok → İçe aktar bölümünde şablon ve tam önizleme bulunur. Ambalaj faktörlerini, temel miktarları, partileri, tüketim tarihlerini ve ek alanları birlikte kontrol edip stok girişlerini açıkça onaylayın. Hatalar tüm dosyayı engeller; kaydedilmiş dosya iki kez işlenmez.',
            },
        },
    },
    {
        id: 'warehouse-import-lossless-quantity-check',
        sequence: 150,
        version: '2026.10.10',
        publishedAt: '2026-10-10T17:10:00.000Z',
        category: 'FIXED',
        linkUrl: '/inventory/import',
        requiredAnyPermissions: ['inventory:read'],
        commitRefs: ['warehouse-import-quantity-precision-20261010'],
        translations: {
            de: {
                title: 'Gebindemengen ohne Rundung prüfen',
                description: 'Die Mengenprüfung im Lagerimport erkennt auch bei großen Mengen kleinste Nachkommastellen nach der Gebindeumrechnung. Mengen mit mehr als sechs Nachkommastellen werden vor der Buchung abgelehnt.',
            },
            en: {
                title: 'Check packaging quantities without rounding',
                description: 'Warehouse imports detect even tiny fractional amounts after packaging conversion, including for large quantities. Quantities with more than six decimal places are rejected before posting.',
            },
            fr: {
                title: 'Vérifier les quantités sans arrondi',
                description: 'L’import de stock détecte les fractions les plus petites après conversion du conditionnement, même pour de grandes quantités. Les quantités ayant plus de six décimales sont refusées avant comptabilisation.',
            },
            es: {
                title: 'Comprobar las cantidades sin redondear',
                description: 'La importación de existencias detecta incluso fracciones mínimas tras convertir el envase, también con cantidades grandes. Las cantidades con más de seis decimales se rechazan antes de registrarlas.',
            },
            tr: {
                title: 'Ambalaj miktarlarını yuvarlamadan kontrol edin',
                description: 'Stok içe aktarımı, büyük miktarlarda bile ambalaj dönüşümünden sonraki en küçük kesirleri algılar. Altıdan fazla ondalık basamağı olan miktarlar kayıttan önce reddedilir.',
            },
        },
    },
    {
        id: 'document-customer-selection',
        sequence: 151,
        version: '2026.10.10',
        publishedAt: '2026-10-10T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/documents/new',
        requiredAnyPermissions: [PERMISSIONS.DOCUMENT_WRITE],
        commitRefs: ['document-customer-selection'],
        translations: {
            de: {
                title: 'Kundenauswahl beim Erstellen von Belegen',
                description: 'Die Kundenauswahl zeigt nur Partner mit Kundenrolle. Reine Interessenten und Lieferanten erscheinen auch in Suchergebnissen nicht mehr.',
            },
            en: {
                title: 'Customer selection when creating documents',
                description: 'The customer dropdown only shows partners with a customer role. Prospects and suppliers without that role no longer appear, including in search results.',
            },
            fr: {
                title: 'Sélection des clients lors de la création de documents',
                description: 'La liste des clients affiche uniquement les partenaires ayant le rôle client. Les prospects et fournisseurs sans ce rôle n’apparaissent plus, y compris dans les résultats de recherche.',
            },
            es: {
                title: 'Selección de clientes al crear documentos',
                description: 'La lista de clientes solo muestra socios con rol de cliente. Los prospectos y proveedores sin ese rol ya no aparecen, tampoco en los resultados de búsqueda.',
            },
            tr: {
                title: 'Belge oluştururken müşteri seçimi',
                description: 'Müşteri listesi yalnızca müşteri rolüne sahip iş ortaklarını gösterir. Bu role sahip olmayan adaylar ve tedarikçiler arama sonuçlarında da görünmez.',
            },
        },
    },
    {
        id: 'document-unit-price-display',
        sequence: 152,
        version: '2026.10.10',
        publishedAt: '2026-10-10T00:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/documents/new',
        requiredAnyPermissions: [PERMISSIONS.DOCUMENT_WRITE],
        commitRefs: ['document-unit-price-display'],
        translations: {
            de: {
                title: 'Einzelpreise mit zwei Nachkommastellen',
                description: 'Einzelpreise in Belegpositionen werden mit zwei Nachkommastellen angezeigt. Berechnung und Speicherung behalten die volle Preisgenauigkeit; genauere manuelle Eingaben bleiben möglich.',
            },
            en: {
                title: 'Unit prices with two decimal places',
                description: 'Unit prices in document rows are displayed with two decimal places. Calculations and saved values retain full price precision; more precise manual entries remain possible.',
            },
            fr: {
                title: 'Prix unitaires avec deux décimales',
                description: 'Les prix unitaires des lignes de document s’affichent avec deux décimales. Les calculs et les valeurs enregistrées conservent toute la précision ; la saisie manuelle de prix plus précis reste possible.',
            },
            es: {
                title: 'Precios unitarios con dos decimales',
                description: 'Los precios unitarios de las líneas de documentos se muestran con dos decimales. Los cálculos y los valores guardados conservan toda la precisión; se pueden seguir introduciendo precios más precisos manualmente.',
            },
            tr: {
                title: 'İki ondalık basamaklı birim fiyatlar',
                description: 'Belge satırlarındaki birim fiyatlar iki ondalık basamakla gösterilir. Hesaplamalar ve kaydedilen değerler tam hassasiyeti korur; daha hassas manuel fiyat girişleri mümkündür.',
            },
        },
    },
    {
        id: 'price-tier-decimal-input',
        sequence: 153,
        version: '2026.10.10',
        publishedAt: '2026-10-10T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/products',
        requiredAnyPermissions: [PERMISSIONS.PRODUCT_WRITE],
        commitRefs: ['price-tier-decimal-input'],
        translations: {
            de: {
                title: 'Staffelpreise ohne Eingabeabbruch bearbeiten',
                description: 'Die Ansicht bleibt auch beim Leeren eines Preises geöffnet. Kurzschreibweisen wie „3.“ und „.53“ sowie Dezimalkommas werden korrekt übernommen; ungültige Werte werden direkt am Feld erklärt.',
            },
            en: {
                title: 'Edit price tiers without interrupted input',
                description: 'The editor stays open when clearing a price. Short forms such as “3.” and “.53”, including decimal commas, are accepted correctly; invalid values are explained beside the field.',
            },
            fr: {
                title: 'Modifier les prix par palier sans interruption',
                description: 'L’éditeur reste ouvert lorsque vous effacez un prix. Les formes « 3. » et « .53 », ainsi que la virgule décimale, sont correctement prises en compte ; les valeurs incorrectes sont expliquées près du champ.',
            },
            es: {
                title: 'Editar escalas de precios sin interrupciones',
                description: 'El editor permanece abierto al vaciar un precio. Las formas «3.» y «.53», también con coma decimal, se aceptan correctamente; los valores incorrectos se explican junto al campo.',
            },
            tr: {
                title: 'Kademeli fiyatları kesintisiz düzenleyin',
                description: 'Fiyat alanı boşaltıldığında düzenleyici açık kalır. “3.” ve “.53” gibi kısa yazımlar ve ondalık virgül doğru şekilde kabul edilir; geçersiz değerler alanın yanında açıklanır.',
            },
        },
    },
    {
        id: 'automatic-intra-community-tax',
        sequence: 154,
        version: '2026.10.10',
        publishedAt: '2026-10-10T00:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/documents/new',
        requiredAnyPermissions: [PERMISSIONS.DOCUMENT_WRITE],
        commitRefs: ['automatic-intra-community-tax'],
        translations: {
            de: {
                title: 'Innergemeinschaftliche Lieferung automatisch auswählen',
                description: 'Neue Belege übernehmen die bestätigte Steuerempfehlung automatisch. EU-B2B-Einstufung, gültiger USt-IdNr.-Nachweis und passende Lieferangaben bleiben erforderlich; manuelle Entscheidungen und offene Versandnachweise bleiben erhalten.',
            },
            en: {
                title: 'Automatically select intra-community supply',
                description: 'New documents apply the confirmed tax recommendation automatically. EU-B2B classification, valid VAT-ID evidence and matching delivery facts remain required; manual decisions and outstanding transport evidence are preserved.',
            },
            fr: {
                title: 'Sélection automatique de la livraison intracommunautaire',
                description: 'Les nouveaux documents appliquent automatiquement la recommandation fiscale confirmée. La catégorie UE B2B, un justificatif de TVA valide et les données de livraison restent requis ; les choix manuels et les preuves de transport manquantes sont conservés.',
            },
            es: {
                title: 'Seleccionar automáticamente la entrega intracomunitaria',
                description: 'Los documentos nuevos aplican automáticamente la recomendación fiscal confirmada. Siguen siendo necesarios la clasificación UE B2B, la acreditación de IVA válida y los datos de entrega; se conservan las decisiones manuales y los justificantes de transporte pendientes.',
            },
            tr: {
                title: 'Topluluk içi teslimatı otomatik seçin',
                description: 'Yeni belgeler doğrulanmış vergi önerisini otomatik uygular. AB B2B sınıflandırması, geçerli KDV kanıtı ve uygun teslimat bilgileri gerekli olmaya devam eder; manuel kararlar ve eksik taşıma kanıtları korunur.',
            },
        },
    },
    {
        id: 'pdf-thousands-separator',
        sequence: 155,
        version: '2026.10.10',
        publishedAt: '2026-10-10T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/documents',
        requiredAnyPermissions: [PERMISSIONS.DOCUMENT_READ],
        commitRefs: ['pdf-thousands-separator'],
        translations: {
            de: {
                title: 'Tausendertrennzeichen im PDF korrigiert',
                description: 'Französische Beleg-PDFs zeigen Tausenderabstände als Leerzeichen statt als „/“. Preise, Summen und Mengen erscheinen mit allen verfügbaren Schriftarten korrekt; die Berechnung bleibt erhalten.',
            },
            en: {
                title: 'Corrected thousands separators in PDFs',
                description: 'French document PDFs show thousands separators as spaces instead of “/”. Prices, totals and quantities display correctly with every available font; calculations are preserved.',
            },
            fr: {
                title: 'Séparateurs de milliers corrigés dans les PDF',
                description: 'Les PDF de documents en français affichent les séparateurs de milliers sous forme d’espaces au lieu de « / ». Les prix, les totaux et les quantités sont lisibles avec toutes les polices disponibles ; les calculs sont conservés.',
            },
            es: {
                title: 'Separadores de miles corregidos en los PDF',
                description: 'Los PDF de documentos en francés muestran los separadores de miles como espacios en lugar de «/». Precios, totales y cantidades se muestran correctamente con todas las fuentes disponibles; se conservan los cálculos.',
            },
            tr: {
                title: 'PDF binlik ayırıcıları düzeltildi',
                description: 'Fransızca belge PDF’lerinde binlik ayırıcılar “/” yerine boşluk olarak gösterilir. Fiyatlar, toplamlar ve miktarlar tüm kullanılabilir yazı tiplerinde doğru görünür; hesaplamalar korunur.',
            },
        },
    },
    {
        id: 'pdf-designer-selected-vat-id',
        sequence: 156,
        version: '2026.10.10',
        publishedAt: '2026-10-10T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/settings/pdf-designer',
        requiredAnyPermissions: [PERMISSIONS.SETTINGS_MANAGE_TEMPLATES],
        commitRefs: ['pdf-designer-selected-vat-id'],
        translations: {
            de: {
                title: 'Ausgewählte USt-ID im PDF anzeigen',
                description: 'Gezielt ausgewählte öffentliche Standardfelder wie die Kunden-USt-ID erscheinen mit ihrem gespeicherten Belegwert. Hinzufügen aktiviert den Kundendatenblock; Vertraulichkeit, Bedingungen und bewusste Ausblendungen bleiben wirksam.',
            },
            en: {
                title: 'Show the selected VAT ID in PDFs',
                description: 'Explicitly selected public standard fields, such as the customer VAT ID, display their saved document value. Adding a field activates the customer block; confidentiality, conditions and deliberate hiding remain effective.',
            },
            fr: {
                title: 'Afficher le n° de TVA sélectionné dans le PDF',
                description: 'Les champs standard publics sélectionnés explicitement, comme le n° de TVA du client, affichent leur valeur enregistrée dans le document. L’ajout active le bloc client ; la confidentialité, les conditions et les masquages explicites restent applicables.',
            },
            es: {
                title: 'Mostrar el NIF-IVA seleccionado en el PDF',
                description: 'Los campos estándar públicos seleccionados expresamente, como el NIF-IVA del cliente, muestran su valor guardado en el documento. Añadir un campo activa el bloque del cliente; se mantienen la confidencialidad, las condiciones y los ocultamientos explícitos.',
            },
            tr: {
                title: 'Seçilen KDV kimlik numarasını PDF’de gösterin',
                description: 'Müşteri KDV kimlik numarası gibi açıkça seçilen herkese açık standart alanlar, belgede kayıtlı değerlerini gösterir. Alan eklemek müşteri bloğunu etkinleştirir; gizlilik, koşullar ve bilinçli gizleme tercihleri korunur.',
            },
        },
    },
    {
        id: 'document-price-group-override',
        sequence: 157,
        version: '2026.10.10',
        publishedAt: '2026-10-10T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/documents/new',
        requiredAnyPermissions: [PERMISSIONS.DOCUMENT_WRITE],
        commitRefs: ['document-price-group-override'],
        translations: {
            de: {
                title: 'Preisgruppe je Verkaufsbeleg wählen',
                description: 'Neue Verkaufsbelege übernehmen die Preisgruppe des Kunden. Im unversendeten Entwurf kann eine andere Gruppe oder „Keine Preisgruppe / allgemeine Konditionen“ gewählt werden. Automatische Artikelpreise werden neu berechnet; manuelle Preise bleiben erhalten. Die Auswahl wird im Beleg gespeichert, ohne den Kundenstamm zu ändern.',
            },
            en: {
                title: 'Choose a price group per sales document',
                description: 'New sales documents inherit the customer’s price group. In an unsent draft, choose another group or “No price group / general terms”. Automatic product prices are recalculated; manual prices are preserved. The selection is saved with the document without changing customer master data.',
            },
            fr: {
                title: 'Choisir un groupe tarifaire par document de vente',
                description: 'Les nouveaux documents de vente reprennent le groupe tarifaire du client. Dans un brouillon non envoyé, choisissez un autre groupe ou « Aucun groupe tarifaire / conditions générales ». Les prix automatiques des articles sont recalculés ; les prix manuels sont conservés. Le choix est enregistré dans le document sans modifier la fiche client.',
            },
            es: {
                title: 'Elegir un grupo de precios por documento de venta',
                description: 'Los nuevos documentos de venta heredan el grupo de precios del cliente. En un borrador sin enviar puede elegir otro grupo o « Sin grupo de precios / condiciones generales ». Los precios automáticos de los artículos se recalculan; los precios manuales se conservan. La selección se guarda en el documento sin modificar la ficha del cliente.',
            },
            tr: {
                title: 'Satış belgesi için fiyat grubu seçin',
                description: 'Yeni satış belgeleri müşterinin fiyat grubunu devralır. Henüz gönderilmemiş bir taslakta başka bir grup veya “Fiyat grubu yok / genel koşullar” seçilebilir. Otomatik ürün fiyatları yeniden hesaplanır; elle girilen fiyatlar korunur. Seçim, müşteri ana verilerini değiştirmeden belgeye kaydedilir.',
            },
        },
    },
    {
        id: 'document-address-country-names',
        sequence: 158,
        version: '2026.10.10',
        publishedAt: '2026-10-10T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/documents',
        requiredAnyPermissions: [PERMISSIONS.DOCUMENT_READ],
        commitRefs: ['document-address-country-names'],
        translations: {
            de: {
                title: 'Ländernamen in Adressen',
                description: 'Im Kundenadressfeld werden Länder ausgeschrieben, zum Beispiel „Österreich“ statt „AT“ und „Frankreich“ statt „FR“. Im ERP richtet sich der Name nach der gewählten Oberflächensprache, im PDF nach der Belegsprache. Das gilt für Rechnungs- und Lieferadressen, auch bei bereits gespeicherten Belegen. Die gespeicherten Adressangaben bleiben erhalten.',
            },
            en: {
                title: 'Country names in addresses',
                description: 'Countries in customer addresses are written out in full, for example “Austria” instead of “AT” and “France” instead of “FR”. In the ERP, names follow the selected interface language; in PDFs, they follow the document language. This applies to billing and shipping addresses, including previously saved documents. Stored address details are preserved.',
            },
            fr: {
                title: 'Noms des pays dans les adresses',
                description: 'Les pays sont écrits en toutes lettres dans les adresses client, par exemple « Autriche » au lieu de « AT » et « France » au lieu de « FR ». Dans l’ERP, le nom suit la langue de l’interface ; dans le PDF, il suit la langue du document. Cela concerne les adresses de facturation et de livraison, y compris les documents déjà enregistrés. Les données d’adresse enregistrées sont conservées.',
            },
            es: {
                title: 'Nombres de países en las direcciones',
                description: 'Los países se muestran con su nombre completo en las direcciones del cliente, por ejemplo « Austria » en lugar de « AT » y « Francia » en lugar de « FR ». En el ERP se utiliza el idioma de la interfaz; en el PDF, el idioma del documento. Se aplica a las direcciones de facturación y entrega, también en documentos ya guardados. Se conservan los datos de dirección guardados.',
            },
            tr: {
                title: 'Adreslerde ülke adları',
                description: 'Müşteri adreslerindeki ülkeler açık adlarıyla gösterilir; örneğin “AT” yerine “Avusturya”, “FR” yerine “Fransa”. ERP’de seçili arayüz dili, PDF’de belge dili kullanılır. Bu kural, daha önce kaydedilmiş belgeler dahil fatura ve teslimat adresleri için geçerlidir. Kayıtlı adres bilgileri korunur.',
            },
        },
    },
    {
        id: 'prospect-bulk-delete-selection',
        sequence: 159,
        version: '2026.10.10',
        publishedAt: '2026-10-10T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/partners/prospects',
        requiredAnyPermissions: [PERMISSIONS.CUSTOMER_DELETE],
        commitRefs: ['prospect-bulk-delete-selection'],
        translations: {
            de: {
                title: 'Interessenten gemeinsam löschen',
                description: 'In der Interessentenliste lassen sich einzelne Einträge oder die aktuelle Seite per Checkbox auswählen und nach Bestätigung gemeinsam löschen. Partner mit Belegen bleiben erhalten; fehlgeschlagene Einträge bleiben für einen erneuten Versuch ausgewählt.',
            },
            en: {
                title: 'Delete prospects together',
                description: 'In the prospect list, select individual entries or the current page with checkboxes and delete them together after confirmation. Partners with documents are preserved; failed entries remain selected for retry.',
            },
            fr: {
                title: 'Supprimer plusieurs prospects',
                description: 'Dans la liste des prospects, sélectionnez des entrées ou la page actuelle avec les cases, puis supprimez-les ensemble après confirmation. Les partenaires possédant des documents sont conservés ; les entrées en échec restent sélectionnées pour réessayer.',
            },
            es: {
                title: 'Eliminar varios prospectos',
                description: 'En la lista de prospectos, seleccione entradas o la página actual mediante casillas y elimínelas juntas tras confirmar. Se conservan los socios con documentos; las entradas fallidas siguen seleccionadas para volver a intentarlo.',
            },
            tr: {
                title: 'Aday müşterileri birlikte silin',
                description: 'Aday müşteri listesinde onay kutularıyla kayıtları veya geçerli sayfayı seçip onaydan sonra birlikte silebilirsiniz. Belgesi olan iş ortakları korunur; başarısız kayıtlar yeniden denemek için seçili kalır.',
            },
        },
    },
    {
        id: 'bounded-error-overview',
        sequence: 160,
        version: '2026.10.12',
        publishedAt: '2026-10-10T18:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/admin/error-logs',
        requiredAnyPermissions: [PERMISSIONS.SETTINGS_WRITE],
        commitRefs: ['error-log-memory-fix-20261010'],
        translations: {
            de: {
                title: 'Fehlerübersicht zuverlässig öffnen',
                description: 'Die Fehlerübersicht bleibt auch bei großen Importfehlern nutzbar. Umfangreiche Diagnosedaten werden in Details und Supportberichten gekürzt; Dateiinhalte werden nicht protokolliert.',
            },
            en: {
                title: 'Open the error overview reliably',
                description: 'The error overview remains usable after large import failures. Extensive diagnostics are shortened in details and support reports; file contents are omitted from logs.',
            },
            fr: {
                title: 'Ouvrir la liste des erreurs de façon fiable',
                description: 'La liste des erreurs reste utilisable après des échecs d’import volumineux. Les diagnostics étendus sont abrégés dans les détails et rapports ; le contenu des fichiers est exclu des journaux.',
            },
            es: {
                title: 'Abrir el resumen de errores de forma fiable',
                description: 'El resumen de errores sigue disponible tras fallos de importaciones grandes. Los diagnósticos extensos se acortan en los detalles e informes; el contenido de los archivos se omite del registro.',
            },
            tr: {
                title: 'Hata özetini güvenilir biçimde açın',
                description: 'Hata özeti büyük içe aktarma hatalarından sonra da kullanılabilir. Ayrıntılarda ve destek raporlarında kapsamlı tanılama verileri kısaltılır; dosya içerikleri günlüğe alınmaz.',
            },
        },
    },
    {
        id: 'background-backup-integrity',
        sequence: 161,
        version: '2026.10.31',
        publishedAt: '2026-10-31T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/admin/backups',
        requiredAnyPermissions: [PERMISSIONS.BACKUP_VIEW],
        commitRefs: ['background-backup-integrity-20261031'],
        translations: {
            de: {
                title: 'Schnellere Statusabfragen für Sicherungen',
                description: 'Die Anzeige des Systemschutzes verwendet die letzte gültige Hintergrundprüfung, ohne große Sicherungen bei jedem Aufruf erneut einzulesen.',
            },
            en: {
                title: 'Faster backup status requests',
                description: 'System protection displays the latest valid background verification without reading large backups again on every request.',
            },
            fr: {
                title: 'Consultation plus rapide de l’état des sauvegardes',
                description: 'La protection du système affiche la dernière vérification valide en arrière-plan sans relire les grandes sauvegardes à chaque consultation.',
            },
            es: {
                title: 'Consulta más rápida del estado de las copias',
                description: 'La protección del sistema muestra la última verificación válida en segundo plano sin volver a leer copias grandes en cada consulta.',
            },
            tr: {
                title: 'Yedek durumunu daha hızlı görüntüleyin',
                description: 'Sistem koruması, her görüntülemede büyük yedekleri yeniden okumadan arka plandaki son geçerli doğrulamayı gösterir.',
            },
        },
    },
    {
        id: 'faster-work-area-opening',
        sequence: 162,
        version: '2026.10.31',
        publishedAt: '2026-10-31T00:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/',
        requiredAnyPermissions: [],
        commitRefs: ['erp-opening-performance-20261031'],
        translations: {
            de: {
                title: 'Arbeitsbereiche schneller öffnen',
                description: 'Das ERP startet und lädt mit weniger Wartezeit. Weitere Arbeitsbereiche werden beim Öffnen vorbereitet; eine Ladeanzeige begleitet den Seitenwechsel.',
            },
            en: {
                title: 'Open work areas faster',
                description: 'The ERP starts and reloads with less waiting. Other work areas are prepared when you open them, with a loading indicator during navigation.',
            },
            fr: {
                title: 'Ouvrir les espaces de travail plus rapidement',
                description: 'L’ERP démarre et se recharge avec moins d’attente. Les autres espaces sont préparés à leur ouverture, avec un indicateur de chargement pendant la navigation.',
            },
            es: {
                title: 'Abrir las áreas de trabajo más rápido',
                description: 'El ERP inicia y se recarga con menos espera. Las otras áreas se preparan al abrirlas, con un indicador de carga durante la navegación.',
            },
            tr: {
                title: 'Çalışma alanlarını daha hızlı açın',
                description: 'ERP daha kısa beklemeyle başlar ve yeniden yüklenir. Diğer çalışma alanları açıldığında hazırlanır; sayfa geçişi sırasında yükleme göstergesi görünür.',
            },
        },
    },
    {
        id: 'automatic-document-header-custom-fields',
        sequence: 163,
        version: '2026.10.31',
        publishedAt: '2026-10-31T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/documents/new',
        requiredAnyPermissions: [PERMISSIONS.DOCUMENT_WRITE],
        commitRefs: ['automatic-document-header-custom-fields'],
        translations: {
            de: {
                title: 'Zusatzfelder sofort im Belegkopf',
                description: 'Aktive Zusatzfelder der Belegart erscheinen beim Erstellen und Öffnen automatisch, auch ohne bisherigen Wert. Auf Desktop und Tablet stehen sie oben rechts im Belegkopf; auf kleinen Bildschirmen darunter. Ein manuelles Hinzufügen ist nicht mehr nötig.',
            },
            en: {
                title: 'Custom fields appear immediately in the document header',
                description: 'Active custom fields for the document type appear automatically when creating or opening a document, including fields without a value. On desktop and tablet they sit at the top right of the header; on small screens below it. Adding fields manually is no longer required.',
            },
            fr: {
                title: 'Les champs personnalisés apparaissent immédiatement dans l’en-tête',
                description: 'Les champs personnalisés actifs du type de document apparaissent automatiquement à la création et à l’ouverture, même sans valeur. Sur ordinateur et tablette, ils se placent en haut à droite de l’en-tête ; sur petit écran, en dessous. Aucun ajout manuel n’est nécessaire.',
            },
            es: {
                title: 'Campos personalizados visibles desde el inicio en la cabecera',
                description: 'Los campos personalizados activos del tipo de documento aparecen automáticamente al crear y abrir un documento, incluso sin valor. En ordenador y tableta se sitúan arriba a la derecha de la cabecera; en pantallas pequeñas, debajo. Ya no es necesario añadirlos manualmente.',
            },
            tr: {
                title: 'Özel alanlar belge başlığında hemen görünür',
                description: 'Belge türünün etkin özel alanları, değerleri boş olsa da belge oluşturulurken ve açılırken otomatik görünür. Masaüstü ve tablette başlığın sağ üstünde, küçük ekranlarda altında yer alır. Alanları elle eklemek artık gerekmez.',
            },
        },
    },
    {
        id: 'pallet-piece-prices-and-quantities',
        sequence: 164,
        version: '2026.10.31',
        publishedAt: '2026-10-31T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/documents/new',
        requiredAnyPermissions: [PERMISSIONS.DOCUMENT_WRITE],
        commitRefs: ['pallet-piece-prices-and-quantities'],
        translations: {
            de: {
                title: 'Stückpreis und Inhalt bei Palettenauswahl',
                description: 'Bei Karton- oder Palettenauswahl wird zusätzlich der Preis je Stück angezeigt. Die aktivierte Gebindeübersicht zeigt neben zugeordneten Kartons/Colis und Paletten auch die enthaltenen Einzelstücke, im Beleg und im PDF. Mengenänderungen werden berücksichtigt; gespeicherte Gebindefaktoren bleiben maßgeblich. Unvollständige Belege führen beim Speichern zum ersten fehlenden Pflichtfeld.',
            },
            en: {
                title: 'Piece prices and contents when selecting pallets',
                description: 'Selecting a carton or pallet also displays the price per piece. The enabled packaging summary shows individual pieces alongside assigned cartons/coli and pallets, in the document and PDF. Quantity changes are reflected; saved packaging factors remain authoritative. Saving incomplete documents focuses the first missing required field.',
            },
            fr: {
                title: 'Prix à la pièce et contenu lors du choix de palettes',
                description: 'Le choix d’un carton ou d’une palette affiche aussi le prix à la pièce. Le récapitulatif activé présente les pièces individuelles avec les cartons/colis et palettes associés, dans le document et le PDF. Les modifications de quantité sont prises en compte ; les facteurs enregistrés restent applicables. L’enregistrement d’un document incomplet place le focus sur le premier champ obligatoire manquant.',
            },
            es: {
                title: 'Precios por pieza y contenido al seleccionar palés',
                description: 'Al seleccionar una caja o un palé también se muestra el precio por pieza. El resumen activado muestra las piezas individuales junto a las cajas/bultos y los palés asignados, en el documento y el PDF. Se reflejan los cambios de cantidad y se respetan los factores guardados. Al guardar un documento incompleto, el foco se sitúa en el primer campo obligatorio que falta.',
            },
            tr: {
                title: 'Palet seçiminde adet fiyatı ve içerik',
                description: 'Koli veya palet seçildiğinde adet fiyatı da gösterilir. Etkin ambalaj özeti, atanan koli ve paletlerin yanında tekil adetleri belgede ve PDF’de gösterir. Miktar değişiklikleri yansıtılır; kayıtlı ambalaj katsayıları esas alınır. Eksik belgeler kaydedilirken eksik olan ilk zorunlu alana odaklanılır.',
            },
        },
    },
    {
        id: 'immediate-backup-integrity-verification',
        sequence: 165,
        version: '2026.11.1',
        publishedAt: '2026-11-01T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/admin/backups',
        requiredAnyPermissions: [PERMISSIONS.BACKUP_DEPLOYMENT_VIEW],
        commitRefs: ['immediate-backup-integrity-verification'],
        translations: {
            de: {
                title: 'Systemschutz nach Neustarts früher prüfen',
                description: 'Die Integritätsprüfung der lokalen Systemsicherung beginnt direkt mit dem Hintergrunddienst. Veröffentlichungen warten nicht zusätzlich auf den ersten regulären Prüftermin.',
            },
            en: {
                title: 'Check system protection earlier after restarts',
                description: 'Integrity verification of the local system backup starts with the background service. Releases no longer also wait for the first scheduled check.',
            },
            fr: {
                title: 'Vérifier la protection plus tôt après un redémarrage',
                description: 'La vérification de l’intégrité de la sauvegarde locale démarre avec le service en arrière-plan. Les publications n’attendent plus également le premier contrôle planifié.',
            },
            es: {
                title: 'Comprobar antes la protección tras reiniciar',
                description: 'La verificación de integridad de la copia local del sistema comienza con el servicio en segundo plano. Las publicaciones ya no esperan además a la primera comprobación programada.',
            },
            tr: {
                title: 'Yeniden başlatma sonrası sistem korumasını daha erken denetleyin',
                description: 'Yerel sistem yedeğinin bütünlük denetimi arka plan hizmetiyle birlikte başlar. Yayınlar artık ilk planlanmış denetimi de beklemez.',
            },
        },
    },
    {
        id: 'document-delivery-tax-automation',
        sequence: 166,
        version: '2026.11.1',
        publishedAt: '2026-11-01T00:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/documents',
        requiredAnyPermissions: [PERMISSIONS.DOCUMENT_READ],
        commitRefs: ['document-delivery-tax-automation'],
        translations: {
            de: {
                title: 'Lieferbedingungen auswählen und Steuer automatisch übernehmen',
                description: 'Belege bieten die gemeinsamen Lieferbedingungen zur Auswahl. Passende Steuerkonditionen werden automatisch übernommen; offene USt-ID-Prüfungen bleiben Hinweise und blockieren die innergemeinschaftliche Auswahl oder Festschreibung nicht.',
            },
            en: {
                title: 'Select delivery terms and apply tax automatically',
                description: 'Documents offer the shared delivery terms for selection. Matching tax conditions are applied automatically; outstanding VAT-ID checks remain warnings and do not block intra-community selection or finalization.',
            },
            fr: {
                title: 'Choisir les conditions de livraison et appliquer la fiscalité automatiquement',
                description: 'Les documents proposent les conditions de livraison communes. Les conditions fiscales adaptées sont appliquées automatiquement ; les contrôles de TVA en attente restent des avertissements sans bloquer la sélection intracommunautaire ni la validation.',
            },
            es: {
                title: 'Elegir condiciones de entrega y aplicar el impuesto automáticamente',
                description: 'Los documentos ofrecen las condiciones de entrega comunes. Las condiciones fiscales adecuadas se aplican automáticamente; las comprobaciones de IVA pendientes son avisos y no bloquean la selección intracomunitaria ni la confirmación.',
            },
            tr: {
                title: 'Teslimat koşullarını seçin ve vergiyi otomatik uygulayın',
                description: 'Belgelerde ortak teslimat koşulları seçilebilir. Uygun vergi koşulları otomatik uygulanır; bekleyen KDV kimlik kontrolleri uyarı olarak kalır ve topluluk içi seçimi veya kesinleştirmeyi engellemez.',
            },
        },
    },
    {
        id: 'quote-validity',
        sequence: 167,
        version: '2026.11.1',
        publishedAt: '2026-11-01T00:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/documents',
        requiredAnyPermissions: [PERMISSIONS.DOCUMENT_READ],
        commitRefs: ['quote-validity'],
        translations: {
            de: {
                title: 'Angebotsgültigkeit direkt bearbeiten',
                description: 'Angebote zeigen „Gültig bis“ direkt im Belegkopf. Neue Angebote berechnen das Datum aus der Firmeneinstellung; eigene Eingaben und gespeicherte Werte bleiben erhalten.',
            },
            en: {
                title: 'Edit quote validity directly',
                description: 'Quotes show “Valid until” in the document header. New quotes calculate the date from company settings; manual entries and saved values are preserved.',
            },
            fr: {
                title: 'Modifier directement la validité des devis',
                description: 'Les devis affichent « Valable jusqu’au » dans l’en-tête. Les nouveaux devis calculent la date selon les paramètres de l’entreprise ; les saisies manuelles et les valeurs enregistrées sont conservées.',
            },
            es: {
                title: 'Editar directamente la validez del presupuesto',
                description: 'Los presupuestos muestran «Válido hasta» en la cabecera. Los nuevos calculan la fecha según la configuración de la empresa; se conservan las entradas manuales y los valores guardados.',
            },
            tr: {
                title: 'Teklif geçerliliğini doğrudan düzenleyin',
                description: 'Tekliflerde “Geçerlilik tarihi” belge başlığında görünür. Yeni teklifler tarihi şirket ayarlarından hesaplar; elle girilen ve kaydedilmiş değerler korunur.',
            },
        },
    },
    {
        id: 'chatgpt-erp-connection',
        sequence: 168,
        version: '2026.11.1',
        publishedAt: '2026-11-01T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/settings/chatgpt',
        requiredAnyPermissions: [],
        commitRefs: ['chatgpt-erp-connection'],
        translations: {
            en: {
                title: 'ChatGPT connection',
                description: 'Connect, approve and revoke ChatGPT access to your ERP.',
            },
            de: {
                title: 'ChatGPT-Verbindung',
                description: 'ChatGPT mit dem ERP verbinden, Zugriff freigeben und widerrufen.',
            },
            fr: {
                title: 'Connexion ChatGPT',
                description: 'Connecter ChatGPT, autoriser et révoquer son accès à votre ERP.',
            },
            es: {
                title: 'Conexión con ChatGPT',
                description: 'Conectar ChatGPT y autorizar o revocar su acceso al ERP.',
            },
            tr: {
                title: 'ChatGPT bağlantısı',
                description: 'ChatGPT’yi ERP’ye bağlayın, erişimi onaylayın ve iptal edin.',
            },
        },
    },
    {
        id: 'chatgpt-sign-in-discovery',
        sequence: 169,
        version: '2026.11.1',
        publishedAt: '2026-11-01T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/settings/chatgpt',
        requiredAnyPermissions: [],
        commitRefs: ['chatgpt-sign-in-discovery'],
        translations: {
            en: {
                title: 'Start ChatGPT sign-in reliably',
                description: 'ChatGPT reliably starts ERP sign-in when a connection needs authorization.',
            },
            de: {
                title: 'ERP-Anmeldung aus ChatGPT starten',
                description: 'ChatGPT startet die ERP-Anmeldung zuverlässig, wenn eine Verbindung freigegeben werden muss.',
            },
            fr: {
                title: 'Démarrer la connexion depuis ChatGPT',
                description: 'ChatGPT démarre correctement la connexion à l’ERP lorsqu’une autorisation est nécessaire.',
            },
            es: {
                title: 'Iniciar el acceso desde ChatGPT',
                description: 'ChatGPT inicia correctamente el acceso al ERP cuando la conexión necesita autorización.',
            },
            tr: {
                title: 'ChatGPT üzerinden ERP oturumu açın',
                description: 'Bağlantı için yetkilendirme gerektiğinde ChatGPT, ERP oturum açma işlemini güvenilir şekilde başlatır.',
            },
        },
    },
    {
        id: 'backoffice-price-and-delete-permissions',
        sequence: 170,
        version: '2026.11.2',
        publishedAt: '2026-11-02T00:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/settings/roles',
        requiredAnyPermissions: [PERMISSIONS.USER_READ],
        commitRefs: ['backoffice-price-and-delete-permissions'],
        translations: {
            de: {
                title: 'Bearbeiten ohne Löschrechte oder Preisänderungen',
                description: 'Backoffice kann Kunden, Belege, Telefonate, Notizen und Vertriebsaufgaben bearbeiten. Löschen, Preisänderungen und Stornieren werden getrennt vergeben; auch eine Stornierung über den Belegstatus benötigt das Stornorecht.',
            },
            en: {
                title: 'Editing without deletion or price changes',
                description: 'Backoffice can work with customers, documents, calls, notes and sales tasks. Deletion, price changes and cancellation are granted separately; cancelling through document status also requires cancellation permission.',
            },
            fr: {
                title: 'Modifier sans supprimer ni changer les prix',
                description: 'Le back-office peut traiter clients, documents, appels, notes et tâches commerciales. Suppression, changements de prix et annulation sont distincts ; annuler par le statut du document exige aussi le droit d’annulation.',
            },
            es: {
                title: 'Editar sin eliminar ni cambiar precios',
                description: 'Backoffice puede trabajar con clientes, documentos, llamadas, notas y tareas comerciales. Eliminar, cambiar precios y anular tienen permisos independientes; anular mediante el estado también requiere el permiso de anulación.',
            },
            tr: {
                title: 'Silmeden veya fiyat değiştirmeden düzenleme',
                description: 'Backoffice müşteri, belge, arama, not ve satış görevlerini işleyebilir. Silme, fiyat değiştirme ve iptal ayrı yetkilerdir; belge durumu üzerinden iptal etmek de iptal yetkisi gerektirir.',
            },
        },
    },
    {
        id: 'document-piece-price-input',
        sequence: 171,
        version: '2026.11.1',
        publishedAt: '2026-11-01T00:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/documents',
        requiredAnyPermissions: [PERMISSIONS.DOCUMENT_READ],
        commitRefs: ['document-piece-pricing'],
        translations: {
            de: {
                title: 'Stückpreise direkt in der Position eingeben',
                description: 'Stückpreis und Einzelpreis je Karton, Coli oder Palette lassen sich direkt bearbeiten und werden automatisch umgerechnet. Mengenänderungen aktualisieren die Gesamtpreise; manuelle Preise und gespeicherte Gebindefaktoren bleiben erhalten.',
            },
            en: {
                title: 'Enter piece prices directly in document rows',
                description: 'Edit the piece price or the unit price per carton, coli or pallet directly; both convert automatically. Quantity changes update totals while manual prices and saved packaging factors are retained.',
            },
            fr: {
                title: 'Saisir le prix à la pièce dans les lignes',
                description: 'Modifiez directement le prix à la pièce ou par carton, colis ou palette : la conversion est automatique. Les changements de quantité actualisent les totaux ; les prix manuels et les facteurs enregistrés sont conservés.',
            },
            es: {
                title: 'Introducir precios por pieza en las líneas',
                description: 'Edite directamente el precio por pieza o por caja, bulto o palé: ambos se convierten automáticamente. Los cambios de cantidad actualizan los totales y se conservan los precios manuales y los factores guardados.',
            },
            tr: {
                title: 'Belge satırında adet fiyatını doğrudan girin',
                description: 'Adet fiyatını veya koli ya da palet başına birim fiyatı doğrudan düzenleyin; fiyatlar otomatik dönüştürülür. Miktar değişince toplamlar güncellenir; manuel fiyatlar ve kayıtlı ambalaj katsayıları korunur.',
            },
        },
    },
    {
        id: 'product-text-translations',
        sequence: 172,
        version: '2026.11.1',
        publishedAt: '2026-11-01T00:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/products',
        requiredAnyPermissions: [PERMISSIONS.PRODUCT_READ],
        commitRefs: ['product-text-translations'],
        translations: {
            de: {
                title: 'Artikeltexte in mehreren Sprachen pflegen',
                description: 'Artikelbezeichnungen und Beschreibungen lassen sich in deutschen, türkischen, englischen und französischen Sprach-Tabs manuell pflegen. Nur die deutsche Bezeichnung ist erforderlich. PDFs verwenden je Feld die Belegsprache mit deutschem Ersatz bei fehlender Übersetzung; spanische Belege verwenden Deutsch. Vorhandene Belege und manuell geänderte Positionstexte bleiben erhalten.',
            },
            en: {
                title: 'Maintain product texts in several languages',
                description: 'Maintain product names and descriptions manually in German, Turkish, English and French tabs. Only the German name is required. PDFs use the document language for each field, falling back to German when a translation is missing; Spanish documents use German. Existing documents and manually edited line texts are preserved.',
            },
            fr: {
                title: 'Gérer les textes des articles en plusieurs langues',
                description: 'Saisissez les désignations et descriptions des articles dans les onglets allemand, turc, anglais et français. Seule la désignation allemande est obligatoire. Les PDF utilisent la langue du document pour chaque champ, avec repli sur l’allemand si la traduction manque ; les documents espagnols utilisent l’allemand. Les documents existants et les textes de ligne modifiés manuellement sont conservés.',
            },
            es: {
                title: 'Mantener textos de artículos en varios idiomas',
                description: 'Introduzca nombres y descripciones de artículos en las pestañas de alemán, turco, inglés y francés. Solo el nombre alemán es obligatorio. Los PDF usan el idioma del documento para cada campo y recurren al alemán si falta la traducción; los documentos en español usan alemán. Se conservan los documentos existentes y los textos de línea editados manualmente.',
            },
            tr: {
                title: 'Ürün metinlerini birden fazla dilde düzenleyin',
                description: 'Ürün adlarını ve açıklamalarını Almanca, Türkçe, İngilizce ve Fransızca sekmelerinde elle düzenleyin. Yalnızca Almanca ad zorunludur. PDF’ler her alan için belge dilini kullanır; çeviri yoksa Almancaya döner, İspanyolca belgeler Almanca kullanır. Mevcut belgeler ve elle düzenlenen satır metinleri korunur.',
            },
        },
    },
    {
        id: 'search-result-group-order',
        sequence: 173,
        version: '2026.11.1',
        publishedAt: '2026-11-01T00:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/?openSearch=1',
        requiredAnyPermissions: [PERMISSIONS.GLOBAL_SEARCH_USE],
        commitRefs: ['search-result-order'],
        translations: {
            de: {
                title: 'Kunden und Artikel vor Belegen finden',
                description: 'Die globale Suche zeigt zuerst Kunden, danach Artikel und Belege am Ende. Das gilt auch bei vielen Treffern und bei zuletzt geöffneten Datensätzen. Die Tastaturnavigation folgt derselben Reihenfolge.',
            },
            en: {
                title: 'Find customers and products before documents',
                description: 'Global search shows customers first, then products, with documents last. This also applies to large result sets and recently opened records. Keyboard navigation follows the same order.',
            },
            fr: {
                title: 'Trouver clients et articles avant les documents',
                description: 'La recherche globale affiche d’abord les clients, puis les articles, et les documents en dernier. Cela vaut aussi pour les nombreux résultats et les enregistrements récemment ouverts. La navigation au clavier suit le même ordre.',
            },
            es: {
                title: 'Encontrar clientes y artículos antes que documentos',
                description: 'La búsqueda global muestra primero clientes, después artículos y al final documentos. Esto también se aplica a muchos resultados y a los registros abiertos recientemente. La navegación por teclado sigue el mismo orden.',
            },
            tr: {
                title: 'Müşteri ve ürünleri belgelerden önce bulun',
                description: 'Genel aramada önce müşteriler, ardından ürünler, en son belgeler gösterilir. Bu sıra çok sayıda sonuç ve son açılan kayıtlar için de geçerlidir. Klavye gezinmesi aynı sırayı izler.',
            },
        },
    },
    {
        id: 'customer-payment-condition-selection',
        sequence: 174,
        version: '2026.11.1',
        publishedAt: '2026-11-01T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/partners/customers',
        requiredAnyPermissions: [PERMISSIONS.CUSTOMER_READ],
        commitRefs: ['customer-payment-conditions'],
        translations: {
            de: {
                title: 'Zahlungskonditionen eindeutig auswählen',
                description: 'Die ausgewählte Zahlungskondition übernimmt Zahlungsziel und Skonto gemeinsam. Individuelle Werte werden erst über „Individuell vereinbaren“ bearbeitbar. Bestehende Sondervereinbarungen bleiben erhalten; erneute Auswahl ersetzt alle zugehörigen Werte.',
            },
            en: {
                title: 'Select customer payment terms clearly',
                description: 'The selected payment terms set the payment deadline and cash discount together. Individual values become editable only through “Set individual terms”. Existing special agreements are preserved; selecting a rule again replaces all related values.',
            },
            fr: {
                title: 'Choisir clairement les conditions de paiement du client',
                description: 'Les conditions sélectionnées définissent ensemble le délai de paiement et l’escompte. Les valeurs individuelles ne deviennent modifiables que via « Définir un accord individuel ». Les accords existants sont conservés ; une nouvelle sélection remplace toutes les valeurs associées.',
            },
            es: {
                title: 'Seleccionar claramente las condiciones de pago del cliente',
                description: 'Las condiciones seleccionadas establecen conjuntamente el plazo de pago y el descuento por pronto pago. Los valores individuales solo se editan mediante «Establecer condiciones individuales». Se conservan los acuerdos existentes; una nueva selección sustituye todos los valores asociados.',
            },
            tr: {
                title: 'Müşteri ödeme koşullarını açıkça seçin',
                description: 'Seçilen ödeme koşulu, ödeme vadesini ve erken ödeme iskontosunu birlikte belirler. Bireysel değerler yalnızca “Bireysel koşul belirle” ile düzenlenebilir. Mevcut özel anlaşmalar korunur; yeniden koşul seçmek ilgili tüm değerleri değiştirir.',
            },
        },
    },
    {
        id: 'custom-field-weekly-times',
        sequence: 175,
        version: '2026.11.1',
        publishedAt: '2026-11-01T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/admin/custom-fields',
        requiredAnyPermissions: [PERMISSIONS.CUSTOM_FIELDS_READ],
        commitRefs: ['custom-field-weekly-times'],
        translations: {
            de: {
                title: 'Wochentage und Zeiten als eigenes Zusatzfeld',
                description: 'Legen Sie eigene Zusatzfelder vom Typ „Wochentage & Zeiten“ an. Wählen Sie Tage sowie Von-/Bis-Zeiten und ergänzen Sie weitere Zeitfenster, etwa für Samstag oder eine Mittagspause. Es werden keine Beispielzeiten vorbelegt. Vorschau und freigegebene Belegausgaben zeigen die Zeiten verständlich in der jeweiligen Sprache.',
            },
            en: {
                title: 'Create your own weekday and time custom fields',
                description: 'Create custom fields of type “Weekdays & times”. Choose days and start/end times, then add windows for Saturday or a lunch break. No example hours are prefilled. Previews and permitted document outputs show readable times in the relevant language.',
            },
            fr: {
                title: 'Créer vos propres champs de jours et horaires',
                description: 'Créez des champs de type « Jours de semaine et horaires ». Choisissez les jours et les heures de début et de fin, puis ajoutez des créneaux pour le samedi ou une pause. Aucun exemple d’horaire n’est prérempli. Les aperçus et sorties autorisées affichent des horaires lisibles dans la langue concernée.',
            },
            es: {
                title: 'Crear campos propios de días y horarios',
                description: 'Cree campos de tipo «Días de la semana y horarios». Elija días y horas de inicio y fin, y añada franjas para el sábado o una pausa. No se rellenan horarios de ejemplo. Las vistas previas y salidas autorizadas muestran horarios legibles en el idioma correspondiente.',
            },
            tr: {
                title: 'Kendi gün ve saat ek alanlarınızı oluşturun',
                description: '“Haftanın günleri ve saatler” türünde ek alanlar oluşturun. Günleri ve başlangıç/bitiş saatlerini seçin; cumartesi veya öğle arası için yeni aralıklar ekleyin. Örnek saatler otomatik doldurulmaz. Önizlemeler ve izin verilen belge çıktıları saatleri ilgili dilde okunabilir gösterir.',
            },
        },
    },
    {
        id: 'address-contact',
        sequence: 176,
        version: '2026.11.1',
        publishedAt: '2026-11-01T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/partners/customers',
        requiredAnyPermissions: [PERMISSIONS.CUSTOMER_READ],
        commitRefs: ['address-contact'],
        translations: {
            de: {
                title: 'Eigene Ansprechpartner je Adresse erfassen',
                description: 'Abweichende Rechnungs-, Liefer- und sonstige Adressen können einen eigenen optionalen Ansprechpartner mit Name, Funktion, Telefon, Mobiltelefon und E-Mail erhalten. Die Angaben erscheinen nur bei dieser Adresse und erzeugen keinen allgemeinen Ansprechpartner. PDFs, Kundenportal und bestehende Belege bleiben unverändert.',
            },
            en: {
                title: 'Add a separate contact to each address',
                description: 'Additional billing, shipping and other addresses can have their own optional contact with a name, role, telephone, mobile and email. Details appear only within that address and do not create a general contact. PDFs, the customer portal and existing documents remain unchanged.',
            },
            fr: {
                title: 'Ajouter un contact propre à chaque adresse',
                description: 'Les adresses supplémentaires de facturation, de livraison ou autres peuvent avoir leur propre contact facultatif avec nom, fonction, téléphone, mobile et e-mail. Les coordonnées apparaissent uniquement dans cette adresse, sans créer de contact général. Les PDF, le portail client et les documents existants restent inchangés.',
            },
            es: {
                title: 'Añadir un contacto propio a cada dirección',
                description: 'Las direcciones adicionales de facturación, envío u otras pueden tener su propio contacto opcional con nombre, cargo, teléfono, móvil y correo electrónico. Los datos solo aparecen dentro de esa dirección y no crean un contacto general. Los PDF, el portal del cliente y los documentos existentes no cambian.',
            },
            tr: {
                title: 'Her adrese ayrı bir ilgili kişi ekleyin',
                description: 'Ek fatura, teslimat ve diğer adreslere ad, görev, telefon, cep telefonu ve e-posta içeren isteğe bağlı bir ilgili kişi eklenebilir. Bilgiler yalnızca o adreste gösterilir ve genel kişi kaydı oluşturmaz. PDF’ler, müşteri portalı ve mevcut belgeler değişmez.',
            },
        },
    },
    {
        id: 'document-recipient-selection',
        sequence: 177,
        version: '2026.11.1',
        publishedAt: '2026-11-01T00:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/documents',
        requiredAnyPermissions: [PERMISSIONS.DOCUMENT_SEND],
        commitRefs: ['document-recipient-selection'],
        translations: {
            de: {
                title: 'Belegempfänger auswählen und erneut senden',
                description: 'Beim Belegversand lassen sich mehrere Empfänger anhand von Name, E-Mail und Zuständigkeit auswählen. Empfehlungen berücksichtigen die Belegart; ein Hauptempfänger und bis zu fünf Kopien sowie manuelle Eingaben sind möglich. Jeder erneute Versand wird bewusst ausgelöst und protokolliert; frühere Versandprotokolle bleiben erhalten.',
            },
            en: {
                title: 'Select document recipients and send again',
                description: 'Select several document recipients by name, email and responsibility. Recommendations reflect the document type; use one main recipient and up to five copies, with manual entries still available. Each resend requires an explicit action and is logged separately; previous delivery logs are preserved.',
            },
            fr: {
                title: 'Choisir les destinataires et renvoyer un document',
                description: 'Choisissez plusieurs destinataires par nom, e-mail et responsabilité. Les recommandations tiennent compte du type de document ; un destinataire principal et jusqu’à cinq copies sont possibles, avec saisie manuelle conservée. Chaque renvoi est déclenché explicitement et consigné séparément ; les journaux précédents sont conservés.',
            },
            es: {
                title: 'Seleccionar destinatarios y volver a enviar documentos',
                description: 'Seleccione varios destinatarios por nombre, correo y responsabilidad. Las recomendaciones consideran el tipo de documento; puede usar un destinatario principal y hasta cinco copias, conservando la entrada manual. Cada reenvío requiere una acción expresa y se registra por separado; se conservan los registros anteriores.',
            },
            tr: {
                title: 'Belge alıcılarını seçin ve yeniden gönderin',
                description: 'Belge alıcılarını ad, e-posta ve sorumluluğa göre birden fazla seçin. Öneriler belge türünü dikkate alır; bir ana alıcı ve en fazla beş bilgi alıcısı kullanılabilir, elle giriş korunur. Her yeniden gönderim açıkça başlatılır ve ayrı kaydedilir; önceki gönderim kayıtları korunur.',
            },
        },
    },
    {
        id: 'customer-siren-siret',
        sequence: 178,
        version: '2026.11.1',
        publishedAt: '2026-11-01T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/partners/customers',
        requiredAnyPermissions: [PERMISSIONS.CUSTOMER_READ],
        commitRefs: ['customer-siren-siret'],
        translations: {
            de: {
                title: 'SIREN und SIRET als eigene Kundenfelder',
                description: 'SIREN und SIRET stehen als eigene optionale Kundenfelder mit Format- und Zusammenhangsprüfung bereit. Suche, Import und Export unterstützen beide Kennungen. Eindeutige gültige Altwerte werden einmalig aus Zusatzfeldern übernommen; Originale und bereits gepflegte Werte bleiben erhalten. Die Kennungen bleiben intern.',
            },
            en: {
                title: 'Dedicated SIREN and SIRET customer fields',
                description: 'SIREN and SIRET are dedicated optional customer fields with format and consistency checks. Search, import and export support both identifiers. Unambiguous valid existing values are copied once from custom fields; originals and already maintained values are preserved. The identifiers remain internal.',
            },
            fr: {
                title: 'Des champs SIREN et SIRET dédiés aux clients',
                description: 'Le SIREN et le SIRET disposent de champs client dédiés et facultatifs avec contrôle de format et de cohérence. Recherche, import et export prennent en charge les deux identifiants. Les anciennes valeurs valides et non ambiguës sont reprises une seule fois des champs personnalisés ; originaux et valeurs déjà renseignées sont conservés. Les identifiants restent internes.',
            },
            es: {
                title: 'Campos SIREN y SIRET propios del cliente',
                description: 'SIREN y SIRET son campos propios y opcionales del cliente con comprobación de formato y coherencia. La búsqueda, importación y exportación admiten ambos identificadores. Los valores antiguos válidos e inequívocos se copian una sola vez desde los campos personalizados; se conservan los originales y los valores ya registrados. Los identificadores siguen siendo internos.',
            },
            tr: {
                title: 'Müşteriye özel SIREN ve SIRET alanları',
                description: 'SIREN ve SIRET, biçim ve tutarlılık kontrolü olan ayrı ve isteğe bağlı müşteri alanlarıdır. Arama, içe ve dışa aktarma her iki kimlik numarasını destekler. Mevcut geçerli ve açık değerler ek alanlardan bir kez aktarılır; özgün ve önceden girilmiş değerler korunur. Kimlik numaraları dahili kalır.',
            },
        },
    },
    {
        id: 'pdf-carton-pallet-piece-prices',
        sequence: 179,
        version: '2026.11.1',
        publishedAt: '2026-11-01T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/documents',
        requiredAnyPermissions: [PERMISSIONS.DOCUMENT_READ],
        commitRefs: ['pdf-carton-pallet-piece-prices'],
        translations: {
            de: {
                title: 'Stückpreis auch im Karton- und Paletten-PDF',
                description: 'Das PDF zeigt den Stückpreis zusätzlich unter dem Gebindepreis. Grundlage sind die gespeicherten Positionspreise und Gebindefaktoren. Die Gebindeübersicht muss dafür nicht aktiviert sein; Preise und Belegsummen bleiben unverändert.',
            },
            en: {
                title: 'Piece prices in carton and pallet PDFs too',
                description: 'PDFs also show the price per piece below the pack price, using saved line prices and packaging factors. The packaging summary need not be enabled; prices and document totals stay unchanged.',
            },
            fr: {
                title: 'Le prix par pièce aussi dans les PDF de cartons et palettes',
                description: 'Le PDF affiche le prix par pièce sous le prix du conditionnement, à partir des prix de ligne et facteurs enregistrés. Le récapitulatif des conditionnements peut rester désactivé ; les prix et les totaux ne changent pas.',
            },
            es: {
                title: 'Precio por unidad también en PDF de cajas y palés',
                description: 'El PDF muestra el precio por unidad debajo del precio del embalaje a partir de los precios de línea y factores guardados. No es necesario activar el resumen de embalajes; los precios y los totales no cambian.',
            },
            tr: {
                title: 'Koli ve palet PDF’lerinde de adet fiyatı',
                description: 'PDF, kayıtlı satır fiyatı ve ambalaj katsayısına göre adet fiyatını ambalaj fiyatının altında gösterir. Ambalaj özetinin etkin olması gerekmez; fiyatlar ve belge toplamları değişmez.',
            },
        },
    },
    {
        id: 'quote-pdf-payment-delivery-terms',
        sequence: 180,
        version: '2026.11.1',
        publishedAt: '2026-11-01T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/documents',
        requiredAnyPermissions: [PERMISSIONS.DOCUMENT_READ],
        commitRefs: ['quote-pdf-payment-delivery-terms'],
        translations: {
            de: {
                title: 'Zahlungs- und Lieferbedingungen im Angebots-PDF',
                description: 'Das Angebots-PDF zeigt die im Beleg gespeicherten Zahlungs- und Lieferbedingungen. Ihre gespeicherte Zahlungsbezeichnung bleibt erhalten; bestehende Ausblendungen im PDF-Designer werden berücksichtigt.',
            },
            en: {
                title: 'Payment and delivery terms in quote PDFs',
                description: 'Quote PDFs show payment and delivery terms saved in the document. The saved payment label is retained and existing PDF designer visibility settings are respected.',
            },
            fr: {
                title: 'Conditions de paiement et de livraison dans les devis PDF',
                description: 'Les devis PDF affichent les conditions de paiement et de livraison enregistrées dans le document. Le libellé de paiement enregistré et les réglages de visibilité du concepteur PDF sont respectés.',
            },
            es: {
                title: 'Condiciones de pago y entrega en presupuestos PDF',
                description: 'Los presupuestos PDF muestran las condiciones de pago y entrega guardadas en el documento. Se conservan la etiqueta de pago guardada y los ajustes de visibilidad del diseñador PDF.',
            },
            tr: {
                title: 'Teklif PDF’lerinde ödeme ve teslimat koşulları',
                description: 'Teklif PDF’leri belgede kayıtlı ödeme ve teslimat koşullarını gösterir. Kayıtlı ödeme etiketi korunur ve PDF tasarımcısının görünürlük ayarlarına uyulur.',
            },
        },
    },
    {
        id: 'pdf-custom-field-grid',
        sequence: 181,
        version: '2026.11.1',
        publishedAt: '2026-11-01T00:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/documents',
        requiredAnyPermissions: [PERMISSIONS.DOCUMENT_READ],
        commitRefs: ['pdf-custom-field-grid'],
        translations: {
            de: {
                title: 'Zusatzfelder im PDF kompakt nebeneinander',
                description: 'Automatische Zusatzfelder im Belegkopf erscheinen in drei Spalten und weiteren Zeilen. Langtexte behalten die volle Breite; individuelle Platzierungen und Sichtbarkeitseinstellungen bleiben erhalten.',
            },
            en: {
                title: 'Compact custom field columns in PDFs',
                description: 'Automatic header custom fields appear in three columns and further rows. Long text keeps the full width, and individual placements and visibility settings are retained.',
            },
            fr: {
                title: 'Champs personnalisés en colonnes dans les PDF',
                description: 'Les champs personnalisés automatiques de l’en-tête apparaissent en trois colonnes et plusieurs lignes. Les textes longs conservent toute la largeur ; les placements et réglages de visibilité individuels sont préservés.',
            },
            es: {
                title: 'Campos personalizados en columnas en los PDF',
                description: 'Los campos personalizados automáticos de la cabecera aparecen en tres columnas y varias filas. Los textos largos conservan todo el ancho y se mantienen las posiciones y la visibilidad individuales.',
            },
            tr: {
                title: 'PDF’lerde kompakt özel alan sütunları',
                description: 'Başlıktaki otomatik özel alanlar üç sütun ve yeni satırlarda gösterilir. Uzun metinler tam genişliği korur; ayrı konum ve görünürlük ayarları korunur.',
            },
        },
    },
    {
        id: 'document-validation-focus-after-save',
        sequence: 182,
        version: '2026.11.1',
        publishedAt: '2026-11-01T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/documents',
        requiredAnyPermissions: [PERMISSIONS.DOCUMENT_READ],
        commitRefs: ['document-validation-focus-after-save'],
        translations: {
            de: {
                title: 'Fehlerhafte Belegfelder zuverlässig erreichen',
                description: 'Nach einem Validierungsfehler beim Speichern erhält das erste betroffene Feld den Fokus, sobald die Eingaben wieder bedienbar sind. Ihre bisherigen Eingaben bleiben erhalten.',
            },
            en: {
                title: 'Reach invalid document fields reliably',
                description: 'If saving returns a validation error, the first affected field receives focus as soon as editing is available again. Your entries are retained.',
            },
            fr: {
                title: 'Accéder aux champs de document incorrects',
                description: 'Si l’enregistrement renvoie une erreur de validation, le premier champ concerné reçoit le focus dès que la saisie est de nouveau possible. Vos saisies sont conservées.',
            },
            es: {
                title: 'Acceder a los campos de documento incorrectos',
                description: 'Si al guardar se devuelve un error de validación, el primer campo afectado recibe el foco en cuanto se puede volver a editar. Se conservan los datos introducidos.',
            },
            tr: {
                title: 'Hatalı belge alanlarına güvenilir erişim',
                description: 'Kaydetme sırasında doğrulama hatası oluşursa, düzenleme yeniden kullanılabilir olduğunda ilk ilgili alana odaklanılır. Girdiğiniz bilgiler korunur.',
            },
        },
    },
    {
        id: 'warehouse-stock-valuation-overview',
        sequence: 183,
        version: '2026.11.1',
        publishedAt: '2026-11-01T18:00:00.000Z',
        category: 'NEW',
        linkUrl: '/inventory/overview',
        requiredAnyPermissions: ['inventory:read'],
        commitRefs: ['warehouse-stock-valuation-overview'],
        translations: {
            de: {
                title: 'Lagerübersicht mit Bestandswerten',
                description: 'Prüfen Sie aktuelle Bestände je Artikel, Charge, Lagerplatz und Bestandsart mit operativen Werten je Währung. Suche, Filter, CSV-Export und Hinweise auf fehlende Preise helfen bei der Kontrolle. Vorhandene lesbare Palettenangaben bleiben der Charge zugeordnet.',
            },
            en: {
                title: 'Warehouse overview with stock values',
                description: 'Review current stock by product, batch, location and stock type with operational values per currency. Search, filters, CSV export and missing-price notes support checks. Existing readable pallet references remain linked to their batch.',
            },
            fr: {
                title: 'Vue du stock avec valeurs',
                description: 'Consultez le stock actuel par article, lot, emplacement et type avec les valeurs opérationnelles par devise. Recherche, filtres, export CSV et prix manquants facilitent le contrôle. Les références de palette lisibles restent liées au lot.',
            },
            es: {
                title: 'Resumen de almacén con valores',
                description: 'Consulte existencias actuales por artículo, lote, ubicación y tipo, con valores operativos por divisa. Búsqueda, filtros, exportación CSV y avisos de precios ausentes facilitan la revisión. Las referencias legibles de palé siguen vinculadas al lote.',
            },
            tr: {
                title: 'Stok değerleriyle depo özeti',
                description: 'Ürün, parti, konum ve stok türüne göre güncel stokları para birimi bazında operasyonel değerlerle inceleyin. Arama, filtreler, CSV dışa aktarma ve eksik fiyat notları kontrolü kolaylaştırır. Okunabilir palet referansları partiye bağlı kalır.',
            },
        },
    },
    {
        id: 'controlled-price-calculation',
        sequence: 184,
        version: '2026.11.1',
        publishedAt: '2026-11-01T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/products/pricing',
        requiredAnyPermissions: ['pricing:read'],
        commitRefs: ['controlled-price-calculation'],
        translations: {
            de: {
                title: 'Verkaufspreise aus Kosten kalkulieren und freigeben',
                description: 'Erstellen Sie eigene Kalkulationsvorlagen mit zentralen Werten, Zuschlägen und Margenzielen. Vergleichen Sie unabhängige Gruppenpreise in Szenarien und geben Sie geprüfte Preise mit Gültigkeitszeitraum frei. Bestehende Belegpreise bleiben erhalten.',
            },
            en: {
                title: 'Calculate and approve selling prices from costs',
                description: 'Build reusable calculation templates with central values, adjustments and margin targets. Compare independent group prices in scenarios and approve reviewed prices for a validity period. Existing document prices are retained.',
            },
            fr: {
                title: 'Calculer et approuver les prix de vente à partir des coûts',
                description: 'Créez des modèles réutilisables avec valeurs centrales, ajustements et marges cibles. Comparez les prix de groupe indépendants dans des scénarios et approuvez les prix contrôlés pour une période. Les prix des documents existants sont conservés.',
            },
            es: {
                title: 'Calcular y aprobar precios de venta a partir de costes',
                description: 'Cree plantillas reutilizables con valores centrales, ajustes y márgenes objetivo. Compare precios independientes de grupos en escenarios y apruebe precios revisados para un período. Se conservan los precios de documentos existentes.',
            },
            tr: {
                title: 'Maliyetlerden satış fiyatı hesaplayın ve onaylayın',
                description: 'Merkezi değerler, düzeltmeler ve marj hedefleriyle yeniden kullanılabilir şablonlar oluşturun. Bağımsız grup fiyatlarını senaryolarda karşılaştırıp incelenen fiyatları belirli dönemler için onaylayın. Mevcut belge fiyatları korunur.',
            },
        },
    },
    {
        id: 'focused-sidebar-navigation',
        sequence: 185,
        version: '2026.11.18',
        publishedAt: '2026-11-02T00:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/',
        requiredAnyPermissions: [],
        commitRefs: ['focused-sidebar-navigation'],
        translations: {
            de: {
                title: 'Übersichtlichere linke Navigation',
                description: 'Nur die aktive oder ausgewählte Menügruppe bleibt geöffnet. Beim Wechsel schließt sich die vorherige automatisch, auch auf Mobilgeräten.',
            },
            en: {
                title: 'Clearer sidebar navigation',
                description: 'Only the active or selected group stays expanded. Switching groups automatically closes the previous one, including on mobile devices.',
            },
            fr: {
                title: 'Navigation latérale plus claire',
                description: 'Seul le groupe actif ou sélectionné reste développé. Changer de groupe réduit automatiquement le précédent, également sur mobile.',
            },
            es: {
                title: 'Navegación lateral más clara',
                description: 'Solo permanece expandido el grupo activo o seleccionado. Cambiar de grupo contrae automáticamente el anterior, también en móviles.',
            },
            tr: {
                title: 'Daha düzenli sol gezinme',
                description: 'Yalnızca etkin veya seçili grup açık kalır. Grup değiştiğinde önceki otomatik kapanır; bu mobil cihazlarda da geçerlidir.',
            },
        },
    },
    {
        id: 'crm-recent-actions',
        sequence: 186,
        version: '2026.11.19',
        publishedAt: '2026-11-02T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/crm/recent-actions',
        requiredAnyPermissions: ['settings:write'],
        commitRefs: ['crm-recent-actions'],
        translations: {
            de: {
                title: 'Letzte CRM-Aktionen nachvollziehen',
                description: 'Inhaber und Administratoren sehen Mitarbeiter, Zeitpunkt und betroffene CRM-Datensätze. Filter und CSV verwenden dieselben Zugriffsregeln; private Inhalte bleiben geschützt.',
            },
            en: {
                title: 'Follow recent CRM actions',
                description: 'Owners and administrators see the editor, time and affected CRM records. Filters and CSV use the same access rules; private content remains protected.',
            },
            fr: {
                title: 'Suivre les dernières actions CRM',
                description: 'Propriétaires et administrateurs consultent auteur, date et données CRM concernées. Filtres et CSV respectent les mêmes droits ; les contenus privés restent protégés.',
            },
            es: {
                title: 'Consultar las últimas acciones del CRM',
                description: 'Propietarios y administradores ven autor, fecha y registros afectados. Los filtros y CSV aplican los mismos permisos; el contenido privado permanece protegido.',
            },
            tr: {
                title: 'Son CRM işlemlerini izleyin',
                description: 'İşyeri sahipleri ve yöneticiler düzenleyeni, zamanı ve etkilenen kayıtları görür. Filtreler ve CSV aynı erişim kurallarını kullanır; özel içerik korunur.',
            },
        },
    },
    {
        id: 'whatsapp-phone-chats-history',
        sequence: 187,
        version: '2026.11.20',
        publishedAt: '2026-11-02T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/whatsapp',
        requiredAnyPermissions: ['whatsapp:read'],
        commitRefs: ['whatsapp-phone-chats-history'],
        translations: {
            de: {
                title: 'Handy-Chats und WhatsApp-Verlauf',
                description: 'Am Handy begonnene Kundengespräche, Antworten und nachgelieferte Textnachrichten erscheinen im Kontochat. Der Verlauf lässt sich auch über eine bestehende QR-Sitzung anfordern und abschnittsweise nachladen.',
            },
            en: {
                title: 'Phone chats and WhatsApp history',
                description: 'Customer conversations started on the phone, replies and delayed texts appear in the account chat. History can also be requested through an existing QR session and loaded in batches.',
            },
            fr: {
                title: 'Conversations mobiles et historique WhatsApp',
                description: 'Les conversations clients commencées sur le téléphone, réponses et textes différés apparaissent dans le compte. L’historique peut aussi être demandé depuis une session QR existante et chargé par lots.',
            },
            es: {
                title: 'Conversaciones móviles e historial WhatsApp',
                description: 'Las conversaciones iniciadas en el móvil, respuestas y textos retrasados aparecen en el chat de la cuenta. El historial también puede solicitarse desde una sesión QR existente y cargarse por lotes.',
            },
            tr: {
                title: 'Telefon sohbetleri ve WhatsApp geçmişi',
                description: 'Telefonda başlayan müşteri sohbetleri, yanıtlar ve gecikmiş metinler hesap sohbetinde görünür. Geçmiş mevcut QR oturumundan da istenebilir ve bölümler halinde yüklenir.',
            },
        },
    },
    {
        id: 'product-decimal-input-preservation',
        sequence: 188,
        version: '2026.11.21',
        publishedAt: '2026-11-02T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/products',
        requiredAnyPermissions: ['product:write'],
        commitRefs: ['product-decimal-input-preservation'],
        translations: {
            de: {
                title: 'Zahlen im Artikel einfach eingeben',
                description: 'Preise, Mengen und Gewichte akzeptieren Punkt und Komma. Auch 47, oder 47. wird richtig übernommen. Ungültige Eingaben bleiben zur Korrektur im geöffneten Formular erhalten.',
            },
            en: {
                title: 'Easier decimal entry for products',
                description: 'Prices, quantities and weights accept a point or comma. Even 47, or 47. is handled correctly. Invalid entries stay in the open form for correction.',
            },
            fr: {
                title: 'Saisir les décimales plus simplement',
                description: 'Prix, quantités et poids acceptent point ou virgule. Même 47, ou 47. est repris correctement. Les saisies invalides restent dans le formulaire ouvert pour correction.',
            },
            es: {
                title: 'Introducir decimales más fácilmente',
                description: 'Precios, cantidades y pesos admiten punto o coma. Incluso 47, o 47. se interpreta correctamente. Las entradas incorrectas permanecen en el formulario abierto para corregirlas.',
            },
            tr: {
                title: 'Ürünlerde kolay ondalık girişi',
                description: 'Fiyat, miktar ve ağırlıklar nokta veya virgül kabul eder. 47, veya 47. bile doğru aktarılır. Geçersiz girdiler düzeltme için açık formda korunur.',
            },
        },
    },
    {
        id: 'document-draft-delete-close',
        sequence: 189,
        version: '2026.11.22',
        publishedAt: '2026-11-02T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/documents',
        requiredAnyPermissions: ['document:write'],
        commitRefs: ['document-draft-delete-close'],
        translations: {
            de: {
                title: 'Gelöschte Entwürfe schließen zuverlässig',
                description: 'Nach dem bestätigten Löschen eines Angebotsentwurfs geht es zurück zur Übersicht oder Kundenakte. Die erfolgreiche Löschung löst keinen Formatfehler und keine weitere Verwerfen-Rückfrage aus.',
            },
            en: {
                title: 'Deleted drafts close reliably',
                description: 'After confirming quote draft deletion, return to the list or customer record. Successful deletion causes no format error or additional discard prompt.',
            },
            fr: {
                title: 'Fermeture fiable des brouillons supprimés',
                description: 'Après suppression confirmée d’un devis brouillon, revenez à la liste ou au dossier client. Aucun faux défaut de format ni nouvelle confirmation d’abandon n’apparaît.',
            },
            es: {
                title: 'Cierre fiable de borradores eliminados',
                description: 'Tras confirmar la eliminación del presupuesto borrador, vuelva a la lista o ficha del cliente. No aparecen falsos errores de formato ni otra confirmación de descarte.',
            },
            tr: {
                title: 'Silinen taslaklar güvenilir şekilde kapanır',
                description: 'Teklif taslağının silinmesini onayladıktan sonra listeye veya müşteri kaydına dönülür. Başarılı silme, biçim hatası ya da ikinci bir vazgeçme onayı oluşturmaz.',
            },
        },
    },
    {
        id: 'global-search-select-previous-query',
        sequence: 190,
        version: '2026.11.23',
        publishedAt: '2026-11-02T00:00:00.000Z',
        category: 'IMPROVED',
        linkUrl: '/?openSearch=1',
        requiredAnyPermissions: ['global_search:use'],
        commitRefs: ['global-search-select-previous-query'],
        translations: {
            de: {
                title: 'Neue Suche direkt lostippen',
                description: 'Beim erneuten Öffnen der globalen Suche ist der bisherige Text markiert. Tippen Sie einfach den neuen Begriff – er ersetzt den vorherigen.',
            },
            en: {
                title: 'Start a new search immediately',
                description: 'Reopening global search selects the previous text. Simply type a new term to replace it.',
            },
            fr: {
                title: 'Lancer une nouvelle recherche directement',
                description: 'Rouvrir la recherche globale sélectionne le texte précédent. Saisissez simplement un nouveau terme pour le remplacer.',
            },
            es: {
                title: 'Empezar una nueva búsqueda directamente',
                description: 'Al reabrir la búsqueda global se selecciona el texto anterior. Escriba el nuevo término para reemplazarlo.',
            },
            tr: {
                title: 'Yeni aramaya doğrudan başlayın',
                description: 'Genel arama yeniden açıldığında önceki metin seçilir. Yeni terimi yazarak doğrudan değiştirebilirsiniz.',
            },
        },
    },
    {
        id: 'product-copy-with-required-new-number',
        sequence: 191,
        version: '2026.11.24',
        publishedAt: '2026-11-02T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/products',
        requiredAnyPermissions: ['product:write'],
        commitRefs: ['product-copy-with-required-new-number'],
        translations: {
            de: {
                title: 'Artikel mit neuer Nummer duplizieren',
                description: 'Im Artikel öffnet Duplizieren eine bearbeitbare Kopie mit Stammdaten, allgemeinen Staffelpreisen und Gebinden. Eine andere, eindeutige Artikelnummer ist Pflicht; Bestände und Chargen bleiben beim Original.',
            },
            en: {
                title: 'Duplicate products with a new number',
                description: 'Duplicate opens an editable product copy with master data, general quantity prices and packaging. A different, unique article number is required; stock and batches stay with the original.',
            },
            fr: {
                title: 'Dupliquer un article avec un nouveau numéro',
                description: 'Dupliquer ouvre une copie modifiable avec données de base, tarifs généraux par quantité et conditionnements. Un numéro différent et unique est obligatoire ; stocks et lots restent liés à l’original.',
            },
            es: {
                title: 'Duplicar artículos con número nuevo',
                description: 'Duplicar abre una copia editable con datos maestros, precios generales por cantidad y embalajes. Se exige otro número único; existencias y lotes permanecen en el original.',
            },
            tr: {
                title: 'Ürünleri yeni numarayla çoğaltın',
                description: 'Çoğalt, ana veriler, genel miktar fiyatları ve ambalajlarla düzenlenebilir kopya açar. Farklı ve benzersiz numara zorunludur; stok ve partiler asıl üründe kalır.',
            },
        },
    },
    {
        id: 'customer-prospect-master-data-copy',
        sequence: 192,
        version: '2026.11.25',
        publishedAt: '2026-11-02T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/partners',
        requiredAnyPermissions: ['customer:write'],
        commitRefs: ['customer-prospect-master-data-copy'],
        translations: {
            de: {
                title: 'Kunden und Interessenten duplizieren',
                description: 'Duplizieren in der Geschäftspartnerakte übernimmt Stammdaten und Konditionen in das Anlegeformular. Erst Speichern erstellt eine eigene Akte mit neuer Nummer; Historien, Zustimmungen, Portalzugänge und Finanzsalden werden nicht kopiert.',
            },
            en: {
                title: 'Duplicate customers and prospects',
                description: 'Duplicate in a partner record prefills master data and terms in the creation form. Saving creates a separate record with a new number; history, consent, portal access and financial balances are excluded.',
            },
            fr: {
                title: 'Dupliquer clients et prospects',
                description: 'Dupliquer reprend les données et conditions dans le formulaire de création. L’enregistrement crée un dossier avec un nouveau numéro ; historiques, consentements, accès portail et soldes sont exclus.',
            },
            es: {
                title: 'Duplicar clientes y prospectos',
                description: 'Duplicar rellena datos maestros y condiciones en el formulario de alta. Guardar crea otra ficha con número nuevo; historial, consentimientos, accesos al portal y saldos no se copian.',
            },
            tr: {
                title: 'Müşteri ve adayları çoğaltın',
                description: 'İş ortağında Çoğalt, oluşturma formuna ana verileri ve koşulları aktarır. Kaydet yeni numarayla ayrı kayıt oluşturur; geçmiş, izinler, portal erişimi ve mali bakiyeler kopyalanmaz.',
            },
        },
    },
    {
        id: 'invoice-copy-fresh-draft',
        sequence: 193,
        version: '2026.11.26',
        publishedAt: '2026-11-02T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/documents',
        requiredAnyPermissions: ['document:write'],
        commitRefs: ['invoice-copy-fresh-draft'],
        translations: {
            de: {
                title: 'Rechnungen als neue Entwürfe kopieren',
                description: 'Weitere Aktionen → Duplizieren öffnet eine bearbeitbare Rechnungskopie mit heutigem Datum. Erst Speichern vergibt eine neue Nummer. Zahlungen, Buchungen und Chargenzuordnungen werden nicht übernommen; das Original bleibt unverändert.',
            },
            en: {
                title: 'Copy invoices as new drafts',
                description: 'Additional actions → Duplicate opens an editable invoice copy dated today. Saving assigns a new number. Payments, journal entries and batch assignments are excluded; the original stays unchanged.',
            },
            fr: {
                title: 'Copier les factures comme nouveaux brouillons',
                description: 'Actions supplémentaires → Dupliquer ouvre une copie modifiable datée du jour. L’enregistrement attribue un nouveau numéro. Paiements, écritures et lots sont exclus ; l’original reste inchangé.',
            },
            es: {
                title: 'Copiar facturas como nuevos borradores',
                description: 'Acciones adicionales → Duplicar abre una copia editable con fecha de hoy. Guardar asigna otro número. Se excluyen pagos, asientos y lotes; el original no cambia.',
            },
            tr: {
                title: 'Faturaları yeni taslak olarak kopyalayın',
                description: 'Ek işlemler → Çoğalt, bugünün tarihiyle düzenlenebilir fatura kopyası açar. Kaydet yeni numara atar. Ödemeler, muhasebe kayıtları ve partiler aktarılmaz; asıl fatura değişmez.',
            },
        },
    },
    {
        id: 'document-number-on-create',
        sequence: 194,
        version: '2026.11.27',
        publishedAt: '2026-11-02T00:00:00.000Z',
        category: 'NEW',
        linkUrl: '/documents/new',
        requiredAnyPermissions: ['document:write'],
        commitRefs: ['document-number-on-create'],
        translations: {
            de: {
                title: 'Belegnummer beim Anlegen selbst eingeben',
                description: 'Neue Belege haben ein optionales Nummernfeld. Leer lassen für automatische Vergabe oder eine eigene eindeutige Nummer eingeben. Fehler erhalten den Entwurf; gespeicherte Nummern bleiben unverändert.',
            },
            en: {
                title: 'Enter a document number on creation',
                description: 'New documents have an optional number field. Leave it blank for automatic numbering or enter a unique custom number. Errors retain the draft; saved numbers stay unchanged.',
            },
            fr: {
                title: 'Saisir le numéro à la création',
                description: 'Les nouveaux documents proposent un numéro facultatif. Laissez vide pour une attribution automatique ou saisissez un numéro unique. Les erreurs conservent le brouillon ; les numéros enregistrés restent fixes.',
            },
            es: {
                title: 'Elegir el número al crear documentos',
                description: 'Los documentos nuevos incluyen un número opcional. Deje vacío para numeración automática o introduzca otro único. Los errores conservan el borrador; los números guardados no cambian.',
            },
            tr: {
                title: 'Oluştururken belge numarası girin',
                description: 'Yeni belgelerde isteğe bağlı numara alanı bulunur. Otomatik atama için boş bırakın veya benzersiz numara girin. Hatalarda taslak korunur; kaydedilen numaralar değişmez.',
            },
        },
    },
    {
        id: 'net-payment-days-with-protected-discounts',
        sequence: 195,
        version: '2026.11.28',
        publishedAt: '2026-11-03T00:00:00.000Z',
        category: 'FIXED',
        linkUrl: '/partners',
        requiredAnyPermissions: ['customer:write'],
        commitRefs: ['preserve-net-payment-day-editing'],
        translations: {
            de: {
                title: 'Zahlungsziel mit geschützten Rabatten bearbeiten',
                description: 'Mitarbeiter mit Kundenbearbeitungsrecht können das Zahlungsziel weiterhin individuell anpassen. Preisgruppen, Rabatte und Skonto bleiben ohne gesondertes Preisänderungsrecht geschützt.',
            },
            en: {
                title: 'Edit net payment days with protected discounts',
                description: 'Employees allowed to edit customers can still adjust net payment days individually. Price groups, discounts and cash discounts remain protected unless separate pricing permission is granted.',
            },
            fr: {
                title: 'Modifier le délai de paiement sans changer les remises',
                description: 'Les collaborateurs autorisés à modifier les clients peuvent toujours adapter le délai de paiement. Les groupes de prix, remises et escomptes restent protégés sans droit distinct de modification des prix.',
            },
            es: {
                title: 'Editar el plazo de pago con descuentos protegidos',
                description: 'Los empleados autorizados a editar clientes pueden seguir ajustando el plazo de pago. Los grupos de precios, descuentos y pronto pago permanecen protegidos sin permiso independiente para cambiar precios.',
            },
            tr: {
                title: 'İndirimler korunurken ödeme vadesini düzenleyin',
                description: 'Müşteri düzenleme yetkisi olan çalışanlar ödeme vadesini ayrıca değiştirebilir. Fiyat grupları, indirimler ve erken ödeme indirimleri ayrı fiyat değiştirme yetkisi olmadan korunur.',
            },
        },
    },
];
//# sourceMappingURL=product-news.js.map